import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ChangeDetectionStrategy, Input, Output, ViewChild, NgModule, Inject, ANALYZE_FOR_ENTRY_COMPONENTS, ViewContainerRef } from '@angular/core';
import * as i2 from '@play/common';
import { CommonsModule, CommonsLoadingModule, CommonsErrorModule, CommonsLocationModule, CommonsComponentModule, CommonsDateModule, BASE_CONFIG, RestrictionTransformerService, RestrictionFilterService, PlayCountryNames, CommonsFormModule, CommonsCountryNameModule, CommonsRestrictionsModule } from '@play/common';
import { isRosterEnabled, isTeam, isPlayer, isSignUpEnabled, isInProgress, isLeagueBanEnabled } from '@play/utility/league';
import { find, map, filter as filter$1, sortBy, forEach, orderBy } from 'lodash';
import * as i6 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i2$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@play/translate';
import { TranslationModule } from '@play/translate';
import * as i3 from '@play/api-client';
import * as i2$2 from '@play/player';
import { PlayerModule } from '@play/player';
import { map as map$1, distinctUntilChanged, tap, switchMap, filter, take, withLatestFrom, first, startWith, mergeMap, skip, takeUntil } from 'rxjs/operators';
import * as i1$1 from '@ngrx/store';
import { StoreModule } from '@ngrx/store';
import { getUser, getGameAccountDescriptions, getGameAccountProviders, getUserPremium, LoadLeagueOnceAction, getLeague, LoadPlayerOnceAction, getPlayer, LoadLeagueRestrictionsOnceAction, getLeagueRestrictions, LoadGameaccountOnceAction, getGameaccounts, exists, LoadLeaguesOnceAction, getLeagues, entryAvailable, getUserTeams, LoadParticipantsOnceAction, getLeagueParticipants, getContestant, type, queueReducers, distinct, getContestants, getTeam, LoadContestantsOnceAction, LoadTeamOnceAction, LoadRosterOnceAction, getRoster, LoadContestantsAction, LoadMembersOnceAction, getTeamMembers, RemoveMemberFromRosterAction, AddMemberToRosterAction, LoadRosterAction as LoadRosterAction$1, LoadLeagueRestrictionsAction, LoadUserTeamsCompleteAction, LeaveRosterAction, SelectRosterAction, LeaveLeagueAction, StateModule } from '@play/state';
import { combineLatest, of, BehaviorSubject, merge, interval, Observable, Subject } from 'rxjs';
import { getCheckedIn } from '@play/utility/participant';
import { isFinished } from '@play/utility/contestant';
import { Map } from 'immutable';
import * as momentImported from 'moment';
import { __decorate, __metadata, __awaiter } from 'tslib';
import * as i1$3 from '@ngrx/effects';
import { ofType, Effect, EffectsModule } from '@ngrx/effects';
import * as i1$2 from '@play/cache';
import { Cache, CacheModule } from '@play/cache';
import { isLeader } from '@play/utility/team';

const restrictionFails = (restriction) => !restriction.passed;
class EligiblityService {
    constructor(transformer) {
        this.transformer = transformer;
    }
    isEligible(league, restrictions, selectedContestant, roster) {
        let transformedRestrictions = restrictions;
        if (isRosterEnabled(league)) {
            transformedRestrictions = this.transformer.teamRestrictionsToRoster(roster, transformedRestrictions);
        }
        const passesRestrictions = transformedRestrictions.filter(restrictionFails).length === 0;
        return passesRestrictions && !selectedContestant.isBarred;
    }
}
EligiblityService.ɵfac = function EligiblityService_Factory(t) { return new (t || EligiblityService)(i0.ɵɵinject(i2.RestrictionTransformerService)); };
EligiblityService.ɵprov = i0.ɵɵdefineInjectable({ token: EligiblityService, factory: EligiblityService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EligiblityService, [{
        type: Injectable
    }], function () { return [{ type: i2.RestrictionTransformerService }]; }, null); })();

class GameAccountBuilder {
    /**
     * Build game account object.
     *
     * @param restrictions
     * @param descriptions
     * @param gameAccountTypes
     * @param statuses
     */
    buildGameAccounts(restrictions, descriptions, gameAccountTypes, statuses) {
        return restrictions.map(restriction => {
            const type = restriction.params.type;
            const gameAccountType = find(gameAccountTypes, gaType => gaType.type === type);
            const status = find(statuses, stati => (stati && stati.type) === type);
            const description = find(descriptions, desc => desc && desc.type === type);
            const idProvider = gameAccountType ? gameAccountType.idProvider : "";
            const value = status ? status.value : "";
            const readOnly = gameAccountType ? gameAccountType.readOnly : false;
            return {
                type: type,
                description: description,
                idProvider: idProvider,
                value: value,
                readOnly: readOnly,
            };
        });
    }
}
GameAccountBuilder.ɵfac = function GameAccountBuilder_Factory(t) { return new (t || GameAccountBuilder)(); };
GameAccountBuilder.ɵprov = i0.ɵɵdefineInjectable({ token: GameAccountBuilder, factory: GameAccountBuilder.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GameAccountBuilder, [{
        type: Injectable
    }], null, null); })();

function ConfirmActionComponent_label_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 2);
    i0.ɵɵelementStart(1, "input", 3);
    i0.ɵɵlistener("ngModelChange", function ConfirmActionComponent_label_6_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.customConfirmed = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 4);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngModel", ctx_r0.customConfirmed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind1(3, 2, "signup-contestant:confirm-" + ctx_r0.customCheckbox), i0.ɵɵsanitizeHtml);
} }
function ConfirmActionComponent_loading_spinner_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner", 11);
} }
function ConfirmActionComponent_inline_error_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.error, " ");
} }
const _c0$m = function (a0, a1) { return { "c-button--destructive": a0, "c-button--primary": a1 }; };
const _c1$8 = ["*"];
class ConfirmActionComponent {
    constructor() {
        this.confirm = new EventEmitter();
        this.cancel = new EventEmitter();
        this.confirmed = false;
        this.customConfirmed = false;
    }
}
ConfirmActionComponent.ɵfac = function ConfirmActionComponent_Factory(t) { return new (t || ConfirmActionComponent)(); };
ConfirmActionComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ConfirmActionComponent, selectors: [["confirm-action"]], inputs: { loading: "loading", customCheckbox: "customCheckbox", error: "error", checkboxLabel: ["checkbox", "checkboxLabel"], buttonLabel: ["button", "buttonLabel"], destructive: "destructive" }, outputs: { confirm: "confirm", cancel: "cancel" }, ngContentSelectors: _c1$8, decls: 15, vars: 14, consts: [[1, "c-confirm-action"], [1, "c-confirm-action__description"], [1, "c-confirm-action__confirm", "c-described-checkbox"], ["type", "checkbox", 1, "c-described-checkbox__checkbox", "c-confirm-action__confirm__checkbox", 3, "ngModel", "ngModelChange"], [1, "c-confirm-action__confirm__title", 3, "innerHtml"], ["class", "c-confirm-action__confirm c-described-checkbox", 4, "ngIf"], [1, "c-confirm-action__controls"], [1, "c-button", "c-button--big", "c-confirm-action__button", 3, "ngClass", "disabled", "click"], [1, "c-button--big", "c-button--secondary", 3, "clicked"], ["class", "c-confirm-action__spinner", 4, "ngIf"], ["class", "c-confirm-action__error", 4, "ngIf"], [1, "c-confirm-action__spinner"], [1, "c-confirm-action__error"]], template: function ConfirmActionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "label", 2);
        i0.ɵɵelementStart(4, "input", 3);
        i0.ɵɵlistener("ngModelChange", function ConfirmActionComponent_Template_input_ngModelChange_4_listener($event) { return ctx.confirmed = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, ConfirmActionComponent_label_6_Template, 4, 4, "label", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "button", 7);
        i0.ɵɵlistener("click", function ConfirmActionComponent_Template_button_click_8_listener() { return ctx.confirm.emit(); });
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "play-button", 8);
        i0.ɵɵlistener("clicked", function ConfirmActionComponent_Template_play_button_clicked_10_listener() { return ctx.cancel.emit(); });
        i0.ɵɵtext(11);
        i0.ɵɵpipe(12, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, ConfirmActionComponent_loading_spinner_13_Template, 1, 0, "loading-spinner", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(14, ConfirmActionComponent_inline_error_14_Template, 2, 1, "inline-error", 10);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngModel", ctx.confirmed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHtml", ctx.checkboxLabel, i0.ɵɵsanitizeHtml);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.customCheckbox);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c0$m, ctx.destructive, !ctx.destructive))("disabled", !ctx.customCheckbox && !ctx.confirmed || ctx.customCheckbox && (!ctx.customConfirmed || !ctx.confirmed) || ctx.loading);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.buttonLabel, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 9, "commons:cancel"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.error);
    } }, directives: [i6.CheckboxControlValueAccessor, i6.NgControlStatus, i6.NgModel, i2$1.NgIf, i2$1.NgClass, i2.ButtonComponent, i2.LoadingSpinnerComponent, i2.InlineErrorComponent], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmActionComponent, [{
        type: Component,
        args: [{
                selector: "confirm-action",
                templateUrl: "./confirm-action.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { loading: [{
            type: Input
        }], customCheckbox: [{
            type: Input
        }], error: [{
            type: Input
        }], checkboxLabel: [{
            type: Input,
            args: ["checkbox"]
        }], buttonLabel: [{
            type: Input,
            args: ["button"]
        }], destructive: [{
            type: Input,
            args: ["destructive"]
        }], confirm: [{
            type: Output
        }], cancel: [{
            type: Output
        }] }); })();

const _c0$l = ["copy"];
class TeamInviteComponent {
    constructor(teams, links) {
        this.teams = teams;
        this.links = links;
    }
    ngOnChanges() {
        this.link = this.links.joinTeamLink(+this.team.id, this.team.password);
    }
    copyLink() {
        const copyTextarea = this.copy.nativeElement;
        copyTextarea.select();
        document.execCommand("copy");
    }
    invitePlayer(email) {
        this.loading = true;
        this.error = false;
        this.success = false;
        this.teams
            .invitePlayerByEmailToTeam(+this.team.id, email)
            .toPromise()
            .then(() => {
            this.success = true;
        })
            .catch(() => {
            this.error = true;
        })
            .then(() => {
            this.loading = false;
        });
    }
}
TeamInviteComponent.ɵfac = function TeamInviteComponent_Factory(t) { return new (t || TeamInviteComponent)(i0.ɵɵdirectiveInject(i3.TeamResource), i0.ɵɵdirectiveInject(i2.LinkService)); };
TeamInviteComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TeamInviteComponent, selectors: [["team-invite"]], viewQuery: function TeamInviteComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$l, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.copy = _t.first);
    } }, inputs: { team: "team" }, features: [i0.ɵɵNgOnChangesFeature], decls: 15, vars: 10, consts: [[1, "c-team-invite"], [1, "c-team-invite__title"], [1, "c-team-invite__label-list"], [1, "c-team-invite__label"], [1, "c-team-invite__input-list"], [1, "c-team-invite__input"], ["name", "link", "type", "url", "readonly", "", 1, "c-team-invite__input__element", 3, "ngModel", "ngModelChange"], ["copy", ""], [1, "c-button--primary", 3, "clicked"]], template: function TeamInviteComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "h3", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵelementStart(5, "label", 3);
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 4);
        i0.ɵɵelementStart(9, "div", 5);
        i0.ɵɵelementStart(10, "input", 6, 7);
        i0.ɵɵlistener("ngModelChange", function TeamInviteComponent_Template_input_ngModelChange_10_listener($event) { return ctx.link = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "play-button", 8);
        i0.ɵɵlistener("clicked", function TeamInviteComponent_Template_play_button_clicked_12_listener() { return ctx.copyLink(); });
        i0.ɵɵtext(13);
        i0.ɵɵpipe(14, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "team-status-dialog:invite-players"));
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 6, "team-status-dialog:invite-link"));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngModel", ctx.link);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 8, "team-status-dialog:copy"), " ");
    } }, directives: [i6.DefaultValueAccessor, i6.NgControlStatus, i6.NgModel, i2.ButtonComponent], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TeamInviteComponent, [{
        type: Component,
        args: [{
                selector: "team-invite",
                templateUrl: "./team-invite.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i3.TeamResource }, { type: i2.LinkService }]; }, { copy: [{
            type: ViewChild,
            args: ["copy"]
        }], team: [{
            type: Input
        }] }); })();

class ComponentsModule {
}
ComponentsModule.ɵfac = function ComponentsModule_Factory(t) { return new (t || ComponentsModule)(); };
ComponentsModule.ɵmod = i0.ɵɵdefineNgModule({ type: ComponentsModule });
ComponentsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            TranslationModule,
            FormsModule,
            CommonModule,
            CommonsModule,
            CommonsLoadingModule,
            CommonsErrorModule,
            CommonsLocationModule,
            CommonsComponentModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ComponentsModule, { declarations: [ConfirmActionComponent, TeamInviteComponent], imports: [TranslationModule,
        FormsModule,
        CommonModule,
        CommonsModule,
        CommonsLoadingModule,
        CommonsErrorModule,
        CommonsLocationModule,
        CommonsComponentModule], exports: [ConfirmActionComponent, TeamInviteComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    TranslationModule,
                    FormsModule,
                    CommonModule,
                    CommonsModule,
                    CommonsLoadingModule,
                    CommonsErrorModule,
                    CommonsLocationModule,
                    CommonsComponentModule,
                ],
                exports: [ConfirmActionComponent, TeamInviteComponent],
                declarations: [ConfirmActionComponent, TeamInviteComponent],
            }]
    }], null, null); })();

class AgeRequirementFactory {
    constructor(translate, location) {
        this.translate = translate;
        this.location = location;
    }
    build(leagueId, restriction, user) {
        const requirement = {
            description: {
                text: this.translate.translate(`league-widget:requirement-${restriction.type}-description`, {
                    passed: restriction.passed ? 1 : 0,
                }),
            },
        };
        if (user.profile) {
            requirement.button = {
                label: this.translate.translate(`league-widget:requirement-${restriction.type}-button`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                action: () => this.location.go(`/player/edit/${user.profile.id}`),
            };
        }
        return requirement;
    }
}
AgeRequirementFactory.ɵfac = function AgeRequirementFactory_Factory(t) { return new (t || AgeRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.Location)); };
AgeRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: AgeRequirementFactory, factory: AgeRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AgeRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: i2.Location }]; }, null); })();

class ResidenceNationalityRequirementFactory {
    constructor(translate, location, ds) {
        this.translate = translate;
        this.location = location;
        this.ds = ds;
    }
    build(leagueId, restriction, user) {
        const requirement = {};
        if (user.profile) {
            requirement.button = {
                label: this.translate.translate(`league-widget:requirement-${restriction.type}-button`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                action: () => this.location.go(`/player/edit/${user.profile.id}`),
            };
        }
        if (!restriction.passed) {
            requirement.description = {
                text: this.translate.translate(`league-widget:requirement-${restriction.type}-description`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                action: this.ds.openRestrictionDialog.bind(this.ds, {}, restriction, true),
            };
        }
        return requirement;
    }
}
ResidenceNationalityRequirementFactory.ɵfac = function ResidenceNationalityRequirementFactory_Factory(t) { return new (t || ResidenceNationalityRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.Location), i0.ɵɵinject("DialogService")); };
ResidenceNationalityRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: ResidenceNationalityRequirementFactory, factory: ResidenceNationalityRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ResidenceNationalityRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: i2.Location }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }]; }, null); })();

class InCountryListRequirementFactory {
    constructor(translate, location, ds) {
        this.translate = translate;
        this.location = location;
        this.ds = ds;
    }
    build(leagueId, restriction, user) {
        const requirement = {};
        if (user.profile) {
            requirement.button = {
                label: this.translate.translate(`league-widget:requirement-${restriction.type}-button`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                action: () => this.location.go(`/player/edit/${user.profile.id}`),
            };
        }
        if (!restriction.passed) {
            requirement.description = {
                text: this.translate.translate(`league-widget:requirement-${restriction.type}-description`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                action: this.ds.openRestrictionDialog.bind(this.ds, {}, restriction, true),
            };
        }
        return requirement;
    }
}
InCountryListRequirementFactory.ɵfac = function InCountryListRequirementFactory_Factory(t) { return new (t || InCountryListRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.Location), i0.ɵɵinject("DialogService")); };
InCountryListRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: InCountryListRequirementFactory, factory: InCountryListRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InCountryListRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: i2.Location }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }]; }, null); })();

class AlternateLeagueRequirementFactory {
    constructor(translate, ds) {
        this.translate = translate;
        this.ds = ds;
    }
    build(leagueId, restriction, user) {
        if (user.profile) {
            return {
                button: {
                    label: this.translate.translate(`league-widget:requirement-${restriction.type}-button`, {
                        passed: restriction.passed ? 1 : 0,
                    }),
                    action: this.ds.openRestrictionDialog.bind(this.ds, {}, restriction, true),
                },
            };
        }
        return {};
    }
}
AlternateLeagueRequirementFactory.ɵfac = function AlternateLeagueRequirementFactory_Factory(t) { return new (t || AlternateLeagueRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject("DialogService")); };
AlternateLeagueRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: AlternateLeagueRequirementFactory, factory: AlternateLeagueRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AlternateLeagueRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }]; }, null); })();

class PremiumRequirementFactory {
    constructor(translate, location, formatter) {
        this.translate = translate;
        this.location = location;
        this.formatter = formatter;
    }
    build(leagueId, restriction, user) {
        const requirement = {
            description: {
                text: this.translate.translate(`league-widget:requirement-${restriction.type}-description`, {
                    passed: restriction.passed ? 1 : 0,
                    premiumUntil: restriction.passed
                        ? this.formatter.formatDate(user.premium ? user.premium.until : null, user.profile.timezone)
                        : null,
                }),
            },
        };
        if (user.profile) {
            requirement.button = {
                label: this.translate.translate(`league-widget:requirement-${restriction.type}-button`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                action: () => this.location.go(restriction.passed ? "/order" : "/premium"),
            };
        }
        return requirement;
    }
}
PremiumRequirementFactory.ɵfac = function PremiumRequirementFactory_Factory(t) { return new (t || PremiumRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.Location), i0.ɵɵinject(i2.FormatDate)); };
PremiumRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: PremiumRequirementFactory, factory: PremiumRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PremiumRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: i2.Location }, { type: i2.FormatDate }]; }, null); })();

class TrustLevelRequirementFactory {
    constructor(translate, formatter, location) {
        this.translate = translate;
        this.formatter = formatter;
        this.location = location;
    }
    build(leagueId, restriction, user) {
        const requirement = {
            description: {
                text: this.translate.translate(`league-widget:requirement-${restriction.type}-description`, {
                    passed: restriction.passed ? 1 : 0,
                    mintrustlevel: restriction.params.mintrustlevel,
                    trustedUntil: restriction.passed ? this.formatter.formatDate(user.profile.trustedUntil, user.profile.timezone) : null,
                }),
            },
        };
        if (user.profile) {
            requirement.button = {
                label: this.translate.translate(`league-widget:requirement-${restriction.type}-button`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                action: () => this.location.go("/playercard_portal"),
            };
        }
        return requirement;
    }
}
TrustLevelRequirementFactory.ɵfac = function TrustLevelRequirementFactory_Factory(t) { return new (t || TrustLevelRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.FormatDate), i0.ɵɵinject(i2.Location)); };
TrustLevelRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: TrustLevelRequirementFactory, factory: TrustLevelRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TrustLevelRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: i2.FormatDate }, { type: i2.Location }]; }, null); })();

class PhotoRequirementFactory {
    constructor(translate, location) {
        this.translate = translate;
        this.location = location;
    }
    build(leagueId, restriction, user) {
        const requirement = {
            description: {
                text: this.translate.translate(`league-widget:requirement-${restriction.type}-description`, {
                    passed: restriction.passed ? 1 : 0,
                }),
            },
        };
        if (user.profile) {
            requirement.button = {
                label: this.translate.translate(`league-widget:requirement-${restriction.type}-button`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                action: () => this.location.go(`/photo_upload/playerphotos/${user.profile.id}`),
            };
        }
        return requirement;
    }
}
PhotoRequirementFactory.ɵfac = function PhotoRequirementFactory_Factory(t) { return new (t || PhotoRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.Location)); };
PhotoRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: PhotoRequirementFactory, factory: PhotoRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PhotoRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: i2.Location }]; }, null); })();

class IsAdminRequirementFactory {
    constructor(translate, location) {
        this.translate = translate;
        this.location = location;
    }
    build(leagueId, restriction, user) {
        const requirement = {
            description: {
                text: this.translate.translate(`league-widget:requirement-${restriction.type}-description`, {
                    passed: restriction.passed ? 1 : 0,
                }),
            },
        };
        if (!restriction.passed && user.profile) {
            requirement.button = {
                label: this.translate.translate(`league-widget:requirement-${restriction.type}-button`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                action: () => this.location.go("/admin_application"),
            };
        }
        return requirement;
    }
}
IsAdminRequirementFactory.ɵfac = function IsAdminRequirementFactory_Factory(t) { return new (t || IsAdminRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.Location)); };
IsAdminRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: IsAdminRequirementFactory, factory: IsAdminRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IsAdminRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: i2.Location }]; }, null); })();

class GameAccountRequirementFactory {
    constructor(translate, ds, builder, location, link) {
        this.translate = translate;
        this.ds = ds;
        this.builder = builder;
        this.location = location;
        this.link = link;
    }
    build(leagueId, restriction, user) {
        const gameaccount = find(user.gameaccounts, gameaccountValue => restriction.params.type === gameaccountValue.type);
        const gameaccountDescription = find(user.gameaccountDescriptions, description => restriction.params.type === description.type);
        const gameaccountProvider = find(user.gameaccountProviders, provider => restriction.params.type === provider.type);
        const returnUrl = encodeURIComponent(this.link.href());
        const gaWhitelist = {
            steam: `https://account.eslgaming.com/oauth2/v1/link/steam?return_url=${returnUrl}`,
            psn: `https://account.eslgaming.com/oauth2/v1/link/psn?return_url=${returnUrl}`,
            psn_sp_int: `https://account.eslgaming.com/oauth2/v1/link/psn?environment=sp-int&return_url=${returnUrl}`,
            xbox: `https://account.eslgaming.com/oauth2/v1/link/xbox?return_url=${returnUrl}`,
            oculus: `https://account.eslgaming.com/oauth2/v1/link/oculus?return_url=${returnUrl}`,
            battletag_global_oauth2: `https://account.eslgaming.com/oauth2/v1/link/battlenet?return_url=${returnUrl}`,
            battletag_china_oauth2: `https://account.eslgaming.com/oauth2/v1/link/battlenet?environment=china&return_url=${returnUrl}`,
            ea: `https://account.eslgaming.com/oauth2/v1/link/ea?return_url=${returnUrl}`,
            discord: `http://account.eslgaming.com/link/discord?return_url=${returnUrl}`,
            supercell: `https://account.eslgaming.com/link/supercell?return_url=${returnUrl}`,
            esea: ` https://play.esea.net/index.php?s=upanel&d=manage&tab=esl_begin&return_to=${returnUrl}`,
            dragonest: `http://account.eslgaming.com/link/dragonest?return_url=${returnUrl}`,
            riot: `https://account.eslgaming.com/link/riot?return_url=${returnUrl}`,
        };
        const gameAccountInfo = this.builder
            .buildGameAccounts(restriction ? [restriction] : [], gameaccountDescription ? [gameaccountDescription] : [], gameaccountProvider ? [gameaccountProvider] : [], [gameaccount])
            .pop();
        let idProvider = gameAccountInfo.idProvider;
        if (idProvider === "pubgm") {
            return {
                title: this.translate.translate("league-widget:requirement-pubgm-use-app-title", {}),
                description: {
                    text: this.translate.translate("league-widget:requirement-pubgm-use-app-description", {}),
                },
            };
        }
        const psnChangeUrl = "https://account.eslgaming.com/user/linkages";
        const requirement = {
            title: this.translate.translate(`league-widget:requirement-${restriction.type}-title`, {
                passed: restriction.passed ? 1 : 0,
                gameaccount: gameaccount ? gameaccount.value : "",
                gameaccountName: gameaccountDescription ? gameaccountDescription.name : "",
            }),
            description: {
                text: gaWhitelist[idProvider]
                    ? this.translate.translate("league-widget:ga-linkage-description", {
                        passed: restriction.passed ? 1 : 0,
                        gameaccount: gameaccount ? gameaccount.value : "",
                        gameaccountName: gameaccountDescription ? gameaccountDescription.name : "",
                    })
                    : this.translate.translate(`league-widget:requirement-${restriction.type}-description`, {
                        passed: restriction.passed ? 1 : 0,
                        gameaccount: gameaccount ? gameaccount.value : "",
                        gameaccountName: gameaccountDescription,
                    }),
            },
            type: restriction.type,
            gameAccountType: restriction.params.type,
        };
        idProvider = requirement.gameAccountType === "psn_online_id_spint" ? "psn_sp_int" : idProvider;
        if (user.profile) {
            requirement.button = {
                label: this.translate.translate(gaWhitelist[idProvider] ? "league-widget:ga-link" : `league-widget:requirement-${restriction.type}-button`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                action: gaWhitelist[idProvider]
                    ? idProvider === "psn" && restriction.passed
                        ? () => this.location.go(psnChangeUrl, true)
                        : () => this.location.go(gaWhitelist[idProvider])
                    : this.ds.openGameAccountDialog.bind(this.ds, {}, gameAccountInfo, true, restriction.passed, leagueId),
            };
        }
        return requirement;
    }
}
GameAccountRequirementFactory.ɵfac = function GameAccountRequirementFactory_Factory(t) { return new (t || GameAccountRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject("DialogService"), i0.ɵɵinject(GameAccountBuilder), i0.ɵɵinject(i2.Location), i0.ɵɵinject(i2.LinkService)); };
GameAccountRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: GameAccountRequirementFactory, factory: GameAccountRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GameAccountRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }, { type: GameAccountBuilder }, { type: i2.Location }, { type: i2.LinkService }]; }, null); })();

class GenderRequirementFactory {
    constructor(translate, location) {
        this.translate = translate;
        this.location = location;
    }
    build(leagueId, restriction, user) {
        const requirement = {
            description: {
                text: this.translate.translate(`league-widget:requirement-${restriction.type}-description`, {
                    passed: restriction.passed ? 1 : 0,
                    gender: restriction.params.gender,
                }),
            },
        };
        if (user.profile) {
            requirement.button = {
                label: this.translate.translate(`league-widget:requirement-${restriction.type}-button`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                action: () => this.location.go(`/player/edit/${user.profile.id}`),
            };
        }
        return requirement;
    }
}
GenderRequirementFactory.ɵfac = function GenderRequirementFactory_Factory(t) { return new (t || GenderRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.Location)); };
GenderRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: GenderRequirementFactory, factory: GenderRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GenderRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: i2.Location }]; }, null); })();

class MinAgeRequirementFactory {
    constructor(translate, location) {
        this.translate = translate;
        this.location = location;
    }
    build(leagueId, restriction, user) {
        const requirement = {
            description: {
                text: this.translate.translate(`league-widget:requirement-${restriction.type}-description`, {
                    passed: restriction.passed ? 1 : 0,
                    minAge: restriction.params.minage,
                }),
            },
        };
        if (user.profile) {
            requirement.button = {
                label: this.translate.translate(`league-widget:requirement-${restriction.type}-button`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                action: () => this.location.go(`/player/edit/${user.profile.id}`),
            };
        }
        return requirement;
    }
}
MinAgeRequirementFactory.ɵfac = function MinAgeRequirementFactory_Factory(t) { return new (t || MinAgeRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.Location)); };
MinAgeRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: MinAgeRequirementFactory, factory: MinAgeRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MinAgeRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: i2.Location }]; }, null); })();

class COCTownHallLevelRequirementFactory {
    constructor(translate, location, formatter) {
        this.translate = translate;
        this.location = location;
        this.formatter = formatter;
    }
    build(leagueId, restriction, user) {
        const requirement = {
            description: {
                text: this.getDescriptionText(restriction),
            },
        };
        return requirement;
    }
    getDescriptionText(restriction) {
        const minLevel = restriction.params.min;
        const maxLevel = restriction.params.max;
        if (minLevel && !maxLevel) {
            return this.getTranslationString(restriction, "min");
        }
        else if (!minLevel && maxLevel) {
            return this.getTranslationString(restriction, "max");
        }
        else if (minLevel && maxLevel && minLevel !== maxLevel) {
            return this.getTranslationString(restriction, "minmax");
        }
        else if (minLevel && maxLevel && minLevel === maxLevel) {
            return this.getTranslationString(restriction, "equal-minmax");
        }
        else {
            return this.getTranslationString(restriction, "min");
        }
    }
    getTranslationString(restriction, translationType) {
        return this.translate.translate(`league-widget:requirement-${restriction.type}-${translationType}`, {
            passed: restriction.passed ? 1 : 0,
            minLevel: restriction.params.min,
            maxLevel: restriction.params.max,
            currentLevel: restriction.failedMembers && restriction.failedMembers.length ? restriction.failedMembers[0].currentLevel : null,
        });
    }
}
COCTownHallLevelRequirementFactory.ɵfac = function COCTownHallLevelRequirementFactory_Factory(t) { return new (t || COCTownHallLevelRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.Location), i0.ɵɵinject(i2.FormatDate)); };
COCTownHallLevelRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: COCTownHallLevelRequirementFactory, factory: COCTownHallLevelRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(COCTownHallLevelRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: i2.Location }, { type: i2.FormatDate }]; }, null); })();

class SC2RegionRequirementFactory {
    constructor(translate, location, link) {
        this.translate = translate;
        this.location = location;
        this.link = link;
    }
    build(leagueId, restriction, user) {
        const returnUrl = encodeURIComponent(this.link.href());
        const linkUrl = `https://account.eslgaming.com/oauth2/v1/link/battlenet?return_url=${returnUrl}`;
        const requirement = {
            description: {
                text: this.getDescriptionText(restriction),
            },
        };
        if (!restriction.passed && user.profile) {
            requirement.button = {
                label: this.translate.translate(`league-widget:requirement-${restriction.type}-button`, {}),
                action: () => this.location.go(linkUrl),
            };
        }
        return requirement;
    }
    getDescriptionText(restriction) {
        return this.getTranslationString(restriction);
    }
    getTranslationString(restriction) {
        const region = restriction.params.region;
        return this.translate.translate(`league-widget:requirement-${restriction.type}`, {
            passed: restriction.passed ? 1 : 0,
            region: region[0].toUpperCase() + region.slice(1),
        });
    }
}
SC2RegionRequirementFactory.ɵfac = function SC2RegionRequirementFactory_Factory(t) { return new (t || SC2RegionRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.Location), i0.ɵɵinject(i2.LinkService)); };
SC2RegionRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: SC2RegionRequirementFactory, factory: SC2RegionRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SC2RegionRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: i2.Location }, { type: i2.LinkService }]; }, null); })();

class CityRequirementFactory {
    constructor(translate, location) {
        this.translate = translate;
        this.location = location;
    }
    build(leagueId, restriction, user) {
        const requirement = {
            description: {
                text: this.getDescriptionText(restriction),
            },
        };
        if (user.profile) {
            requirement.button = {
                label: this.translate.translate(`league-widget:requirement-${restriction.type}-button`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                action: () => this.location.go(`/player/edit/${user.profile.id}`),
            };
        }
        return requirement;
    }
    getDescriptionText(restriction) {
        if (restriction.params.city) {
            return this.getTranslationString(restriction, "fixed");
        }
        else {
            return this.getTranslationString(restriction, "any");
        }
    }
    getTranslationString(restriction, translationType) {
        return this.translate.translate(`league-widget:requirement-${restriction.type}-${translationType}`, {
            passed: restriction.passed ? 1 : 0,
            city: restriction.params.city,
        });
    }
}
CityRequirementFactory.ɵfac = function CityRequirementFactory_Factory(t) { return new (t || CityRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.Location)); };
CityRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: CityRequirementFactory, factory: CityRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CityRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: i2.Location }]; }, null); })();

class BrawlStarsProfileRequirementFactory {
    constructor(translate, link) {
        this.translate = translate;
        this.link = link;
    }
    build(leagueId, restriction, user) {
        const { passed } = restriction;
        const requirement = {
            description: {
                text: this.translate.translate("league-widget:requirement-brawlStarsProfile-description", { passed: passed ? 1 : 0 }),
            },
        };
        if (!passed && user.profile) {
            requirement.button = {
                label: this.translate.translate("league-widget:ga-link", {
                    passed: 0,
                }),
                action: () => {
                    const returnUrl = encodeURIComponent(this.link.href());
                    window.location.href = `https://account.eslgaming.com/link/supercell?return_url=${returnUrl}`;
                },
            };
        }
        return requirement;
    }
}
BrawlStarsProfileRequirementFactory.ɵfac = function BrawlStarsProfileRequirementFactory_Factory(t) { return new (t || BrawlStarsProfileRequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.LinkService)); };
BrawlStarsProfileRequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: BrawlStarsProfileRequirementFactory, factory: BrawlStarsProfileRequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BrawlStarsProfileRequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: i2.LinkService }]; }, null); })();

const requirementTexts = {
    "league-widget:requirement-age-title": "Birthday Entered",
    "league-widget:requirement-age-description": "{passed, select, 1{} other{Enter your birthday}}",
    "league-widget:requirement-age-button": "{passed, select, 1{Change} other{Enter}}",
    "league-widget:requirement-alternateLeague-title": "Conflicting tournaments",
    "league-widget:requirement-alternateLeague-button": "Info",
    "league-widget:requirement-gameaccount-title": "{gameaccountName}",
    "league-widget:requirement-gameaccount-description": "{passed, select, 1{{gameaccount}} other{Register your game ID}}",
    "league-widget:requirement-gameaccount-button": "{passed, select, 1{Change} other{Register}}",
    "league-widget:requirement-gender-title": "Gender",
    "league-widget:requirement-gender-description": "{passed, select, 1{{gender, select, f{Female} other{Male}}} " + "other{Must be {gender, select, f{Female} other{Male}}}}",
    "league-widget:requirement-gender-button": "{passed, select, 1{Change} other{Enter}}",
    "league-widget:requirement-isadmin-title": "Staff",
    "league-widget:requirement-isadmin-description": "{passed, select, 1{You're awesome!} other{Join the staff}}",
    "league-widget:requirement-isadmin-button": "Apply",
    "league-widget:requirement-photo-title": "Photo",
    "league-widget:requirement-photo-description": "{passed, select, 1{Looking good!} other{Upload a photo}}",
    "league-widget:requirement-photo-button": "{passed, select, 1{Change} other{Upload}}",
    "league-widget:requirement-minage-title": "Min Age",
    "league-widget:requirement-minage-description": "{passed, select, 1{} other{At least {minAge} years old}}",
    "league-widget:requirement-minage-button": "{passed, select, 1{Change} other{Enter}}",
    "league-widget:requirement-residence_nationality-title": "Residence / Citizenship",
    "league-widget:requirement-residence_nationality-description": "{passed, select, 1{} other{More info}}",
    "league-widget:requirement-residence_nationality-button": "Change",
    "league-widget:requirement-inCountryList-title": "Residence",
    "league-widget:requirement-inCountryList-description": "{passed, select, 1{} other{More info}}",
    "league-widget:requirement-inCountryList-button": "Change",
    "league-widget:requirement-trustlevel-title": "Trusted",
    "league-widget:requirement-trustlevel-description": "{passed, select, 1{Until {trustedUntil}} other{Requires Trusted " +
        "{mintrustlevel, select, 5{Pro} other{Level {mintrustlevel}}}}}",
    "league-widget:requirement-trustlevel-button": "{passed, select, 1{Extend} other{Info}}",
    "league-widget:requirement-premium-title": "Premium",
    "league-widget:requirement-premium-description": "{passed, select, 1{Until {premiumUntil}} other{Requires premium}}",
    "league-widget:requirement-premium-button": "{passed, select, 1{Extend} other{Info}}",
    "league-widget:requirement-cocTownHallLevel-title": "Town Hall Level",
    "league-widget:requirement-cocTownHallLevel-button": "Change",
    "league-widget:requirement-cocTownHallLevel-min": "{passed, select, 1{Great, your Town Hall passed the minimum " +
        "level of {minLevel}!} other{Your Town Hall level must be at least {minLevel}}}",
    "league-widget:requirement-cocTownHallLevel-max": "{passed, select, 1{Great, your Town Hall is below the maximum " +
        "level of {maxLevel}!} other{Your Town Hall level must be lower than {maxLevel}}}",
    "league-widget:requirement-cocTownHallLevel-minmax": "{passed, select, 1{Great, your Town Hall level is " +
        "between {minLevel} and {maxLevel}!} other{Your Town Hall level must be between {minLevel} and {maxLevel}}}",
    "league-widget:requirement-cocTownHallLevel-equal-minmax": "{passed, select, 1{Great, your Town Hall level is {minLevel}!} other{Your Town Hall level must be exactly {minLevel}}}",
    "league-widget:requirement-cocIsWarLogPublic-title": "Public Clan War Log",
    "league-widget:requirement-cocIsWarLogPublic-description": "Players clan war log must be set to public",
    "league-widget:requirement-city-title": "City",
    "league-widget:requirement-city-button": "Change",
    "league-widget:requirement-city-fixed": "{passed, select, 1{You have selected {city}} other{Your city must be {city}}}",
    "league-widget:requirement-city-any": "{passed, select, 1{You have entered a city} other{You must enter your city}}",
    "league-widget:requirement-sc2Region-title": "StarCraft II Profile",
    "league-widget:requirement-sc2Region": "{passed, select, 1{} other{You must have a StarCraft 2 profile in the {region} region}}",
    "league-widget:requirement-sc2Region-button": "Refresh",
};

class RequirementFactory {
    constructor(translate, ageFactory, minageFactory, genderFactory, gameaccountFactory, isadminFactory, photoFactory, trustlevelFactory, premiumFactory, alternateLeagueFactory, residencenationalityFactory, inCountryListFactory, cocTownHallLevelRequirementFactory, cityRequirementFactory, sC2RegionRequirementFactory, brawlStarsProfileRequirementFactory) {
        this.translate = translate;
        this.ageFactory = ageFactory;
        this.minageFactory = minageFactory;
        this.genderFactory = genderFactory;
        this.gameaccountFactory = gameaccountFactory;
        this.isadminFactory = isadminFactory;
        this.photoFactory = photoFactory;
        this.trustlevelFactory = trustlevelFactory;
        this.premiumFactory = premiumFactory;
        this.alternateLeagueFactory = alternateLeagueFactory;
        this.residencenationalityFactory = residencenationalityFactory;
        this.inCountryListFactory = inCountryListFactory;
        this.cocTownHallLevelRequirementFactory = cocTownHallLevelRequirementFactory;
        this.cityRequirementFactory = cityRequirementFactory;
        this.sC2RegionRequirementFactory = sC2RegionRequirementFactory;
        this.brawlStarsProfileRequirementFactory = brawlStarsProfileRequirementFactory;
        this.requirementRestrictionMap = {
            age: this.ageFactory,
            minage: this.minageFactory,
            gender: this.genderFactory,
            gameaccount: this.gameaccountFactory,
            isadmin: this.isadminFactory,
            photo: this.photoFactory,
            trustlevel: this.trustlevelFactory,
            premium: this.premiumFactory,
            alternateLeague: this.alternateLeagueFactory,
            residence_nationality: this.residencenationalityFactory,
            inCountryList: this.inCountryListFactory,
            cocTownHallLevel: this.cocTownHallLevelRequirementFactory,
            city: this.cityRequirementFactory,
            sc2Region: this.sC2RegionRequirementFactory,
            brawlStarsProfile: this.brawlStarsProfileRequirementFactory,
        };
    }
    build(leagueId, restrictions, user) {
        return map(restrictions, (restriction) => {
            const baseRequirement = {
                title: this.translate.translate(`league-widget:requirement-${restriction.type}-title`, {
                    passed: restriction.passed ? 1 : 0,
                }),
                passed: restriction.passed,
            };
            let specialRequirement;
            if (this.requirementRestrictionMap[restriction.type]) {
                specialRequirement = this.requirementRestrictionMap[restriction.type].build(leagueId, restriction, user);
            }
            else {
                specialRequirement = this.buildRestriction(restriction);
            }
            return Object.assign(Object.assign({}, baseRequirement), specialRequirement);
        });
    }
    buildRestriction(restriction) {
        return {
            description: {
                text: this.translate.translate(`league-widget:requirement-${restriction.type}-description`, {
                    passed: restriction.passed ? 1 : 0,
                }),
            },
        };
    }
}
RequirementFactory.ɵfac = function RequirementFactory_Factory(t) { return new (t || RequirementFactory)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(AgeRequirementFactory), i0.ɵɵinject(MinAgeRequirementFactory), i0.ɵɵinject(GenderRequirementFactory), i0.ɵɵinject(GameAccountRequirementFactory), i0.ɵɵinject(IsAdminRequirementFactory), i0.ɵɵinject(PhotoRequirementFactory), i0.ɵɵinject(TrustLevelRequirementFactory), i0.ɵɵinject(PremiumRequirementFactory), i0.ɵɵinject(AlternateLeagueRequirementFactory), i0.ɵɵinject(ResidenceNationalityRequirementFactory), i0.ɵɵinject(InCountryListRequirementFactory), i0.ɵɵinject(COCTownHallLevelRequirementFactory), i0.ɵɵinject(CityRequirementFactory), i0.ɵɵinject(SC2RegionRequirementFactory), i0.ɵɵinject(BrawlStarsProfileRequirementFactory)); };
RequirementFactory.ɵprov = i0.ɵɵdefineInjectable({ token: RequirementFactory, factory: RequirementFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RequirementFactory, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: AgeRequirementFactory }, { type: MinAgeRequirementFactory }, { type: GenderRequirementFactory }, { type: GameAccountRequirementFactory }, { type: IsAdminRequirementFactory }, { type: PhotoRequirementFactory }, { type: TrustLevelRequirementFactory }, { type: PremiumRequirementFactory }, { type: AlternateLeagueRequirementFactory }, { type: ResidenceNationalityRequirementFactory }, { type: InCountryListRequirementFactory }, { type: COCTownHallLevelRequirementFactory }, { type: CityRequirementFactory }, { type: SC2RegionRequirementFactory }, { type: BrawlStarsProfileRequirementFactory }]; }, null); })();

function RequirementGameAccountStepComponent_div_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.requirement.description.text);
} }
function RequirementGameAccountStepComponent_div_4_player_game_account_text_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "player-game-account-text", 9);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("playerId", ctx_r3.playerId)("gameAccountType", ctx_r3.gameAccountType);
} }
const _c0$k = function (a0) { return { "c-requirement-step__info__description--disabled": a0 }; };
function RequirementGameAccountStepComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, RequirementGameAccountStepComponent_div_4_span_1_Template, 2, 1, "span", 7);
    i0.ɵɵtemplate(2, RequirementGameAccountStepComponent_div_4_player_game_account_text_2_Template, 1, 2, "player-game-account-text", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$k, ctx_r0.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.requirement.passed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.requirement.passed);
} }
const _c1$7 = function (a0, a1) { return { "c-button--primary": a0, "c-button--secondary": a1 }; };
function RequirementGameAccountStepComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function RequirementGameAccountStepComponent_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.button.emit(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c1$7, !ctx_r1.requirement.passed, ctx_r1.requirement.passed));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.requirement.button.label, " ");
} }
const _c2$2 = function (a0) { return { "is-passing": a0 }; };
const _c3$2 = function (a0) { return { "c-requirement-step__info__title--disabled": a0 }; };
class RequirementGameAccountStepComponent {
    constructor() {
        this.description = new EventEmitter();
        this.button = new EventEmitter();
    }
}
RequirementGameAccountStepComponent.ɵfac = function RequirementGameAccountStepComponent_Factory(t) { return new (t || RequirementGameAccountStepComponent)(); };
RequirementGameAccountStepComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RequirementGameAccountStepComponent, selectors: [["requirement-game-account-step"]], inputs: { playerId: "playerId", gameAccountType: "gameAccountType", requirement: "requirement", disabled: "disabled" }, outputs: { description: "description", button: "button" }, decls: 7, vars: 9, consts: [[1, "c-requirement-step", 3, "ngClass"], [1, "c-requirement-step__info", 3, "ngClass"], [1, "c-requirement-step__info__title"], ["class", "c-requirement-step__info__description", 3, "ngClass", 4, "ngIf"], [1, "c-requirement-step__action"], ["class", "c-button c-button--block c-button--big", 3, "ngClass", "click", 4, "ngIf"], [1, "c-requirement-step__info__description", 3, "ngClass"], [4, "ngIf"], [3, "playerId", "gameAccountType", 4, "ngIf"], [3, "playerId", "gameAccountType"], [1, "c-button", "c-button--block", "c-button--big", 3, "ngClass", "click"]], template: function RequirementGameAccountStepComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "section", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, RequirementGameAccountStepComponent_div_4_Template, 3, 5, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "section", 4);
        i0.ɵɵtemplate(6, RequirementGameAccountStepComponent_button_6_Template, 2, 5, "button", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c2$2, ctx.requirement.passed));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$2, ctx.disabled));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.requirement.title, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.requirement.description);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.requirement.button);
    } }, directives: [i2$1.NgClass, i2$1.NgIf, i2$2.PlayerGameAccountTextComponent], styles: ["[_nghost-%COMP%] {\n                display: block;\n            }"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RequirementGameAccountStepComponent, [{
        type: Component,
        args: [{
                selector: "requirement-game-account-step",
                templateUrl: "./requirement-game-account-step.component.html",
                styles: [
                    `
            :host {
                display: block;
            }
        `,
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { playerId: [{
            type: Input
        }], gameAccountType: [{
            type: Input
        }], requirement: [{
            type: Input
        }], disabled: [{
            type: Input
        }], description: [{
            type: Output
        }], button: [{
            type: Output
        }] }); })();

function RequirementStepComponent_div_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r2.requirement.description.text);
} }
function RequirementStepComponent_div_4_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵlistener("click", function RequirementStepComponent_div_4_a_2_Template_a_click_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(2); $event.preventDefault(); return ctx_r4.description.emit(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r3.requirement.description.text);
} }
const _c0$j = function (a0) { return { "c-requirement-step__info__description--disabled": a0 }; };
function RequirementStepComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, RequirementStepComponent_div_4_span_1_Template, 2, 1, "span", 7);
    i0.ɵɵtemplate(2, RequirementStepComponent_div_4_a_2_Template, 2, 1, "a", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0$j, ctx_r0.disabled));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.requirement.description.action);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.requirement.description.action);
} }
const _c1$6 = function (a0, a1) { return { "c-button--primary": a0, "c-button--secondary": a1 }; };
function RequirementStepComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function RequirementStepComponent_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.button.emit(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c1$6, !ctx_r1.requirement.passed, ctx_r1.requirement.passed));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.requirement.button.label, " ");
} }
const _c2$1 = function (a0) { return { "is-passing": a0 }; };
const _c3$1 = function (a0) { return { "c-requirement-step__info__title--disabled": a0 }; };
class RequirementStepComponent {
    constructor() {
        this.description = new EventEmitter();
        this.button = new EventEmitter();
    }
}
RequirementStepComponent.ɵfac = function RequirementStepComponent_Factory(t) { return new (t || RequirementStepComponent)(); };
RequirementStepComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RequirementStepComponent, selectors: [["requirement-step"]], inputs: { requirement: "requirement", disabled: "disabled" }, outputs: { description: "description", button: "button" }, decls: 7, vars: 9, consts: [[1, "c-requirement-step", 3, "ngClass"], [1, "c-requirement-step__info", 3, "ngClass"], [1, "c-requirement-step__info__title"], ["class", "c-requirement-step__info__description", 3, "ngClass", 4, "ngIf"], [1, "c-requirement-step__action"], ["class", "c-button c-button--block c-button--big", 3, "ngClass", "click", 4, "ngIf"], [1, "c-requirement-step__info__description", 3, "ngClass"], [4, "ngIf"], ["role", "button", "href", "#", 3, "click", 4, "ngIf"], ["role", "button", "href", "#", 3, "click"], [1, "c-button", "c-button--block", "c-button--big", 3, "ngClass", "click"]], template: function RequirementStepComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "section", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, RequirementStepComponent_div_4_Template, 3, 5, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "section", 4);
        i0.ɵɵtemplate(6, RequirementStepComponent_button_6_Template, 2, 5, "button", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c2$1, ctx.requirement.passed));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c3$1, ctx.disabled));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.requirement.title, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.requirement.description);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.requirement.button);
    } }, directives: [i2$1.NgClass, i2$1.NgIf], styles: ["[_nghost-%COMP%] {\n                display: block;\n            }"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RequirementStepComponent, [{
        type: Component,
        args: [{
                selector: "requirement-step",
                templateUrl: "./requirement-step.component.html",
                styles: [
                    `
            :host {
                display: block;
            }
        `,
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { requirement: [{
            type: Input
        }], disabled: [{
            type: Input
        }], description: [{
            type: Output
        }], button: [{
            type: Output
        }] }); })();

class RequirementModule {
}
RequirementModule.ɵfac = function RequirementModule_Factory(t) { return new (t || RequirementModule)(); };
RequirementModule.ɵmod = i0.ɵɵdefineNgModule({ type: RequirementModule });
RequirementModule.ɵinj = i0.ɵɵdefineInjector({ providers: [
        RequirementFactory,
        AgeRequirementFactory,
        MinAgeRequirementFactory,
        GenderRequirementFactory,
        GameAccountRequirementFactory,
        IsAdminRequirementFactory,
        PhotoRequirementFactory,
        TrustLevelRequirementFactory,
        PremiumRequirementFactory,
        AlternateLeagueRequirementFactory,
        ResidenceNationalityRequirementFactory,
        InCountryListRequirementFactory,
        COCTownHallLevelRequirementFactory,
        SC2RegionRequirementFactory,
        CityRequirementFactory,
        BrawlStarsProfileRequirementFactory,
    ], imports: [[CommonModule, CommonsDateModule, CommonsLocationModule, TranslationModule, PlayerModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(RequirementModule, { declarations: [RequirementStepComponent, RequirementGameAccountStepComponent], imports: [CommonModule, CommonsDateModule, CommonsLocationModule, TranslationModule, PlayerModule], exports: [RequirementStepComponent, RequirementGameAccountStepComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RequirementModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, CommonsDateModule, CommonsLocationModule, TranslationModule, PlayerModule],
                declarations: [RequirementStepComponent, RequirementGameAccountStepComponent],
                exports: [RequirementStepComponent, RequirementGameAccountStepComponent],
                providers: [
                    RequirementFactory,
                    AgeRequirementFactory,
                    MinAgeRequirementFactory,
                    GenderRequirementFactory,
                    GameAccountRequirementFactory,
                    IsAdminRequirementFactory,
                    PhotoRequirementFactory,
                    TrustLevelRequirementFactory,
                    PremiumRequirementFactory,
                    AlternateLeagueRequirementFactory,
                    ResidenceNationalityRequirementFactory,
                    InCountryListRequirementFactory,
                    COCTownHallLevelRequirementFactory,
                    SC2RegionRequirementFactory,
                    CityRequirementFactory,
                    BrawlStarsProfileRequirementFactory,
                ],
            }]
    }], null, null); })();

const playerReadyTexts = {
    "player-ready:requirements": "Requirements",
};

class PlayerReadyComponentConfig {
    get sorting() {
        return [
            "isadmin",
            "gender",
            "minage",
            "inCountryList",
            "residence_nationality",
            "alternateLeague",
            "premium",
            "trustlevel",
            "age",
            "gameaccount",
            "photo",
        ];
    }
}
PlayerReadyComponentConfig.ɵfac = function PlayerReadyComponentConfig_Factory(t) { return new (t || PlayerReadyComponentConfig)(); };
PlayerReadyComponentConfig.ɵprov = i0.ɵɵdefineInjectable({ token: PlayerReadyComponentConfig, factory: PlayerReadyComponentConfig.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlayerReadyComponentConfig, [{
        type: Injectable
    }], null, null); })();

class ContestantReadyAlertFactory {
    constructor(helper, date) {
        this.helper = helper;
        this.date = date;
    }
    getPlayerAlertTexts(contestant, privateProfile, restrictions) {
        const ppStatus = this.helper.getPlayerPPStatus(restrictions, parseInt(contestant.id, 10));
        const bannedStatus = this.helper.getPlayerBannedStatus(restrictions, parseInt(contestant.id, 10));
        return this.getContestantAlertTexts(contestant, privateProfile, ppStatus, bannedStatus);
    }
    getTeamAlertTexts(contestant, privateProfile, restrictions) {
        const ppStatus = this.helper.getTeamPPStatus(restrictions);
        const bannedStatus = this.helper.getTeamBannedStatus(restrictions);
        return this.getContestantAlertTexts(contestant, privateProfile, ppStatus, bannedStatus);
    }
    getContestantAlertTexts(contestant, privateProfile, ppStatus, bannedStatus) {
        const texts = [];
        if (ppStatus) {
            texts.push({
                text: "contestant-ready:too-many-pps-until",
                params: {
                    until: this.date.formatDate(ppStatus.until, privateProfile.timezone),
                },
            });
        }
        if (bannedStatus) {
            texts.push({
                text: "contestant-ready:banned-until",
                params: {
                    until: this.date.formatDate(bannedStatus.until, privateProfile.timezone),
                },
            });
        }
        if (contestant.isBarred) {
            texts.push({
                text: "contestant-ready:barred-until",
                params: {
                    until: this.date.formatDate(contestant.barredUntil, privateProfile.timezone),
                },
            });
        }
        return texts;
    }
}
ContestantReadyAlertFactory.ɵfac = function ContestantReadyAlertFactory_Factory(t) { return new (t || ContestantReadyAlertFactory)(i0.ɵɵinject(i2.RestrictionService), i0.ɵɵinject(i2.FormatDate)); };
ContestantReadyAlertFactory.ɵprov = i0.ɵɵdefineInjectable({ token: ContestantReadyAlertFactory, factory: ContestantReadyAlertFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContestantReadyAlertFactory, [{
        type: Injectable
    }], function () { return [{ type: i2.RestrictionService }, { type: i2.FormatDate }]; }, null); })();

const _c0$i = function (a0) { return { team: a0 }; };
function ContestantReadyHeaderComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "contestant-ready:ready", i0.ɵɵpureFunction1(4, _c0$i, ctx_r0.isTeam ? 1 : 0)), " ");
} }
function ContestantReadyHeaderComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "contestant-ready:not-ready", i0.ɵɵpureFunction1(4, _c0$i, ctx_r1.isTeam ? 1 : 0)), " ");
} }
const _c1$5 = function (a0, a1) { return { "is-passing": a0, "is-failing": a1 }; };
class ContestantReadyHeaderComponent {
}
ContestantReadyHeaderComponent.ɵfac = function ContestantReadyHeaderComponent_Factory(t) { return new (t || ContestantReadyHeaderComponent)(); };
ContestantReadyHeaderComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ContestantReadyHeaderComponent, selectors: [["contestant-ready-header"]], inputs: { isReady: ["ready", "isReady"], isTeam: ["team", "isTeam"] }, decls: 3, vars: 6, consts: [[1, "c-contestant-ready-header", "c-label", 3, "ngClass"], ["class", "c-contestant-ready-header__status", 4, "ngIf"], [1, "c-contestant-ready-header__status"]], template: function ContestantReadyHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, ContestantReadyHeaderComponent_span_1_Template, 3, 6, "span", 1);
        i0.ɵɵtemplate(2, ContestantReadyHeaderComponent_span_2_Template, 3, 6, "span", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c1$5, ctx.isReady, !ctx.isReady));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isReady);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isReady);
    } }, directives: [i2$1.NgClass, i2$1.NgIf], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContestantReadyHeaderComponent, [{
        type: Component,
        args: [{
                selector: "contestant-ready-header",
                templateUrl: "./contestant-ready-header.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { isReady: [{
            type: Input,
            args: ["ready"]
        }], isTeam: [{
            type: Input,
            args: ["team"]
        }] }); })();

function ContestantReadyAlertComponent_section_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const alert_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, alert_r2.text, alert_r2.params), " ");
} }
function ContestantReadyAlertComponent_section_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 1);
    i0.ɵɵtemplate(1, ContestantReadyAlertComponent_section_0_div_1_Template, 3, 4, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.alerts);
} }
class ContestantReadyAlertComponent {
}
ContestantReadyAlertComponent.ɵfac = function ContestantReadyAlertComponent_Factory(t) { return new (t || ContestantReadyAlertComponent)(); };
ContestantReadyAlertComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ContestantReadyAlertComponent, selectors: [["contestant-ready-alert"]], inputs: { alerts: "alerts" }, decls: 1, vars: 1, consts: [["class", "c-contestant-ready-alert", 4, "ngIf"], [1, "c-contestant-ready-alert"], [4, "ngFor", "ngForOf"]], template: function ContestantReadyAlertComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ContestantReadyAlertComponent_section_0_Template, 2, 1, "section", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.alerts && ctx.alerts.length);
    } }, directives: [i2$1.NgIf, i2$1.NgForOf], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContestantReadyAlertComponent, [{
        type: Component,
        args: [{
                selector: "contestant-ready-alert",
                templateUrl: "./contestant-ready-alert.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { alerts: [{
            type: Input,
            args: ["alerts"]
        }] }); })();

function PlayerReadyComponent_contestant_ready_header_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "contestant-ready-header", 5);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ready", i0.ɵɵpipeBind1(1, 2, ctx_r0.readyToPlay$))("team", false);
} }
function PlayerReadyComponent_div_7_contestant_ready_alert_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "contestant-ready-alert", 7);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("alerts", i0.ɵɵpipeBind1(1, 1, ctx_r4.alerts$));
} }
function PlayerReadyComponent_div_7_ng_container_3_section_1_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "requirement-game-account-step", 14);
    i0.ɵɵlistener("button", function PlayerReadyComponent_div_7_ng_container_3_section_1_ng_container_1_ng_container_2_Template_requirement_game_account_step_button_1_listener($event) { i0.ɵɵrestoreView(_r14); const requirement_r9 = i0.ɵɵnextContext().$implicit; return requirement_r9.button == null ? null : requirement_r9.button.action($event); })("description", function PlayerReadyComponent_div_7_ng_container_3_section_1_ng_container_1_ng_container_2_Template_requirement_game_account_step_description_1_listener($event) { i0.ɵɵrestoreView(_r14); const requirement_r9 = i0.ɵɵnextContext().$implicit; return requirement_r9.description == null ? null : requirement_r9.description.action($event); });
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r10 = i0.ɵɵnextContext(4);
    let tmp_0_0 = null;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("playerId", (tmp_0_0 = i0.ɵɵpipeBind1(2, 4, ctx_r10.userPrivate$)) == null ? null : tmp_0_0.entry == null ? null : tmp_0_0.entry.id)("gameAccountType", requirement_r9.gameAccountType)("requirement", requirement_r9)("disabled", !i0.ɵɵpipeBind1(3, 6, ctx_r10.userPrivate$).entry);
} }
function PlayerReadyComponent_div_7_ng_container_3_section_1_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "requirement-step", 15);
    i0.ɵɵlistener("button", function PlayerReadyComponent_div_7_ng_container_3_section_1_ng_container_1_ng_container_3_Template_requirement_step_button_1_listener($event) { i0.ɵɵrestoreView(_r20); const requirement_r9 = i0.ɵɵnextContext().$implicit; return requirement_r9.button == null ? null : requirement_r9.button.action($event); })("description", function PlayerReadyComponent_div_7_ng_container_3_section_1_ng_container_1_ng_container_3_Template_requirement_step_description_1_listener($event) { i0.ɵɵrestoreView(_r20); const requirement_r9 = i0.ɵɵnextContext().$implicit; return requirement_r9.description == null ? null : requirement_r9.description.action($event); });
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement_r9 = i0.ɵɵnextContext().$implicit;
    const ctx_r11 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("requirement", requirement_r9)("disabled", !i0.ɵɵpipeBind1(2, 2, ctx_r11.userPrivate$).entry);
} }
function PlayerReadyComponent_div_7_ng_container_3_section_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainerStart(1, 11);
    i0.ɵɵtemplate(2, PlayerReadyComponent_div_7_ng_container_3_section_1_ng_container_1_ng_container_2_Template, 4, 8, "ng-container", 12);
    i0.ɵɵtemplate(3, PlayerReadyComponent_div_7_ng_container_3_section_1_ng_container_1_ng_container_3_Template, 3, 4, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirement_r9 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", requirement_r9.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "gameaccount");
} }
function PlayerReadyComponent_div_7_ng_container_3_section_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 9);
    i0.ɵɵtemplate(1, PlayerReadyComponent_div_7_ng_container_3_section_1_ng_container_1_Template, 4, 2, "ng-container", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const requirements_r6 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", requirements_r6);
} }
function PlayerReadyComponent_div_7_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PlayerReadyComponent_div_7_ng_container_3_section_1_Template, 2, 1, "section", 8);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const requirements_r6 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", requirements_r6.length);
} }
function PlayerReadyComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PlayerReadyComponent_div_7_contestant_ready_alert_1_Template, 2, 3, "contestant-ready-alert", 6);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, PlayerReadyComponent_div_7_ng_container_3_Template, 2, 1, "ng-container", 4);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r1.userPrivate$).entry);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx_r1.requirements$));
} }
function PlayerReadyComponent_loading_spinner_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner");
} }
function PlayerReadyComponent_inline_error_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"), " ");
} }
class PlayerReadyComponent {
    constructor(config, factory, alerts, rFilter, rTransform, store) {
        this.config = config;
        this.factory = factory;
        this.alerts = alerts;
        this.rFilter = rFilter;
        this.rTransform = rTransform;
        this.store = store;
    }
    ngOnInit() {
        this.userPrivate$ = this.store.select(getUser);
        this.gameAccountDescriptions$ = this.store.select(getGameAccountDescriptions);
        this.gameAccountProviders$ = this.store.select(getGameAccountProviders);
        this.userPremium$ = this.store.select(getUserPremium);
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        const userId$ = this.userPrivate$.pipe(map$1(user => (user.entry ? +user.entry.id : null)), distinctUntilChanged());
        this.userPublic$ = userId$.pipe(tap(userId => (userId ? this.store.dispatch(new LoadPlayerOnceAction(userId)) : null)), switchMap(userId => (userId ? this.store.select(getPlayer(userId)) : [null])));
        this.restrictions$ = userId$.pipe(tap(userId => (userId ? this.store.dispatch(new LoadLeagueRestrictionsOnceAction(this.leagueId, userId)) : null)), switchMap(userId => (userId ? this.store.select(getLeagueRestrictions(this.leagueId, userId)) : [null])));
        this.gameaccounts$ = userId$.pipe(tap(userId => (userId ? this.store.dispatch(new LoadGameaccountOnceAction(userId)) : null)), switchMap(userId => (userId ? this.store.select(getGameaccounts(userId)) : [null])));
        this.isLoading$ = this.isLoading();
        this.hasError$ = this.hasError();
        this.requirements$ = this.getRequirements();
        this.alerts$ = combineLatest(this.userPublic$.pipe(filter(exists)), this.userPrivate$.pipe(filter(exists)), this.restrictions$.pipe(filter(exists))).pipe(map$1(([publicProfile, privateProfile, restrictions]) => {
            if (publicProfile.entry && privateProfile.entry && restrictions.entry) {
                return this.alerts.getPlayerAlertTexts(publicProfile.entry, privateProfile.entry, restrictions.entry);
            }
            return [];
        }));
        this.readyToPlay$ = this.restrictions$.pipe(filter(exists), map$1(requirements => filter$1(requirements.entry, requirement => !requirement.passed)), map$1(requirements => filter$1(requirements, requirement => this.rFilter.affectsPlayers(requirement))), map$1(requirements => requirements.length === 0));
    }
    hasError() {
        return combineLatest(this.league$, this.userPrivate$, this.userPublic$, this.restrictions$, this.userPremium$, this.gameAccountDescriptions$, this.gameAccountProviders$).pipe(map$1((data) => {
            return data.filter(entry => entry && entry.error).length !== 0;
        }));
    }
    isLoading() {
        return combineLatest(this.league$, this.userPrivate$, this.userPublic$, this.restrictions$, this.userPremium$, this.gameAccountDescriptions$, this.gameAccountProviders$).pipe(map$1((data) => {
            return data.filter(entry => entry && entry.loading && !entry.entry).length !== 0;
        }));
    }
    getRequirements() {
        const restrictions$ = combineLatest(this.league$, this.restrictions$).pipe(switchMap(([league, restrictions]) => {
            let lRestrictions = league.entry.restrictions;
            if (restrictions && restrictions.entry) {
                lRestrictions = restrictions.entry;
            }
            let playerRestrictions = this.rTransform.countryCodeToCountryName(this.rFilter.getPlayerRestrictions(lRestrictions));
            playerRestrictions = sortBy(playerRestrictions, (restriction) => {
                return this.config.sorting.indexOf(restriction.type);
            });
            const alternateLeagueRestriction = find(playerRestrictions, ["type", "alternateLeague"]);
            if (alternateLeagueRestriction) {
                const { params: { leagueids }, } = alternateLeagueRestriction;
                this.store.dispatch(new LoadLeaguesOnceAction(leagueids));
                this.alternateLeagues$ = this.store.select(getLeagues(leagueids)).pipe(map$1(leagues => {
                    const leaguesArr = leagues.toArray();
                    const entryState = {
                        entry: null,
                        loading: true,
                        error: null,
                    };
                    if (leaguesArr.filter(entry => entry && entry.loading && !entry.entry).length !== 0) {
                        return entryState;
                    }
                    else {
                        entryState.entry = leaguesArr.map(({ entry }) => entry);
                        entryState.loading = false;
                    }
                    return entryState;
                }));
                return this.alternateLeagues$.pipe(filter(entryAvailable), map$1(leagues => leagues.entry), map$1(leagues => leagues.filter(Boolean)), take(1), map$1(leagues => {
                    for (let i = 0; i < playerRestrictions.length; i++) {
                        if (playerRestrictions[i].type === "alternateLeague") {
                            playerRestrictions[i].params = Object.assign(Object.assign({}, playerRestrictions[i].params), { leagues });
                        }
                    }
                    return playerRestrictions;
                }));
            }
            return of(playerRestrictions);
        }));
        return combineLatest(restrictions$, this.userPrivate$, this.userPremium$, this.gameaccounts$, this.gameAccountDescriptions$, this.gameAccountProviders$).pipe(switchMap(([restrictions, user, userPremium, userGameAccounts, gameaccountDescriptions, gameaccountProviders]) => {
            return this.league$.pipe(map$1(league => this.factory.build(league.entry.id, restrictions, {
                profile: user.entry,
                premium: userPremium.entry,
                gameaccounts: userGameAccounts ? userGameAccounts.entry : null,
                gameaccountDescriptions: gameaccountDescriptions.entry,
                gameaccountProviders: gameaccountProviders.entry,
            })));
        }));
    }
}
PlayerReadyComponent.ɵfac = function PlayerReadyComponent_Factory(t) { return new (t || PlayerReadyComponent)(i0.ɵɵdirectiveInject(PlayerReadyComponentConfig), i0.ɵɵdirectiveInject(RequirementFactory), i0.ɵɵdirectiveInject(ContestantReadyAlertFactory), i0.ɵɵdirectiveInject(i2.RestrictionFilterService), i0.ɵɵdirectiveInject(i2.RestrictionTransformerService), i0.ɵɵdirectiveInject(i1$1.Store)); };
PlayerReadyComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PlayerReadyComponent, selectors: [["player-ready"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 14, vars: 17, consts: [[1, "c-player-ready"], [1, "c-league-widget__header"], [1, "c-league-widget__header__title"], [3, "ready", "team", 4, "ngIf"], [4, "ngIf"], [3, "ready", "team"], [3, "alerts", 4, "ngIf"], [3, "alerts"], ["class", "c-player-ready__requirement-list", 4, "ngIf"], [1, "c-player-ready__requirement-list"], [4, "ngFor", "ngForOf"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [1, "c-player-ready__requirement", 3, "playerId", "gameAccountType", "requirement", "disabled", "button", "description"], [1, "c-player-ready__requirement", 3, "requirement", "disabled", "button", "description"]], template: function PlayerReadyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "section", 1);
        i0.ɵɵelementStart(2, "h3", 2);
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, PlayerReadyComponent_contestant_ready_header_5_Template, 2, 4, "contestant-ready-header", 3);
        i0.ɵɵpipe(6, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, PlayerReadyComponent_div_7_Template, 5, 6, "div", 4);
        i0.ɵɵpipe(8, "async");
        i0.ɵɵpipe(9, "async");
        i0.ɵɵtemplate(10, PlayerReadyComponent_loading_spinner_10_Template, 1, 0, "loading-spinner", 4);
        i0.ɵɵpipe(11, "async");
        i0.ɵɵtemplate(12, PlayerReadyComponent_inline_error_12_Template, 3, 3, "inline-error", 4);
        i0.ɵɵpipe(13, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, "player-ready:requirements"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 7, ctx.userPrivate$).entry);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(8, 9, ctx.hasError$) && !i0.ɵɵpipeBind1(9, 11, ctx.isLoading$));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(11, 13, ctx.isLoading$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(13, 15, ctx.hasError$));
    } }, directives: [i2$1.NgIf, ContestantReadyHeaderComponent, ContestantReadyAlertComponent, i2$1.NgForOf, i2$1.NgSwitch, i2$1.NgSwitchCase, i2$1.NgSwitchDefault, RequirementGameAccountStepComponent, RequirementStepComponent, i2.LoadingSpinnerComponent, i2.InlineErrorComponent], pipes: [i1.TranslatePipe, i2$1.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlayerReadyComponent, [{
        type: Component,
        args: [{
                selector: "player-ready",
                templateUrl: "./player-ready.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: PlayerReadyComponentConfig }, { type: RequirementFactory }, { type: ContestantReadyAlertFactory }, { type: i2.RestrictionFilterService }, { type: i2.RestrictionTransformerService }, { type: i1$1.Store }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

class ContestantReadyModule {
    static withComponents() {
        return {
            ngModule: ContestantReadyModule,
            providers: [
                {
                    provide: ANALYZE_FOR_ENTRY_COMPONENTS,
                    useValue: [],
                    multi: true,
                },
            ],
        };
    }
}
ContestantReadyModule.ɵfac = function ContestantReadyModule_Factory(t) { return new (t || ContestantReadyModule)(); };
ContestantReadyModule.ɵmod = i0.ɵɵdefineNgModule({ type: ContestantReadyModule });
ContestantReadyModule.ɵinj = i0.ɵɵdefineInjector({ providers: [ContestantReadyAlertFactory], imports: [[CommonModule, CommonsErrorModule, CommonsLoadingModule, CommonsDateModule, TranslationModule, RequirementModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ContestantReadyModule, { declarations: [ContestantReadyAlertComponent, ContestantReadyHeaderComponent], imports: [CommonModule, CommonsErrorModule, CommonsLoadingModule, CommonsDateModule, TranslationModule, RequirementModule], exports: [ContestantReadyAlertComponent, ContestantReadyHeaderComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContestantReadyModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, CommonsErrorModule, CommonsLoadingModule, CommonsDateModule, TranslationModule, RequirementModule],
                declarations: [ContestantReadyAlertComponent, ContestantReadyHeaderComponent],
                exports: [ContestantReadyAlertComponent, ContestantReadyHeaderComponent],
                providers: [ContestantReadyAlertFactory],
            }]
    }], null, null); })();

function PlayerReadyPickupComponent_player_ready_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "player-ready", 1);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("userId", ctx_r0.userId)("leagueId", ctx_r0.leagueId);
} }
class PlayerReadyPickupComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        const userTeams$ = this.store.select(getUserTeams).pipe(filter(entryAvailable), map$1(entry => entry.entry), map$1(userTeams => {
            return userTeams.reduce((teams, userTeam) => {
                const isActive = ["honorary_member", "inactive"].indexOf(userTeam.membership.role) === -1;
                if (isActive) {
                    return [...teams, userTeam.team];
                }
                return teams;
            }, []);
        }));
        this.store.dispatch(new LoadParticipantsOnceAction(this.leagueId));
        const participants$ = this.store.select(getLeagueParticipants(this.leagueId)).pipe(filter(entryAvailable), map$1(entry => entry.entry), map$1(participants => getCheckedIn(participants)));
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        const isRoster$ = this.store.select(getLeague(this.leagueId)).pipe(filter(entryAvailable), map$1(entry => entry.entry), map$1(isRosterEnabled));
        this.canBeInvited$ = combineLatest(participants$, userTeams$).pipe(map$1(([participants, teams]) => {
            return teams.find(team => {
                return Boolean(participants.find(participant => +team.id === participant.id));
            });
        }), withLatestFrom(isRoster$), map$1(([team, isRoster]) => Boolean(team && isRoster)));
    }
}
PlayerReadyPickupComponent.ɵfac = function PlayerReadyPickupComponent_Factory(t) { return new (t || PlayerReadyPickupComponent)(i0.ɵɵdirectiveInject(i1$1.Store)); };
PlayerReadyPickupComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PlayerReadyPickupComponent, selectors: [["player-ready-pickup"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 2, vars: 3, consts: [[3, "userId", "leagueId", 4, "ngIf"], [3, "userId", "leagueId"]], template: function PlayerReadyPickupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlayerReadyPickupComponent_player_ready_0_Template, 1, 2, "player-ready", 0);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.canBeInvited$));
    } }, directives: [i2$1.NgIf, PlayerReadyComponent], pipes: [i2$1.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlayerReadyPickupComponent, [{
        type: Component,
        args: [{
                selector: "player-ready-pickup",
                templateUrl: "./player-ready-pickup.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }]; }, { leagueId: [{
            type: Input
        }], userId: [{
            type: Input
        }] }); })();

class PlayerReadyModule {
    static withComponents() {
        return {
            ngModule: PlayerReadyModule,
            providers: [
                {
                    provide: ANALYZE_FOR_ENTRY_COMPONENTS,
                    useValue: [PlayerReadyComponent, PlayerReadyPickupComponent],
                    multi: true,
                },
            ],
        };
    }
}
PlayerReadyModule.ɵfac = function PlayerReadyModule_Factory(t) { return new (t || PlayerReadyModule)(); };
PlayerReadyModule.ɵmod = i0.ɵɵdefineNgModule({ type: PlayerReadyModule });
PlayerReadyModule.ɵinj = i0.ɵɵdefineInjector({ providers: [PlayerReadyComponentConfig], imports: [[
            CommonModule,
            CommonsErrorModule,
            CommonsLoadingModule,
            CommonsDateModule,
            TranslationModule,
            RequirementModule,
            ContestantReadyModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PlayerReadyModule, { declarations: [PlayerReadyComponent, PlayerReadyPickupComponent], imports: [CommonModule,
        CommonsErrorModule,
        CommonsLoadingModule,
        CommonsDateModule,
        TranslationModule,
        RequirementModule,
        ContestantReadyModule], exports: [PlayerReadyComponent, PlayerReadyPickupComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlayerReadyModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    CommonsErrorModule,
                    CommonsLoadingModule,
                    CommonsDateModule,
                    TranslationModule,
                    RequirementModule,
                    ContestantReadyModule,
                ],
                declarations: [PlayerReadyComponent, PlayerReadyPickupComponent],
                exports: [PlayerReadyComponent, PlayerReadyPickupComponent],
                providers: [PlayerReadyComponentConfig],
            }]
    }], null, null); })();

const playerAccountTexts = {};

function PlayerAccountComponent_article_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "article", 1);
    i0.ɵɵelementStart(1, "ul", 2);
    i0.ɵɵelementStart(2, "li", 3);
    i0.ɵɵelementStart(3, "a", 4);
    i0.ɵɵlistener("click", function PlayerAccountComponent_article_0_Template_a_click_3_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); $event.preventDefault(); return ctx_r1.leaveLeague(); });
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 1, "contestant-account:leave-league"), " ");
} }
class PlayerAccountComponent {
    constructor(store, dialogs) {
        this.store = store;
        this.dialogs = dialogs;
    }
    ngOnInit() {
        this.user$ = this.store.select(getUser);
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.contestant$ = this.store.select(getContestant(this.leagueId, this.userId, this.userId));
        this.shouldShowWidget$ = combineLatest(this.isContestantUnfinished, this.isContestant, this.isSignoffEnabled).pipe(map$1(conditions => conditions.filter(x => !x).length === 0));
    }
    leaveLeague() {
        this.dialogs.openLeaveLeagueDialog({
            leagueId: this.leagueId,
            contestantId: this.userId,
        });
    }
    get isContestantUnfinished() {
        return this.contestant$.pipe(map$1(contestant => contestant && !isFinished(contestant)));
    }
    get isContestant() {
        return this.contestant$.pipe(map$1(contestant => contestant && +contestant.id === this.userId));
    }
    get isSignoffEnabled() {
        return this.league$.pipe(map$1(league => league.entry.signOff && league.entry.signOff.enabled));
    }
}
PlayerAccountComponent.ɵfac = function PlayerAccountComponent_Factory(t) { return new (t || PlayerAccountComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject("DialogService")); };
PlayerAccountComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PlayerAccountComponent, selectors: [["league-player-account"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 2, vars: 3, consts: [["class", "c-league-widget__module c-league-contestant-account", 4, "ngIf"], [1, "c-league-widget__module", "c-league-contestant-account"], [1, "c-league-contestant-account__links"], [1, "c-league-contestant-account__links__item"], ["href", "#", 3, "click"]], template: function PlayerAccountComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PlayerAccountComponent_article_0_Template, 6, 3, "article", 0);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.shouldShowWidget$));
    } }, directives: [i2$1.NgIf], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PlayerAccountComponent, [{
        type: Component,
        args: [{
                selector: "league-player-account",
                templateUrl: "./player-account.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

const SignupFlowActionTypes = {
    LOAD_SELECTED_CONTESTANT: type("[Signup Flow] Load Selected Contestant"),
    SELECT_CONTESTANT: type("[Signup Flow] Select Contestant"),
};
class SelectContestantAction {
    constructor(leagueId, contestantId, contestantType) {
        this.leagueId = leagueId;
        this.contestantId = contestantId;
        this.contestantType = contestantType;
        this.type = SignupFlowActionTypes.SELECT_CONTESTANT;
        this.payload = null;
    }
}
class LoadSelectedContestantAction {
    constructor(leagueId) {
        this.leagueId = leagueId;
        this.type = SignupFlowActionTypes.LOAD_SELECTED_CONTESTANT;
        this.payload = null;
    }
}

const reducers$2 = queueReducers([
    (state = Map(), action) => {
        switch (action.type) {
            case SignupFlowActionTypes.SELECT_CONTESTANT:
                const lAction = action;
                return state.set(lAction.leagueId, {
                    contestantId: lAction.contestantId,
                    contestantType: lAction.contestantType,
                });
        }
        return state;
    },
]);
function selectContestantReducer(state, action) {
    return reducers$2(state, action);
}
const getSelectedContestant = (leagueId, contestantType) => {
    return (state$) => {
        const contestantId$ = state$.pipe(distinct(s => {
            const contestant = s.leagueWidget.selectedContestant.get(leagueId);
            if (contestant && contestant.contestantType === contestantType) {
                return contestant.contestantId;
            }
            return undefined;
        }));
        if (contestantType === "player") {
            return contestantId$;
        }
        const contestants$ = state$.pipe(map$1(getUser), filter(entryAvailable), map$1(entry => entry.entry), switchMap(user => state$.pipe(map$1(getContestants(leagueId, +user.id)))));
        return combineLatest(contestantId$, state$.pipe(map$1(getUserTeams)), contestants$).pipe(distinct(([contestantId, userTeams, contestants]) => {
            const userTeam = find(userTeams.entry, (team) => {
                return contestantId === +team.team.id;
            });
            const userContestant = contestants
                ? find(contestants.entry, contestant => {
                    return +contestant.id === contestantId;
                })
                : undefined;
            return userTeam || userContestant ? contestantId : !contestantId ? contestantId : null;
        }));
    };
};

function ContestantListComponent_ul_5_li_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function ContestantListComponent_ul_5_li_1_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const contestant_r4 = ctx.ngIf; const ctx_r5 = i0.ɵɵnextContext(3); return ctx_r5.selectContestant(contestant_r4.id); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const contestant_r4 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", contestant_r4.name, " ");
} }
function ContestantListComponent_ul_5_li_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, ContestantListComponent_ul_5_li_1_button_1_Template, 2, 1, "button", 6);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const contestant_r2 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r1.getTeam(contestant_r2.id)));
} }
function ContestantListComponent_ul_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 4);
    i0.ɵɵtemplate(1, ContestantListComponent_ul_5_li_1_Template, 3, 3, "li", 5);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.contestants);
} }
class ContestantListComponent {
    constructor(store) {
        this.store = store;
        this.select = new EventEmitter();
        this.showDropdown$ = new BehaviorSubject(false);
    }
    toggleDropdown() {
        this.showDropdown$.next(!this.showDropdown$.getValue());
    }
    getTeam(id) {
        return this.store.select(getTeam(+id)).pipe(filter(entryAvailable), map$1(entry => entry.entry));
    }
    selectContestant(id) {
        this.showDropdown$.next(false);
        this.select.emit(+id);
    }
}
ContestantListComponent.ɵfac = function ContestantListComponent_Factory(t) { return new (t || ContestantListComponent)(i0.ɵɵdirectiveInject(i1$1.Store)); };
ContestantListComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ContestantListComponent, selectors: [["contestant-list"]], inputs: { contestants: "contestants", contestantId: "contestantId" }, outputs: { select: "selected" }, decls: 7, vars: 6, consts: [[1, "c-switch-contestant"], [1, "c-switch-contestant__current", "c-button", "c-button--outline", 3, "click"], [1, "c-switch-contestant__current__name"], ["class", "c-switch-contestant__list", 4, "ngIf"], [1, "c-switch-contestant__list"], [4, "ngFor", "ngForOf"], ["class", "c-switch-contestant__entry", 3, "click", 4, "ngIf"], [1, "c-switch-contestant__entry", 3, "click"]], template: function ContestantListComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "button", 1);
        i0.ɵɵlistener("click", function ContestantListComponent_Template_button_click_1_listener() { return ctx.toggleDropdown(); });
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, ContestantListComponent_ul_5_Template, 2, 1, "ul", 3);
        i0.ɵɵpipe(6, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        let tmp_0_0 = null;
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate((tmp_0_0 = i0.ɵɵpipeBind1(4, 2, ctx.getTeam(ctx.contestantId))) == null ? null : tmp_0_0.name);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 4, ctx.showDropdown$));
    } }, directives: [i2$1.NgIf, i2$1.NgForOf], pipes: [i2$1.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContestantListComponent, [{
        type: Component,
        args: [{
                selector: "contestant-list",
                templateUrl: "./contestant-list.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }]; }, { contestants: [{
            type: Input
        }], contestantId: [{
            type: Input
        }], select: [{
            type: Output,
            args: ["selected"]
        }] }); })();

function SwitchContestantComponent_ng_container_0_contestant_list_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "contestant-list", 2);
    i0.ɵɵlistener("selected", function SwitchContestantComponent_ng_container_0_contestant_list_1_Template_contestant_list_selected_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(2); return ctx_r3.switchContestant($event); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const contestants_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("contestants", contestants_r1.entry)("contestantId", i0.ɵɵpipeBind1(1, 2, ctx_r2.selectedContestantId$));
} }
function SwitchContestantComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SwitchContestantComponent_ng_container_0_contestant_list_1_Template, 2, 4, "contestant-list", 1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r0.canSwitchContestant$));
} }
class SwitchContestantComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        this.selectedContestantId$ = this.store.pipe(getSelectedContestant(this.leagueId, "team"), filter(contestantId => Boolean(contestantId)), distinctUntilChanged());
        this.store.dispatch(new LoadContestantsOnceAction(this.leagueId, this.userId));
        this.contestants$ = this.store.select(getContestants(this.leagueId, this.userId));
        this.contestant$ = this.selectedContestantId$.pipe(tap(contestantId => this.store.dispatch(new LoadContestantsOnceAction(this.leagueId, this.userId))), switchMap(contestantId => this.store.select(getContestant(this.leagueId, this.userId, contestantId))));
        this.canSwitchContestant$ = this.canSwitchContestant();
    }
    canSwitchContestant() {
        return combineLatest(this.contestants$, this.selectedContestantId$).pipe(map$1(([contestants, contestantId]) => {
            if (!contestants || !contestants.entry) {
                return false;
            }
            if (contestants.entry.length === 1) {
                return +contestants.entry[0].id !== contestantId;
            }
            return contestants.entry.length > 1;
        }), distinctUntilChanged());
    }
    switchContestant(id) {
        this.store.dispatch(new SelectContestantAction(this.leagueId, +id, "team"));
    }
}
SwitchContestantComponent.ɵfac = function SwitchContestantComponent_Factory(t) { return new (t || SwitchContestantComponent)(i0.ɵɵdirectiveInject(i1$1.Store)); };
SwitchContestantComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SwitchContestantComponent, selectors: [["switch-contestant"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 2, vars: 3, consts: [[4, "ngIf"], [3, "contestants", "contestantId", "selected", 4, "ngIf"], [3, "contestants", "contestantId", "selected"]], template: function SwitchContestantComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SwitchContestantComponent_ng_container_0_Template, 3, 3, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.contestants$));
    } }, directives: [i2$1.NgIf, ContestantListComponent], pipes: [i2$1.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SwitchContestantComponent, [{
        type: Component,
        args: [{
                selector: "switch-contestant",
                templateUrl: "./switch-contestant.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }]; }, { leagueId: [{
            type: Input
        }], userId: [{
            type: Input
        }] }); })();

const teamAccountTexts = {
    "team-account:manage-roster": "Manage Roster",
    "team-account:team-status": "Team Status",
    "team-account:leave-roster": "Leave Roster",
};

function TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_11_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 10);
    i0.ɵɵelementStart(1, "a", 11);
    i0.ɵɵlistener("click", function TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_11_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(4); $event.preventDefault(); return ctx_r9.manageRoster(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "team-account:manage-roster"));
} }
function TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_14_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 10);
    i0.ɵɵelementStart(1, "a", 11);
    i0.ɵɵlistener("click", function TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_14_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(4); $event.preventDefault(); return ctx_r11.openRosterStatus(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "team-account:roster-status"));
} }
function TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_17_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 10);
    i0.ɵɵelementStart(1, "a", 11);
    i0.ɵɵlistener("click", function TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_17_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(4); $event.preventDefault(); return ctx_r13.openTeamStatus(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "team-account:team-status"));
} }
function TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_20_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 10);
    i0.ɵɵelementStart(1, "a", 11);
    i0.ɵɵlistener("click", function TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_20_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(4); $event.preventDefault(); return ctx_r15.leaveRoster(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "team-account:leave-roster"));
} }
function TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_23_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 10);
    i0.ɵɵelementStart(1, "a", 11);
    i0.ɵɵlistener("click", function TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_23_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(4); $event.preventDefault(); return ctx_r17.leaveLeague(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "contestant-account:leave-league"));
} }
function TeamAccountComponent_ng_container_0_ng_container_1_article_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "article", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "div", 4);
    i0.ɵɵelementStart(3, "strong");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6, ": ");
    i0.ɵɵelementStart(7, "a", 5);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "ul", 6);
    i0.ɵɵtemplate(11, TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_11_Template, 4, 3, "li", 7);
    i0.ɵɵpipe(12, "async");
    i0.ɵɵpipe(13, "async");
    i0.ɵɵtemplate(14, TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_14_Template, 4, 3, "li", 7);
    i0.ɵɵpipe(15, "async");
    i0.ɵɵpipe(16, "async");
    i0.ɵɵtemplate(17, TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_17_Template, 4, 3, "li", 7);
    i0.ɵɵpipe(18, "async");
    i0.ɵɵpipe(19, "async");
    i0.ɵɵtemplate(20, TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_20_Template, 4, 3, "li", 7);
    i0.ɵɵpipe(21, "async");
    i0.ɵɵpipe(22, "async");
    i0.ɵɵtemplate(23, TeamAccountComponent_ng_container_0_ng_container_1_article_1_li_23_Template, 4, 3, "li", 7);
    i0.ɵɵpipe(24, "async");
    i0.ɵɵpipe(25, "async");
    i0.ɵɵpipe(26, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 8);
    i0.ɵɵelement(28, "switch-contestant", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const team_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 10, "commons:team"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("locationHref", i0.ɵɵpipeBind1(8, 12, ctx_r3.teamLink$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", team_r2.entry.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(12, 14, ctx_r3.isRosterLeague$) && i0.ɵɵpipeBind1(13, 16, ctx_r3.isTeamManager$));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(15, 18, ctx_r3.isRosterLeague$) && !i0.ɵɵpipeBind1(16, 20, ctx_r3.isTeamManager$));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(18, 22, ctx_r3.isRosterLeague$) && i0.ɵɵpipeBind1(19, 24, ctx_r3.isTeamManager$));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(21, 26, ctx_r3.isRosterLeague$) && i0.ɵɵpipeBind1(22, 28, ctx_r3.isInRoster$));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(24, 30, ctx_r3.isSignoffEnabled$) && i0.ɵɵpipeBind1(25, 32, ctx_r3.isTeamManager$) && i0.ɵɵpipeBind1(26, 34, ctx_r3.isContestant$));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("leagueId", ctx_r3.leagueId)("userId", ctx_r3.userId);
} }
function TeamAccountComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TeamAccountComponent_ng_container_0_ng_container_1_article_1_Template, 29, 36, "article", 1);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const team_r2 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", team_r2.entry);
} }
function TeamAccountComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, TeamAccountComponent_ng_container_0_ng_container_1_Template, 2, 1, "ng-container", 0);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r0.team$));
} }
class TeamAccountComponent {
    constructor(store, links, dialogs) {
        this.store = store;
        this.links = links;
        this.dialogs = dialogs;
    }
    ngOnInit() {
        this.user$ = this.store.select(getUser);
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.isTeamLeague$ = this.league$.pipe(filter(entryAvailable), map$1(league => isTeam(league.entry)));
        this.selectedContestantId$ = this.store.pipe(getSelectedContestant(this.leagueId, "team"), filter(contestantId => Boolean(contestantId)), distinctUntilChanged());
        this.team$ = this.selectedContestantId$.pipe(tap(contestantId => this.store.dispatch(new LoadTeamOnceAction(contestantId))), switchMap(contestantId => this.store.select(getTeam(contestantId))));
        this.contestant$ = this.selectedContestantId$.pipe(tap(contestantId => this.store.dispatch(new LoadContestantsOnceAction(this.leagueId, this.userId))), switchMap(contestantId => this.store.select(getContestant(this.leagueId, this.userId, contestantId))));
        this.roster$ = this.selectedContestantId$.pipe(tap(contestantId => this.store.dispatch(new LoadRosterOnceAction(this.leagueId, contestantId))), switchMap(contestantId => this.store.select(getRoster(this.leagueId, contestantId))));
        this.memberShip$ = this.selectedContestantId$.pipe(switchMap(contestantId => this.store.select(getUserTeams).pipe(map$1(userTeams => {
            const userTeam = find(userTeams.entry, team => {
                return +team.team.id === contestantId;
            });
            return userTeam ? userTeam.membership : null;
        }))));
        this.contestants$ = this.store.select(getContestants(this.leagueId, this.userId));
        this.teamLink$ = this.getTeamLink();
        this.isTeamManager$ = this.getIsTeamManager();
        this.isInRoster$ = this.getIsInRoster();
        this.isContestant$ = this.getIsContestant();
        this.isRosterLeague$ = this.getIsRosterLeague();
        this.isSignoffEnabled$ = this.getIsSignoffEnabled();
    }
    manageRoster() {
        combineLatest(this.selectedContestantId$, this.isContestant$, this.isRosterLeague$)
            .pipe(first())
            .subscribe(([teamId, isContestant, isRosterLeague]) => {
            const scope = { leagueId: this.leagueId, teamId: teamId, isRosterLeague: isRosterLeague };
            if (isContestant) {
                this.dialogs.openRosterSelectDialog(scope);
            }
            else {
                this.dialogs.openRosterPreselectDialog(scope);
            }
        });
    }
    openRosterStatus() {
        combineLatest(this.selectedContestantId$, this.isRosterLeague$)
            .pipe(first())
            .subscribe(([teamId, isRosterLeague]) => {
            this.dialogs.openRosterStatusDialog({
                leagueId: this.leagueId,
                teamId: teamId,
                isRosterLeague: isRosterLeague,
            });
        });
    }
    openTeamStatus() {
        combineLatest(this.selectedContestantId$, this.isRosterLeague$)
            .pipe(first())
            .subscribe(([teamId, isRosterLeague]) => {
            this.dialogs.openTeamManagementDialog({
                leagueId: this.leagueId,
                teamId: teamId,
                isRosterLeague: isRosterLeague,
            });
        });
    }
    leaveLeague() {
        this.selectedContestantId$.pipe(first()).subscribe(teamId => {
            this.dialogs.openLeaveLeagueDialog({
                leagueId: this.leagueId,
                contestantId: teamId,
            });
        });
    }
    leaveRoster() {
        this.selectedContestantId$.pipe(first()).subscribe(teamId => {
            this.dialogs.openLeaveRosterDialog({
                leagueId: this.leagueId,
                teamId: teamId,
            });
        });
    }
    getTeamLink() {
        return this.team$.pipe(filter(entryAvailable), map$1(team => this.links.team(+team.entry.id)), distinctUntilChanged());
    }
    getIsTeamManager() {
        return this.memberShip$.pipe(filter(membership => Boolean(membership)), map$1(membership => ["leader", "co_leader", "matchorga"].indexOf(membership.permission) !== -1), distinctUntilChanged());
    }
    getIsContestant() {
        return combineLatest(this.contestant$, this.selectedContestantId$).pipe(map$1(([contestant, contestantId]) => {
            return contestant && +contestant.id === contestantId;
        }), distinctUntilChanged());
    }
    getIsRosterLeague() {
        return this.league$.pipe(map$1(league => isRosterEnabled(league.entry)), distinctUntilChanged());
    }
    getIsInRoster() {
        return this.roster$.pipe(filter(roster => Boolean(roster && roster.entry)), switchMap(roster => {
            return this.user$.pipe(filter(user => Boolean(user && user.entry)), map$1(user => roster.entry.members.indexOf(+user.entry.id) !== -1));
        }), distinctUntilChanged());
    }
    getIsSignoffEnabled() {
        return this.league$.pipe(map$1(league => league.entry.signOff && league.entry.signOff.enabled), distinctUntilChanged());
    }
}
TeamAccountComponent.ɵfac = function TeamAccountComponent_Factory(t) { return new (t || TeamAccountComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i2.LinkService), i0.ɵɵdirectiveInject("DialogService")); };
TeamAccountComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TeamAccountComponent, selectors: [["league-team-account"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 3, vars: 5, consts: [[4, "ngIf"], ["class", "c-league-widget__module c-league-contestant-account o-media", 4, "ngIf"], [1, "c-league-widget__module", "c-league-contestant-account", "o-media"], [1, "o-media__body"], [1, "c-league-contestant-account__name"], [1, "c-league-contestant-account__name__link", 3, "locationHref"], [1, "c-league-contestant-account__links"], ["class", "c-league-contestant-account__links__item", 4, "ngIf"], [1, "o-media__figure"], [3, "leagueId", "userId"], [1, "c-league-contestant-account__links__item"], ["href", "#", 3, "click"]], template: function TeamAccountComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, TeamAccountComponent_ng_container_0_Template, 3, 3, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵpipe(2, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.isTeamLeague$) && i0.ɵɵpipeBind1(2, 3, ctx.selectedContestantId$));
    } }, directives: [i2$1.NgIf, i2.LocationDirective, SwitchContestantComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TeamAccountComponent, [{
        type: Component,
        args: [{
                selector: "league-team-account",
                templateUrl: "./team-account.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2.LinkService }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

const contestantAccountTexts = {
    "contestant-account:leave-league": "Leave League",
};

function ContestantAccountComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div");
} }
function ContestantAccountComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "league-player-account", 3);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("leagueId", ctx_r2.leagueId)("userId", ctx_r2.userId);
} }
function ContestantAccountComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "league-team-account", 3);
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("leagueId", ctx_r4.leagueId)("userId", ctx_r4.userId);
} }
class ContestantAccountComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.isPlayerLeague$ = this.league$.pipe(filter(entryAvailable), map$1(league => isPlayer(league.entry)));
    }
}
ContestantAccountComponent.ɵfac = function ContestantAccountComponent_Factory(t) { return new (t || ContestantAccountComponent)(i0.ɵɵdirectiveInject(i1$1.Store)); };
ContestantAccountComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ContestantAccountComponent, selectors: [["league-contestant-account"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 6, vars: 5, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["player", ""], ["team", ""], [3, "leagueId", "userId"]], template: function ContestantAccountComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ContestantAccountComponent_div_0_Template, 1, 0, "div", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, ContestantAccountComponent_ng_template_2_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, ContestantAccountComponent_ng_template_4_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        const _r3 = i0.ɵɵreference(5);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 3, ctx.isPlayerLeague$))("ngIfThen", _r1)("ngIfElse", _r3);
    } }, directives: [i2$1.NgIf, PlayerAccountComponent, TeamAccountComponent], pipes: [i2$1.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContestantAccountComponent, [{
        type: Component,
        args: [{
                selector: "league-contestant-account",
                templateUrl: "./contestant-account.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

class ContestantAccountModule {
    static withComponents() {
        return {
            ngModule: ContestantAccountModule,
            providers: [
                {
                    provide: ANALYZE_FOR_ENTRY_COMPONENTS,
                    useValue: [ContestantAccountComponent],
                    multi: true,
                },
            ],
        };
    }
}
ContestantAccountModule.ɵfac = function ContestantAccountModule_Factory(t) { return new (t || ContestantAccountModule)(); };
ContestantAccountModule.ɵmod = i0.ɵɵdefineNgModule({ type: ContestantAccountModule });
ContestantAccountModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[CommonModule, TranslationModule, CommonsErrorModule, CommonsLoadingModule, CommonsDateModule, CommonsLocationModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ContestantAccountModule, { declarations: [PlayerAccountComponent,
        TeamAccountComponent,
        ContestantAccountComponent,
        SwitchContestantComponent,
        ContestantListComponent], imports: [CommonModule, TranslationModule, CommonsErrorModule, CommonsLoadingModule, CommonsDateModule, CommonsLocationModule] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContestantAccountModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TranslationModule, CommonsErrorModule, CommonsLoadingModule, CommonsDateModule, CommonsLocationModule],
                declarations: [
                    PlayerAccountComponent,
                    TeamAccountComponent,
                    ContestantAccountComponent,
                    SwitchContestantComponent,
                    ContestantListComponent,
                ],
                exports: [],
            }]
    }], null, null); })();

const contestantReadyTexts = {
    "contestant-ready:ready": "{team, select, 1{Team is ready} other{You are ready}}",
    "contestant-ready:not-ready": "{team, select, 1{Team is not ready} other{You are not ready}}",
    "contestant-ready:too-many-pps-until": "Too many pps until {until}",
    "contestant-ready:banned-until": "Banned until {until}",
    "contestant-ready:barred-until": "Barred until {until}",
};

const vendorTeamNoticeTexts = {
    "vendor-team-notice:description": "Managing the roster of a PlayStation team is only possible through the PlayStation dashboard",
};

function VendorTeamNoticeComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "article", 1);
    i0.ɵɵelementStart(2, "p", 2);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "vendor-team-notice:description"), " ");
} }
class VendorTeamNoticeComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        const isTeamEmpty$ = this.store.pipe(getSelectedContestant(this.leagueId, "team"), filter(exists), switchMap(teamId => this.store.select(getTeam(teamId))), filter(entryAvailable), distinct(team => !team.entry.memberCount));
        const isRosterLeague$ = this.store.select(getLeague(this.leagueId)).pipe(filter(entryAvailable), distinct(league => isRosterEnabled(league.entry)));
        this.shouldDisplay$ = combineLatest(isTeamEmpty$, isRosterLeague$).pipe(distinct(data => data.filter(Boolean).length === 2));
    }
}
VendorTeamNoticeComponent.ɵfac = function VendorTeamNoticeComponent_Factory(t) { return new (t || VendorTeamNoticeComponent)(i0.ɵɵdirectiveInject(i1$1.Store)); };
VendorTeamNoticeComponent.ɵcmp = i0.ɵɵdefineComponent({ type: VendorTeamNoticeComponent, selectors: [["vendor-team-notice"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 2, vars: 3, consts: [[4, "ngIf"], [1, "c-league-widget__module", "c-league-widget__module--warning"], [1, "c-league-widget__module__description"]], template: function VendorTeamNoticeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, VendorTeamNoticeComponent_ng_container_0_Template, 5, 3, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.shouldDisplay$));
    } }, directives: [i2$1.NgIf], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VendorTeamNoticeComponent, [{
        type: Component,
        args: [{
                selector: "vendor-team-notice",
                templateUrl: "./vendor-team-notice.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }]; }, { leagueId: [{
            type: Input
        }], userId: [{
            type: Input
        }] }); })();

const signupFlowTexts = {
    "signup-flow:select-team": "Select team",
    "signup-flow:change-team-description": "You can also sign up with a different " + "team or create a new team.",
    "signup-flow:phase-starts-in": "Starts in {date}",
    "signup-flow:you-are-not-ready": "{isTeam, select, 0{You are} other{Your team is}} not ready.",
    // Setup
    "signup-flow:setup": "Tournament is being setup",
    "signup-flow:setup-description": "Come back later or look for other tournaments to play in.",
    // Sign Up
    "signup-flow:signup-description": "{eligible, select, 0{{hasCheckIn, select, " +
        "0{You can sign up now but you must be ready to play before the tournament starts otherwise you will be removed.} " +
        "other{You can sign up now but you must be ready to play to be able to check in later.}}} other{}}",
    "signup-flow:signup-closed-description": "It is no longer possible to sign up for this tournament",
    "signup-flow:signup-opens-description": "Sign up has not opened yet",
    "signup-flow:signup-pending": "Please wait for your sign up to be checked and accepted by an admin.",
    "signup-flow:signup-closed-at": "Sign up closed at {date}.",
    "signup-flow:signup-opens-at": "Sign up opens at {date}.",
    "signup-flow:signup-opens-in": "Sign up opens in {date}.",
    "signup-flow:signup-closes-at": "Sign up closes at {date}.",
    "signup-flow:signup-closes-in": "Sign up closes in {date}.",
    // Checkin
    "signup-flow:checkin-description": "{eligible, select, " +
        "0{Make sure that {isTeam, select, 0{you are} other{your team is}} ready otherwise you can't check in.} " +
        "other{You are able to check in once the check in phase starts.}" +
        "}",
    "signup-flow:checkin-closed-description": "Check in has closed.",
    "signup-flow:checkin-opens-description": "Check in has not opened yet.",
    "signup-flow:checkin-closed-at": "Check in closed at {date}.",
    "signup-flow:checkin-opens-at": "Check in opens at {date}.",
    "signup-flow:checkin-opens-in": "Check in opens in {date}.",
    "signup-flow:checkin-closes-at": "Check in closes at {date}.",
    "signup-flow:checkin-closes-in": "Check in closes in {date}.",
    "signup-flow:checked-in": "{hasCheckIn, select, 1{You have successfully checked in to the tournament. " +
        "Please wait for the tournament to start.} " +
        "other{You have successfully signed up to the tournament. " +
        "{eligible, select, 0{{isTeam, select, 0{You} other{Your team}} " +
        "must be ready when the tournament starts otherwise you will be removed.} other{}}}}",
    // Late Sign Up
    "signup-flow:late-signup-description": "Hurry up! Late sign up will close soon. You will not need to check in afterwards.",
    "signup-flow:late-signup-closed-description": "Late sign up has closed. It is no longer possible to sign up for this tournament.",
    "signup-flow:late-signup-opens-description": "Late sign up has not opened yet.",
    "signup-flow:late-signup-disabled": "Early sign-ups can check in now. It is no longer possible to sign up for this tournament.",
    "signup-flow:late-signup-closed-at": "Late sign up closed at {date}.",
    "signup-flow:late-signup-opens-at": "Late sign up opens at {date}.",
    "signup-flow:late-signup-opens-in": "Late sign up opens in {date}.",
    "signup-flow:late-signup-closes-at": "Late sign up closes at {date}.",
    "signup-flow:late-signup-closes-in": "Late sign up closes in {date}.",
    // In Progress
    "signup-flow:in-progress": "Tournament already in progress",
    "signup-flow:in-progress-description": "Check out the results or look for other tournaments to play in.",
};

const moment$2 = momentImported;
const mapStateToPrefix = (state) => {
    switch (state) {
        case "signUp":
            return "signup";
        case "lateSignUp":
            return "late-signup";
        case "checkIn":
            return "checkin";
        case "inProgress":
            return "in-progress";
        case "lateCheckin":
            return "late-checkin";
        default:
            return null;
    }
};
class TimelineHelper {
    constructor(timeFormatter, dateFormatter, translate, config) {
        this.timeFormatter = timeFormatter;
        this.dateFormatter = dateFormatter;
        this.translate = translate;
        this.config = config;
        this.thresholdHumanReadable = 28800;
    }
    /**
     * @param begin
     */
    hasAlreadyStarted(begin) {
        const now = moment$2();
        const beginDate = moment$2(begin);
        return now.diff(beginDate) >= 0;
    }
    /**
     * @param end
     */
    hasAlreadyEnded(end) {
        const now = moment$2();
        const endDate = moment$2(end);
        return endDate.diff(now) < 0;
    }
    /**
     * @param future
     */
    getSecondTimeDiff(future) {
        return (new Date(future).getTime() - new Date().getTime()) / 1000;
    }
    /**
     *
     * @param begin
     * @param end
     * @param timezone
     * @param prefix
     */
    getTimelineText(begin, end, timezone, prefix) {
        if (end && this.hasAlreadyEnded(end)) {
            return this.translate.translate(`signup-flow:${prefix}-closed-at`, {
                date: this.dateFormatter.formatDateTime(end, { timezone, showTimezone: false }),
            });
        }
        if (begin && !this.hasAlreadyStarted(begin)) {
            const beginTimeDiff = this.getSecondTimeDiff(begin);
            if (beginTimeDiff > this.thresholdHumanReadable) {
                return this.translate.translate(`signup-flow:${prefix}-opens-at`, {
                    date: this.dateFormatter.formatDateTime(begin, { timezone, showTimezone: false }),
                });
            }
            return this.translate.translate(`signup-flow:${prefix}-opens-in`, {
                date: this.timeFormatter.formatForHumans(Math.max(0, beginTimeDiff)),
            });
        }
        if (!end) {
            return null;
        }
        const endTimeDiff = this.getSecondTimeDiff(end);
        if (endTimeDiff > this.thresholdHumanReadable) {
            return this.translate.translate(`signup-flow:${prefix}-closes-at`, {
                date: this.dateFormatter.formatDateTime(end, { timezone, showTimezone: false }),
            });
        }
        return this.translate.translate(`signup-flow:${prefix}-closes-in`, {
            date: this.timeFormatter.formatForHumans(Math.max(0, endTimeDiff)),
        });
    }
    /**
     * @param league
     * @param timezone
     * @param states
     */
    getCountdownOfTimeline(league, timezone, states) {
        const statesHasLateCheckIn = states.indexOf("lateCheckin") !== -1;
        states = states.map(response => (response === "lateCheckin" ? "lateSignUp" : response));
        if (!league.timeline) {
            return null;
        }
        const countdownData = states.reduce((current, state) => {
            if (current.end && !this.hasAlreadyEnded(current.end)) {
                return current;
            }
            if (current.begin && !this.hasAlreadyEnded(current.begin)) {
                return current;
            }
            if (!league.timeline[state]) {
                return current;
            }
            return Object.assign(Object.assign({}, current), { state: state, begin: league.timeline[state].begin, end: league.timeline[state].end });
        }, { begin: null, end: null, state: null });
        if (countdownData.state) {
            if (statesHasLateCheckIn) {
                countdownData.state = "lateCheckin";
            }
            const { begin, end } = countdownData;
            let date = "";
            if (end) {
                date = end;
            }
            if (!this.hasAlreadyStarted(begin)) {
                date = begin;
            }
            if (date) {
                date = this.dateFormatter.getFullDateTimeTz(date);
            }
            return {
                text: this.getTimelineText(begin, end, timezone, mapStateToPrefix(countdownData.state)),
                date,
            };
        }
        return null;
    }
}
TimelineHelper.ɵfac = function TimelineHelper_Factory(t) { return new (t || TimelineHelper)(i0.ɵɵinject(i2.FormatTime), i0.ɵɵinject(i2.FormatDate), i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(BASE_CONFIG)); };
TimelineHelper.ɵprov = i0.ɵɵdefineInjectable({ token: TimelineHelper, factory: TimelineHelper.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimelineHelper, [{
        type: Injectable
    }], function () { return [{ type: i2.FormatTime }, { type: i2.FormatDate }, { type: i1.TranslateService }, { type: undefined, decorators: [{
                type: Inject,
                args: [BASE_CONFIG]
            }] }]; }, null); })();

function SignupFlowComponent_play_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "play-button", 5);
    i0.ɵɵlistener("clicked", function SignupFlowComponent_play_button_3_Template_play_button_clicked_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.clicked.emit(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r0.isDisabled)("loading", ctx_r0.isLoading);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.buttonLabel, " ");
} }
function SignupFlowComponent_time_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "time", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tooltip", ctx_r1.hintLabel.date);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.hintLabel.text, " ");
} }
const _c0$h = ["*"];
class SignupFlowComponent {
    constructor() {
        this.clicked = new EventEmitter();
    }
}
SignupFlowComponent.ɵfac = function SignupFlowComponent_Factory(t) { return new (t || SignupFlowComponent)(); };
SignupFlowComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SignupFlowComponent, selectors: [["signup-flow"]], inputs: { buttonLabel: ["button", "buttonLabel"], hintLabel: ["hint", "hintLabel"], isDisabled: ["disabled", "isDisabled"], isLoading: ["loading", "isLoading"] }, outputs: { clicked: "clicked" }, ngContentSelectors: _c0$h, decls: 6, vars: 2, consts: [[1, "c-league-widget__module", "c-league-widget__module--highlight"], [1, "c-league-widget__module__description"], ["class", "c-button--primary c-button--gigantic c-button--block", 3, "disabled", "loading", "clicked", 4, "ngIf"], [1, "hintLabel"], ["class", "c-league-widget__module__hint", 3, "tooltip", 4, "ngIf"], [1, "c-button--primary", "c-button--gigantic", "c-button--block", 3, "disabled", "loading", "clicked"], [1, "c-league-widget__module__hint", 3, "tooltip"]], template: function SignupFlowComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "p", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, SignupFlowComponent_play_button_3_Template, 2, 3, "play-button", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, SignupFlowComponent_time_5_Template, 2, 2, "time", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.buttonLabel);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.hintLabel);
    } }, directives: [i2$1.NgIf, i2.ButtonComponent, i2.TooltipDirective], styles: [".hintLabel[_ngcontent-%COMP%] {\n                position: relative;\n            }"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignupFlowComponent, [{
        type: Component,
        args: [{
                selector: "signup-flow",
                templateUrl: "./signup-flow.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [
                    `
            .hintLabel {
                position: relative;
            }
        `,
                ],
            }]
    }], null, { buttonLabel: [{
            type: Input,
            args: ["button"]
        }], hintLabel: [{
            type: Input,
            args: ["hint"]
        }], isDisabled: [{
            type: Input,
            args: ["disabled"]
        }], isLoading: [{
            type: Input,
            args: ["loading"]
        }], clicked: [{
            type: Output,
            args: ["clicked"]
        }] }); })();

function SignupFlowTransitionComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.nextPhaseStart);
} }
const _c0$g = ["*"];
class SignupFlowTransitionComponent {
}
SignupFlowTransitionComponent.ɵfac = function SignupFlowTransitionComponent_Factory(t) { return new (t || SignupFlowTransitionComponent)(); };
SignupFlowTransitionComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SignupFlowTransitionComponent, selectors: [["signup-flow-transition"]], inputs: { nextPhaseStart: ["hint", "nextPhaseStart"] }, ngContentSelectors: _c0$g, decls: 4, vars: 1, consts: [[1, "c-league-widget__module", "c-league-widget__module--highlight"], [1, "c-league-widget__module__description"], ["class", "c-league-widget__module__hint", 4, "ngIf"], [1, "c-league-widget__module__hint"]], template: function SignupFlowTransitionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "p", 1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, SignupFlowTransitionComponent_div_3_Template, 2, 1, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.nextPhaseStart);
    } }, directives: [i2$1.NgIf], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignupFlowTransitionComponent, [{
        type: Component,
        args: [{
                selector: "signup-flow-transition",
                templateUrl: "./signup-flow-transition.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { nextPhaseStart: [{
            type: Input,
            args: ["hint"]
        }] }); })();

const PreSelectionActionTypes = {
    RESET_ROSTER: type("[Preselect Roster] Reset"),
    LOAD_ROSTER: type("[Preselect Roster] Load"),
    LOAD_ROSTER_COMPLETE: type("[Preselect Roster] Load Complete"),
    SET_ROSTER: type("[Preselect Roster] Set"),
};
class LoadRosterAction {
    constructor(leagueId, teamId) {
        this.leagueId = leagueId;
        this.teamId = teamId;
        this.type = PreSelectionActionTypes.LOAD_ROSTER;
        this.payload = null;
    }
}
class LoadRosterCompleteAction {
    constructor(leagueId, teamId, payload) {
        this.leagueId = leagueId;
        this.teamId = teamId;
        this.payload = payload;
        this.type = PreSelectionActionTypes.LOAD_ROSTER_COMPLETE;
    }
}
class ResetRosterAction {
    constructor(leagueId, teamId) {
        this.leagueId = leagueId;
        this.teamId = teamId;
        this.payload = null;
        this.type = PreSelectionActionTypes.RESET_ROSTER;
    }
}
class SetRosterAction {
    constructor(leagueId, teamId, members) {
        this.leagueId = leagueId;
        this.teamId = teamId;
        this.members = members;
        this.payload = null;
        this.type = PreSelectionActionTypes.SET_ROSTER;
    }
}

const reducers$1 = queueReducers([
    (state = {}, action) => {
        if (action.type === PreSelectionActionTypes.LOAD_ROSTER) {
            const laction = action;
            const newstate = Object.assign({}, state);
            if (!newstate[laction.leagueId]) {
                newstate[laction.leagueId] = {};
            }
            if (!newstate[laction.leagueId][laction.teamId]) {
                newstate[laction.leagueId][laction.teamId] = [];
            }
            return newstate;
        }
        if (action.type === PreSelectionActionTypes.LOAD_ROSTER_COMPLETE) {
            const laction = action;
            const newstate = Object.assign({}, state);
            if (!newstate[laction.leagueId]) {
                newstate[laction.leagueId] = {};
            }
            newstate[laction.leagueId][laction.teamId] = laction.payload;
            return newstate;
        }
        if (action.type === PreSelectionActionTypes.RESET_ROSTER) {
            const laction = action;
            if (state[laction.leagueId] && state[laction.leagueId][laction.teamId]) {
                const newstate = Object.assign({}, state);
                newstate[laction.leagueId][laction.teamId] = [];
                return newstate;
            }
            return state;
        }
        if (action.type === PreSelectionActionTypes.SET_ROSTER) {
            const laction = action;
            const newstate = Object.assign({}, state);
            if (!newstate[laction.leagueId]) {
                newstate[laction.leagueId] = {};
            }
            newstate[laction.leagueId][laction.teamId] = laction.members;
            return newstate;
        }
        return state;
    },
]);
function preSelectionReducer(state, action) {
    return reducers$1(state, action);
}
function getRosterMemberState(state) {
    return state.leagueWidget.preSelectRoster;
}
const getRosterMembers = (leagueId, teamId) => {
    return (state) => {
        const rosterState = getRosterMemberState(state);
        return rosterState[leagueId] ? rosterState[leagueId][teamId] : [];
    };
};

const isContestantEligible = (leagueId, contestantId) => {
    const eligibilityService = new EligiblityService(new RestrictionTransformerService(new RestrictionFilterService(), new PlayCountryNames()));
    return (state$) => {
        const contestantData = merge(state$.pipe(distinct(getTeam(contestantId)), filter(Boolean)), state$.pipe(distinct(getPlayer(contestantId)), filter(Boolean)));
        const isContestant$ = state$.pipe(distinct(getUser), filter(entryAvailable), switchMap(user => state$.pipe(distinct(getContestant(leagueId, +user.entry.id, contestantId)))), map$1(Boolean));
        return combineLatest(state$.pipe(distinct(getLeague(leagueId))), state$.pipe(distinct(getLeagueRestrictions(leagueId, contestantId))), state$.pipe(distinct(getRoster(leagueId, contestantId))), state$.pipe(distinct(getRosterMembers(leagueId, contestantId))), contestantData, isContestant$).pipe(distinct(([league, restrictionState, roster, preselectedRoster, selectedContestant, isContestant]) => {
            if (!restrictionState || restrictionState.error || !restrictionState.entry) {
                return false;
            }
            if (!league || league.error || !league.entry) {
                return false;
            }
            if (!selectedContestant || selectedContestant.error || !selectedContestant.entry) {
                return false;
            }
            let rosterMembers;
            if (roster && roster.entry && isContestant) {
                rosterMembers = roster.entry.members;
            }
            else if (preselectedRoster && preselectedRoster.length) {
                rosterMembers = preselectedRoster;
            }
            else {
                rosterMembers = [];
            }
            return eligibilityService.isEligible(league.entry, restrictionState.entry, selectedContestant.entry, rosterMembers);
        }));
    };
};

function SelectTeamComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "signup-flow", 1);
    i0.ɵɵlistener("clicked", function SelectTeamComponent_ng_container_0_Template_signup_flow_clicked_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); return ctx_r1.selectTeam(); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("button", i0.ɵɵpipeBind1(2, 3, "signup-flow:select-team"))("hint", i0.ɵɵpipeBind1(3, 5, ctx_r0.countdown$));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, "signup-flow:select-team-description"), " ");
} }
class SelectTeamComponent {
    constructor(timelineHelper, store, dialogs) {
        this.timelineHelper = timelineHelper;
        this.store = store;
        this.dialogs = dialogs;
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.isTeamLeague$ = this.league$.pipe(filter(entryAvailable), map$1(league => isTeam(league.entry)));
        this.user$ = this.store.select(getUser);
        this.selectedContestantId$ = this.store.pipe(getSelectedContestant(this.leagueId, "team"));
        const countdownInterval = interval(1000).pipe(startWith(0));
        this.countdown$ = combineLatest(countdownInterval, this.league$, this.user$).pipe(map$1(([, league, user]) => {
            return this.timelineHelper.getCountdownOfTimeline(league.entry, user.entry.timezone, ["signUp", "lateSignUp"]);
        }));
    }
    selectTeam() {
        this.dialogs.openTeamSelectDialog({ leagueId: this.leagueId }).then(teamId => {
            this.store.dispatch(new SelectContestantAction(this.leagueId, teamId, "team"));
        });
    }
}
SelectTeamComponent.ɵfac = function SelectTeamComponent_Factory(t) { return new (t || SelectTeamComponent)(i0.ɵɵdirectiveInject(TimelineHelper), i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject("DialogService")); };
SelectTeamComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SelectTeamComponent, selectors: [["select-team"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 3, vars: 5, consts: [[4, "ngIf"], [3, "button", "hint", "clicked"]], template: function SelectTeamComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SelectTeamComponent_ng_container_0_Template, 6, 9, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵpipe(2, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.isTeamLeague$) && !i0.ɵɵpipeBind1(2, 3, ctx.selectedContestantId$));
    } }, directives: [i2$1.NgIf, SignupFlowComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectTeamComponent, [{
        type: Component,
        args: [{
                selector: "select-team",
                templateUrl: "./select-team.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: TimelineHelper }, { type: i1$1.Store }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

const _c0$f = function (a0) { return { isTeam: a0 }; };
function YouAreReadyTextComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "strong");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 1, "signup-flow:you-are-not-ready", i0.ɵɵpureFunction1(4, _c0$f, ctx_r0.isTeam ? 1 : 0)));
} }
class YouAreReadyTextComponent {
}
YouAreReadyTextComponent.ɵfac = function YouAreReadyTextComponent_Factory(t) { return new (t || YouAreReadyTextComponent)(); };
YouAreReadyTextComponent.ɵcmp = i0.ɵɵdefineComponent({ type: YouAreReadyTextComponent, selectors: [["you-are-ready-text"]], inputs: { eligible: "eligible", isTeam: "isTeam" }, decls: 1, vars: 1, consts: [["class", "c-league-widget__module__ready", 4, "ngIf"], [1, "c-league-widget__module__ready"]], template: function YouAreReadyTextComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, YouAreReadyTextComponent_div_0_Template, 4, 6, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.eligible);
    } }, directives: [i2$1.NgIf], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(YouAreReadyTextComponent, [{
        type: Component,
        args: [{
                selector: "you-are-ready-text",
                templateUrl: "./you-are-ready-text.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { eligible: [{
            type: Input
        }], isTeam: [{
            type: Input
        }] }); })();

const _c0$e = function (a0, a1, a2) { return { isTeam: a0, eligible: a1, hasCheckIn: a2 }; };
class StateClosedTextComponent {
}
StateClosedTextComponent.ɵfac = function StateClosedTextComponent_Factory(t) { return new (t || StateClosedTextComponent)(); };
StateClosedTextComponent.ɵcmp = i0.ɵɵdefineComponent({ type: StateClosedTextComponent, selectors: [["state-closed-text"]], inputs: { state: "state", eligible: "eligible", isTeam: "isTeam", hasCheckIn: "hasCheckIn" }, decls: 2, vars: 8, template: function StateClosedTextComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtext(0);
        i0.ɵɵpipe(1, "translate");
    } if (rf & 2) {
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(1, 1, "signup-flow:" + ctx.state + "-closed-description", i0.ɵɵpureFunction3(4, _c0$e, ctx.isTeam ? 1 : 0, ctx.eligible ? 1 : 0, ctx.hasCheckIn ? 1 : 0)));
    } }, pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StateClosedTextComponent, [{
        type: Component,
        args: [{
                selector: "state-closed-text",
                templateUrl: "./state-closed-text.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { state: [{
            type: Input
        }], eligible: [{
            type: Input
        }], isTeam: [{
            type: Input
        }], hasCheckIn: [{
            type: Input
        }] }); })();

const _c0$d = function (a0, a1, a2) { return { isTeam: a0, eligible: a1, hasCheckIn: a2 }; };
class StateOpensTextComponent {
}
StateOpensTextComponent.ɵfac = function StateOpensTextComponent_Factory(t) { return new (t || StateOpensTextComponent)(); };
StateOpensTextComponent.ɵcmp = i0.ɵɵdefineComponent({ type: StateOpensTextComponent, selectors: [["state-opens-text"]], inputs: { state: "state", eligible: "eligible", isTeam: "isTeam", hasCheckIn: "hasCheckIn" }, decls: 2, vars: 8, template: function StateOpensTextComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtext(0);
        i0.ɵɵpipe(1, "translate");
    } if (rf & 2) {
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(1, 1, "signup-flow:" + ctx.state + "-opens-description", i0.ɵɵpureFunction3(4, _c0$d, ctx.isTeam ? 1 : 0, ctx.eligible ? 1 : 0, ctx.hasCheckIn ? 1 : 0)));
    } }, pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StateOpensTextComponent, [{
        type: Component,
        args: [{
                selector: "state-opens-text",
                templateUrl: "./state-opens-text.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { state: [{
            type: Input
        }], eligible: [{
            type: Input
        }], isTeam: [{
            type: Input
        }], hasCheckIn: [{
            type: Input
        }] }); })();

function StateOpenTextComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "signup-flow:ineligible-live-signup-description"), "\n");
} }
const _c0$c = function (a0, a1, a2) { return { isTeam: a0, eligible: a1, hasCheckIn: a2 }; };
function StateOpenTextComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(1, 1, "signup-flow:" + ctx_r2.state + "-description", i0.ɵɵpureFunction3(4, _c0$c, ctx_r2.isTeam ? 1 : 0, ctx_r2.eligible ? 1 : 0, ctx_r2.hasCheckIn ? 1 : 0)), "\n");
} }
class StateOpenTextComponent {
}
StateOpenTextComponent.ɵfac = function StateOpenTextComponent_Factory(t) { return new (t || StateOpenTextComponent)(); };
StateOpenTextComponent.ɵcmp = i0.ɵɵdefineComponent({ type: StateOpenTextComponent, selectors: [["state-open-text"]], inputs: { state: "state", eligible: "eligible", isTeam: "isTeam", hasCheckIn: "hasCheckIn", isLive: "isLive" }, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["default", ""]], template: function StateOpenTextComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, StateOpenTextComponent_span_0_Template, 3, 3, "span", 0);
        i0.ɵɵtemplate(1, StateOpenTextComponent_ng_template_1_Template, 2, 8, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.state === "signup" && ctx.isLive && !ctx.eligible)("ngIfElse", _r1);
    } }, directives: [i2$1.NgIf], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StateOpenTextComponent, [{
        type: Component,
        args: [{
                selector: "state-open-text",
                templateUrl: "./state-open-text.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { state: [{
            type: Input
        }], eligible: [{
            type: Input
        }], isTeam: [{
            type: Input
        }], hasCheckIn: [{
            type: Input
        }], isLive: [{
            type: Input
        }] }); })();

function StateTextComponent_state_closed_text_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "state-closed-text", 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("state", ctx_r0.state)("hasCheckIn", ctx_r0.hasCheckIn)("eligible", ctx_r0.eligible)("isTeam", ctx_r0.isTeam);
} }
function StateTextComponent_state_opens_text_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "state-opens-text", 3);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("state", ctx_r1.state)("hasCheckIn", ctx_r1.hasCheckIn)("eligible", ctx_r1.eligible)("isTeam", ctx_r1.isTeam);
} }
function StateTextComponent_div_3_state_open_text_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "state-open-text", 5);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("state", ctx_r3.state)("hasCheckIn", ctx_r3.hasCheckIn)("eligible", ctx_r3.eligible)("isTeam", ctx_r3.isTeam)("isLive", ctx_r3.isLive);
} }
function StateTextComponent_div_3_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "signup-flow:signup-full"));
} }
function StateTextComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, StateTextComponent_div_3_state_open_text_1_Template, 1, 5, "state-open-text", 4);
    i0.ɵɵtemplate(2, StateTextComponent_div_3_div_2_Template, 3, 3, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r2.full);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.full);
} }
class StateTextComponent {
}
StateTextComponent.ɵfac = function StateTextComponent_Factory(t) { return new (t || StateTextComponent)(); };
StateTextComponent.ɵcmp = i0.ɵɵdefineComponent({ type: StateTextComponent, selectors: [["state-text"]], inputs: { state: "state", closed: "closed", opens: "opens", eligible: "eligible", isTeam: "isTeam", hasCheckIn: "hasCheckIn", full: "full", isLive: "isLive" }, decls: 4, vars: 5, consts: [[3, "eligible", "isTeam"], [3, "state", "hasCheckIn", "eligible", "isTeam", 4, "ngIf"], [4, "ngIf"], [3, "state", "hasCheckIn", "eligible", "isTeam"], [3, "state", "hasCheckIn", "eligible", "isTeam", "isLive", 4, "ngIf"], [3, "state", "hasCheckIn", "eligible", "isTeam", "isLive"]], template: function StateTextComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "you-are-ready-text", 0);
        i0.ɵɵtemplate(1, StateTextComponent_state_closed_text_1_Template, 1, 4, "state-closed-text", 1);
        i0.ɵɵtemplate(2, StateTextComponent_state_opens_text_2_Template, 1, 4, "state-opens-text", 1);
        i0.ɵɵtemplate(3, StateTextComponent_div_3_Template, 3, 2, "div", 2);
    } if (rf & 2) {
        i0.ɵɵproperty("eligible", ctx.eligible)("isTeam", ctx.isTeam);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.closed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.opens);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.closed && !ctx.opens);
    } }, directives: [YouAreReadyTextComponent, i2$1.NgIf, StateClosedTextComponent, StateOpensTextComponent, StateOpenTextComponent], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StateTextComponent, [{
        type: Component,
        args: [{
                selector: "state-text",
                templateUrl: "./state-text.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { state: [{
            type: Input
        }], closed: [{
            type: Input
        }], opens: [{
            type: Input
        }], eligible: [{
            type: Input
        }], isTeam: [{
            type: Input
        }], hasCheckIn: [{
            type: Input
        }], full: [{
            type: Input
        }], isLive: [{
            type: Input
        }] }); })();

class SignupLeagueDisabledComponent {
}
SignupLeagueDisabledComponent.ɵfac = function SignupLeagueDisabledComponent_Factory(t) { return new (t || SignupLeagueDisabledComponent)(); };
SignupLeagueDisabledComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SignupLeagueDisabledComponent, selectors: [["signup-league-disabled"]], decls: 4, vars: 3, consts: [[1, "c-league-widget__module", "c-league-widget__module--highlight"], [1, "c-league-widget__module__description"]], template: function SignupLeagueDisabledComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "p", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "signup-flow:signup-disabled"), " ");
    } }, pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignupLeagueDisabledComponent, [{
        type: Component,
        args: [{
                selector: "signup-league-disabled",
                templateUrl: "./signup-league-disabled.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

function SignupLeagueComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div");
} }
function SignupLeagueComponent_ng_template_2_signup_flow_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "signup-flow", 5);
    i0.ɵɵlistener("clicked", function SignupLeagueComponent_ng_template_2_signup_flow_1_Template_signup_flow_clicked_0_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.signup(); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelement(6, "state-text", 6);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵpipe(10, "async");
    i0.ɵɵpipe(11, "async");
    i0.ɵɵpipe(12, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const league_r6 = ctx.ngIf;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("button", i0.ɵɵpipeBind1(1, 11, "commons:signup"))("hint", i0.ɵɵpipeBind1(2, 13, ctx_r5.countdown$))("disabled", !i0.ɵɵpipeBind1(3, 15, ctx_r5.stateTimeframe$) || !i0.ɵɵpipeBind1(4, 17, ctx_r5.eligible$) && i0.ɵɵpipeBind1(5, 19, ctx_r5.stateTimeframe$));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("state", "signup")("closed", i0.ɵɵpipeBind1(7, 21, ctx_r5.stateClosed$))("opens", i0.ɵɵpipeBind1(8, 23, ctx_r5.stateOpens$))("full", i0.ɵɵpipeBind1(9, 25, ctx_r5.stateFull$))("eligible", i0.ɵɵpipeBind1(10, 27, ctx_r5.eligible$))("isTeam", i0.ɵɵpipeBind1(11, 29, ctx_r5.isTeamLeague$))("isLive", i0.ɵɵpipeBind1(12, 31, ctx_r5.stateTimeframe$))("hasCheckIn", league_r6.entry.timeline == null ? null : league_r6.entry.timeline.checkIn == null ? null : league_r6.entry.timeline.checkIn.begin);
} }
function SignupLeagueComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "select-team", 3);
    i0.ɵɵtemplate(1, SignupLeagueComponent_ng_template_2_signup_flow_1_Template, 13, 33, "signup-flow", 4);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("leagueId", ctx_r2.leagueId)("userId", ctx_r2.userId);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 3, ctx_r2.contestant$) && i0.ɵɵpipeBind1(3, 5, ctx_r2.league$));
} }
function SignupLeagueComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "signup-league-disabled");
} }
class SignupLeagueComponent {
    constructor(timelineHelper, store, dialogs) {
        this.timelineHelper = timelineHelper;
        this.store = store;
        this.dialogs = dialogs;
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.user$ = this.store.select(getUser);
        this.isTeamLeague$ = this.league$.pipe(filter(entryAvailable), map$1(league => isTeam(league.entry)));
        this.contestant$ = this.league$.pipe(switchMap(league => {
            return this.store.pipe(getSelectedContestant(this.leagueId, isPlayer(league.entry) ? "player" : "team"));
        }));
        this.eligible$ = this.contestant$.pipe(switchMap(contestantId => {
            return this.store.pipe(isContestantEligible(this.leagueId, contestantId));
        }));
        const countdownInterval = interval(1000).pipe(startWith(0));
        this.stateOpens$ = combineLatest(countdownInterval, this.league$).pipe(map$1(([, league]) => {
            if (league.entry.timeline && league.entry.timeline.signUp) {
                const begin = league.entry.timeline.signUp.begin;
                return !this.timelineHelper.hasAlreadyStarted(begin);
            }
            return false;
        }));
        this.stateClosed$ = combineLatest(countdownInterval, this.league$).pipe(map$1(([, league]) => {
            if (league.entry.timeline && league.entry.timeline.signUp) {
                const end = league.entry.timeline.signUp.end;
                return this.timelineHelper.hasAlreadyEnded(end);
            }
            return false;
        }));
        this.stateFull$ = combineLatest(countdownInterval, this.league$).pipe(map$1(([, { entry: { contestants: { maxSignedUp, signedUp }, }, },]) => !!maxSignedUp && maxSignedUp <= signedUp));
        this.stateTimeframe$ = combineLatest(this.stateOpens$, this.stateClosed$, this.stateFull$).pipe(map$1(([opens, closed, full]) => !opens && !closed && !full));
        this.countdown$ = combineLatest(countdownInterval, this.league$, this.user$).pipe(map$1(([, league, user]) => {
            return this.timelineHelper.getCountdownOfTimeline(league.entry, user.entry.timezone, ["signUp"]);
        }));
    }
    signup() {
        this.contestant$.pipe(first()).subscribe(contestantId => {
            this.dialogs
                .openSignupDialog({
                leagueId: this.leagueId,
                contestantId: contestantId,
            })
                .then(() => {
                this.store.dispatch(new LoadContestantsAction(this.leagueId, this.userId, true));
            });
        });
    }
}
SignupLeagueComponent.ɵfac = function SignupLeagueComponent_Factory(t) { return new (t || SignupLeagueComponent)(i0.ɵɵdirectiveInject(TimelineHelper), i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject("DialogService")); };
SignupLeagueComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SignupLeagueComponent, selectors: [["signup-league"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 6, vars: 5, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["signupEnabled", ""], ["signupDisabled", ""], [3, "leagueId", "userId"], [3, "button", "hint", "disabled", "clicked", 4, "ngIf"], [3, "button", "hint", "disabled", "clicked"], [3, "state", "closed", "opens", "full", "eligible", "isTeam", "isLive", "hasCheckIn"]], template: function SignupLeagueComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SignupLeagueComponent_div_0_Template, 1, 0, "div", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, SignupLeagueComponent_ng_template_2_Template, 4, 7, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, SignupLeagueComponent_ng_template_4_Template, 1, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        const _r3 = i0.ɵɵreference(5);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 3, ctx.league$).entry == null ? null : i0.ɵɵpipeBind1(1, 3, ctx.league$).entry.signUp.enabled)("ngIfThen", _r1)("ngIfElse", _r3);
    } }, directives: [i2$1.NgIf, SelectTeamComponent, SignupFlowComponent, StateTextComponent, SignupLeagueDisabledComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignupLeagueComponent, [{
        type: Component,
        args: [{
                selector: "signup-league",
                templateUrl: "./signup-league.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: TimelineHelper }, { type: i1$1.Store }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

function SignupLeaguePendingComponent_article_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "article", 1);
    i0.ɵɵelement(1, "you-are-ready-text", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementStart(4, "p", 3);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("eligible", i0.ɵɵpipeBind1(2, 3, ctx_r0.eligible$))("isTeam", i0.ɵɵpipeBind1(3, 5, ctx_r0.isTeamLeague$));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 7, "signup-flow:signup-pending"), " ");
} }
class SignupLeaguePendingComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.isTeamLeague$ = this.league$.pipe(filter(entryAvailable), map$1(league => isTeam(league.entry)));
        this.contestant$ = this.league$.pipe(switchMap(league => {
            return this.store.pipe(getSelectedContestant(this.leagueId, isPlayer(league.entry) ? "player" : "team"));
        }));
        this.eligible$ = this.contestant$.pipe(switchMap(contestantId => {
            return this.store.pipe(isContestantEligible(this.leagueId, contestantId));
        }));
    }
}
SignupLeaguePendingComponent.ɵfac = function SignupLeaguePendingComponent_Factory(t) { return new (t || SignupLeaguePendingComponent)(i0.ɵɵdirectiveInject(i1$1.Store)); };
SignupLeaguePendingComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SignupLeaguePendingComponent, selectors: [["signup-league-pending"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 3, vars: 5, consts: [["class", "c-league-widget__module c-league-widget__module--highlight", 4, "ngIf"], [1, "c-league-widget__module", "c-league-widget__module--highlight"], [3, "eligible", "isTeam"], [1, "c-league-widget__module__description"]], template: function SignupLeaguePendingComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SignupLeaguePendingComponent_article_0_Template, 7, 9, "article", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵpipe(2, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.contestant$) && i0.ɵɵpipeBind1(2, 3, ctx.league$));
    } }, directives: [i2$1.NgIf, YouAreReadyTextComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignupLeaguePendingComponent, [{
        type: Component,
        args: [{
                selector: "signup-league-pending",
                templateUrl: "./signup-league-pending.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

class SignupFlowErrors {
    constructor(translate) {
        this.translate = translate;
    }
    getErrorForKey(errorKey) {
        switch (errorKey) {
            case "contestant_not_found":
                return this.translate.translate("commons:league-error-contestant-not-found", {});
            case "contestant_must_be_in_league":
                return this.translate.translate("commons:league-error-must-be-in-league", {});
            case "account_barred":
            case "your_account_is_barred":
            case "contestant_barred":
            case "your_team_is_barred":
                return this.translate.translate("commons:league-error-contestant-barred", {});
            case "contestant_must_be_team":
                return this.translate.translate("commons:league-error-contestant-not-team", {});
            case "contestant_must_be_player":
                return this.translate.translate("commons:league-error-contestant-not-player", {});
            case "banned_from_league":
            case "contestant_is_banned_from_league":
                return this.translate.translate("commons:league-error-banned", {});
            case "contestant_has_too_many_penalty_points":
                return this.translate.translate("commons:league-error-too-many-pps", {});
            case "contestant_already_checked_in":
                return this.translate.translate("commons:league-error-already-checked-in", {});
            case "denied_due_restriction":
            case "restrictions_not_met":
            case "contestant_failed_restriction":
                return this.translate.translate("commons:league-error-failed-restrictions", {});
            case "too_early":
                return this.translate.translate("commons:league-error-too-early", {});
            case "too_late":
                return this.translate.translate("commons:league-error-too-late", {});
            case "cup_full":
            case "league_full":
            case "sign_up_limit_reached":
                return this.translate.translate("commons:league-error-league-full", {});
            case "premium_required":
                return this.translate.translate("commons:league-error-premium-required", {});
            case "team_too_small":
                return this.translate.translate("commons:league-error-team-too-small", {});
            case "team_too_large":
                return this.translate.translate("commons:league-error-team-too-large", {});
            case "cannot_signup_other_player":
                return this.translate.translate("commons:league-error-not-self", {});
            case "must_be_manager_or_roster_member":
                return this.translate.translate("commons:league-error-not-in-roster-or-manager", {});
            case "no_team_permission":
            case "must_be_manager":
                return this.translate.translate("commons:league-error-not-manager", {});
            case "member_already_in_league":
            case "member_already_active_in_league":
                return this.translate.translate("commons:league-error-member-already-in-league", {});
            case "not_enough_members_pass_restrictions":
                return this.translate.translate("commons:league-error-failed-restrictions-members", {});
            case "member_banned_in_league":
                return this.translate.translate("commons:league-error-banned-members", {});
            case "league_not_in_checkin_state":
                return this.translate.translate("commons:league-error-wrong-state", { expected: "checkIn" });
            default:
                return this.translate.translate("commons:error-unknown", {});
        }
    }
}
SignupFlowErrors.ɵfac = function SignupFlowErrors_Factory(t) { return new (t || SignupFlowErrors)(i0.ɵɵinject(i1.TranslateService)); };
SignupFlowErrors.ɵprov = i0.ɵɵdefineInjectable({ token: SignupFlowErrors, factory: SignupFlowErrors.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignupFlowErrors, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }]; }, null); })();

function CheckinLeagueComponent_inline_error_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r2 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(error_r2);
} }
function CheckinLeagueComponent_signup_flow_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "signup-flow", 2);
    i0.ɵɵlistener("clicked", function CheckinLeagueComponent_signup_flow_2_Template_signup_flow_clicked_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.checkin(); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelement(6, "state-text", 3);
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵpipe(10, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("button", i0.ɵɵpipeBind1(1, 9, "commons:check-in"))("hint", i0.ɵɵpipeBind1(2, 11, ctx_r1.countdown$))("disabled", !i0.ɵɵpipeBind1(3, 13, ctx_r1.stateTimeframe$) || !i0.ɵɵpipeBind1(4, 15, ctx_r1.eligible$))("loading", i0.ɵɵpipeBind1(5, 17, ctx_r1.loading$));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("state", "checkin")("closed", i0.ɵɵpipeBind1(7, 19, ctx_r1.stateClosed$))("opens", i0.ɵɵpipeBind1(8, 21, ctx_r1.stateOpens$))("eligible", i0.ɵɵpipeBind1(9, 23, ctx_r1.eligible$))("isTeam", i0.ɵɵpipeBind1(10, 25, ctx_r1.isTeamLeague$));
} }
class CheckinLeagueComponent {
    constructor(timelineHelper, store, errors, contestantResource) {
        this.timelineHelper = timelineHelper;
        this.store = store;
        this.errors = errors;
        this.contestantResource = contestantResource;
        this.loading$ = new BehaviorSubject(false);
        this.error$ = new BehaviorSubject(null);
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.user$ = this.store.select(getUser);
        this.isTeamLeague$ = this.league$.pipe(filter(entryAvailable), map$1(league => isTeam(league.entry)));
        this.contestant$ = this.league$.pipe(switchMap(league => {
            return this.store.pipe(getSelectedContestant(this.leagueId, isPlayer(league.entry) ? "player" : "team"));
        }));
        this.eligible$ = this.contestant$.pipe(switchMap(contestantId => {
            return this.store.pipe(isContestantEligible(this.leagueId, contestantId));
        }));
        const countdownInterval = interval(1000)
            .pipe(startWith(0))
            .pipe();
        this.stateOpens$ = combineLatest(countdownInterval, this.league$).pipe(map$1(([, league]) => {
            if (league.entry.timeline && league.entry.timeline.checkIn) {
                const begin = league.entry.timeline.checkIn.begin;
                return !this.timelineHelper.hasAlreadyStarted(begin);
            }
            return false;
        }));
        this.stateClosed$ = combineLatest(countdownInterval, this.league$).pipe(map$1(([, league]) => {
            if (league.entry.timeline && league.entry.timeline.checkIn) {
                const end = league.entry.timeline.checkIn.end;
                return this.timelineHelper.hasAlreadyEnded(end);
            }
            return false;
        }));
        this.stateTimeframe$ = combineLatest(this.stateOpens$, this.stateClosed$).pipe(map$1(([opens, closed]) => !opens && !closed));
        this.countdown$ = combineLatest(countdownInterval, this.league$, this.user$).pipe(map$1(([, league, user]) => {
            return this.timelineHelper.getCountdownOfTimeline(league.entry, user.entry.timezone, ["checkIn"]);
        }));
    }
    getErrorForKey(errorKey) {
        return this.errors.getErrorForKey(errorKey);
    }
    checkin() {
        this.loading$.next(true);
        this.error$.next(null);
        combineLatest(this.league$, this.contestant$)
            .pipe(first())
            .subscribe(([league, contestantId]) => {
            this.contestantResource
                .checkInToLeague(league.entry.id, contestantId)
                .toPromise()
                .then(() => this.store.dispatch(new LoadContestantsAction(this.leagueId, this.userId, true)))
                .catch((error) => {
                const errorText = error ? error.message : "";
                this.error$.next(this.getErrorForKey(errorText));
                return null;
            })
                .then(() => this.loading$.next(false));
        });
    }
}
CheckinLeagueComponent.ɵfac = function CheckinLeagueComponent_Factory(t) { return new (t || CheckinLeagueComponent)(i0.ɵɵdirectiveInject(TimelineHelper), i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(SignupFlowErrors), i0.ɵɵdirectiveInject(i3.ContestantResource)); };
CheckinLeagueComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CheckinLeagueComponent, selectors: [["checkin-league"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 5, vars: 8, consts: [[4, "ngIf"], [3, "button", "hint", "disabled", "loading", "clicked", 4, "ngIf"], [3, "button", "hint", "disabled", "loading", "clicked"], [3, "state", "closed", "opens", "eligible", "isTeam"]], template: function CheckinLeagueComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CheckinLeagueComponent_inline_error_0_Template, 2, 1, "inline-error", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, CheckinLeagueComponent_signup_flow_2_Template, 11, 27, "signup-flow", 1);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵpipe(4, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.error$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx.contestant$) && i0.ɵɵpipeBind1(4, 6, ctx.league$));
    } }, directives: [i2$1.NgIf, i2.InlineErrorComponent, SignupFlowComponent, StateTextComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckinLeagueComponent, [{
        type: Component,
        args: [{
                selector: "checkin-league",
                templateUrl: "./checkin-league.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: TimelineHelper }, { type: i1$1.Store }, { type: SignupFlowErrors }, { type: i3.ContestantResource }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

const _c0$b = function (a0, a1, a2) { return { hasCheckIn: a0, eligible: a1, isTeam: a2 }; };
function CheckinLeagueCheckedInComponent_signup_flow_transition_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "signup-flow-transition", 1);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵelement(2, "you-are-ready-text", 2);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const league_r1 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hint", i0.ɵɵpipeBind1(1, 4, ctx_r0.countdown$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("eligible", i0.ɵɵpipeBind1(3, 6, ctx_r0.eligible$))("isTeam", i0.ɵɵpipeBind1(4, 8, ctx_r0.isTeamLeague$));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(6, 10, "signup-flow:checked-in", i0.ɵɵpureFunction3(17, _c0$b, (league_r1.entry.timeline == null ? null : league_r1.entry.timeline.checkIn == null ? null : league_r1.entry.timeline.checkIn.begin) ? 1 : 0, i0.ɵɵpipeBind1(7, 13, ctx_r0.eligible$) ? 1 : 0, i0.ɵɵpipeBind1(8, 15, ctx_r0.isTeamLeague$) ? 1 : 0)), "\n");
} }
class CheckinLeagueCheckedInComponent {
    constructor(store, timeFormatter, translate, timelineHelper) {
        this.store = store;
        this.timeFormatter = timeFormatter;
        this.translate = translate;
        this.timelineHelper = timelineHelper;
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.user$ = this.store.select(getUser);
        this.isTeamLeague$ = this.league$.pipe(filter(entryAvailable), map$1(league => isTeam(league.entry)));
        this.contestant$ = this.league$.pipe(switchMap(league => {
            return this.store.pipe(getSelectedContestant(this.leagueId, isPlayer(league.entry) ? "player" : "team"));
        }));
        this.eligible$ = this.contestant$.pipe(switchMap(contestantId => {
            return this.store.pipe(isContestantEligible(this.leagueId, contestantId));
        }));
        this.countdown$ = combineLatest(interval(1000).pipe(startWith(0)), this.league$).pipe(map$1(([, league]) => {
            if (league.entry.timeline && league.entry.timeline.inProgress) {
                const begin = league.entry.timeline.inProgress.begin;
                const timeDiff = this.timelineHelper.getSecondTimeDiff(begin);
                return this.translate.translate("signup-flow:phase-starts-in", {
                    date: this.timeFormatter.formatForHumans(Math.max(0, timeDiff)),
                });
            }
            return null;
        }));
    }
}
CheckinLeagueCheckedInComponent.ɵfac = function CheckinLeagueCheckedInComponent_Factory(t) { return new (t || CheckinLeagueCheckedInComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i2.FormatTime), i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject(TimelineHelper)); };
CheckinLeagueCheckedInComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CheckinLeagueCheckedInComponent, selectors: [["checkin-league-checked-in"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 3, vars: 5, consts: [[3, "hint", 4, "ngIf"], [3, "hint"], [3, "eligible", "isTeam"]], template: function CheckinLeagueCheckedInComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CheckinLeagueCheckedInComponent_signup_flow_transition_0_Template, 9, 21, "signup-flow-transition", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵpipe(2, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.contestant$) && i0.ɵɵpipeBind1(2, 3, ctx.league$));
    } }, directives: [i2$1.NgIf, SignupFlowTransitionComponent, YouAreReadyTextComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckinLeagueCheckedInComponent, [{
        type: Component,
        args: [{
                selector: "checkin-league-checked-in",
                templateUrl: "./checkin-league-checked-in.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i2.FormatTime }, { type: i1.TranslateService }, { type: TimelineHelper }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

class LateSignupLeagueDisabledComponent {
    constructor(timeFormatter, translate, timelineHelper) {
        this.timeFormatter = timeFormatter;
        this.translate = translate;
        this.timelineHelper = timelineHelper;
    }
    ngOnChanges() {
        this.countdown$ = interval(1000)
            .pipe(startWith(0))
            .pipe(map$1(() => {
            const league = this.league;
            if (league.entry.timeline && league.entry.timeline.inProgress) {
                const begin = league.entry.timeline.inProgress.begin;
                const timeDiff = this.timelineHelper.getSecondTimeDiff(begin);
                return this.translate.translate("signup-flow:phase-starts-in", {
                    date: this.timeFormatter.formatForHumans(Math.max(0, timeDiff)),
                });
            }
            return null;
        }));
    }
}
LateSignupLeagueDisabledComponent.ɵfac = function LateSignupLeagueDisabledComponent_Factory(t) { return new (t || LateSignupLeagueDisabledComponent)(i0.ɵɵdirectiveInject(i2.FormatTime), i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject(TimelineHelper)); };
LateSignupLeagueDisabledComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LateSignupLeagueDisabledComponent, selectors: [["late-signup-league-disabled"]], inputs: { league: "league" }, features: [i0.ɵɵNgOnChangesFeature], decls: 4, vars: 6, consts: [[3, "hint"]], template: function LateSignupLeagueDisabledComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "signup-flow-transition", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("hint", i0.ɵɵpipeBind1(1, 2, ctx.countdown$));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 4, "signup-flow:late-signup-disabled"), "\n");
    } }, directives: [SignupFlowTransitionComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LateSignupLeagueDisabledComponent, [{
        type: Component,
        args: [{
                selector: "late-signup-league-disabled",
                templateUrl: "./late-signup-league-disabled.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i2.FormatTime }, { type: i1.TranslateService }, { type: TimelineHelper }]; }, { league: [{
            type: Input,
            args: ["league"]
        }] }); })();

function LateSignupLeagueComponent_signup_flow_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "signup-flow", 2);
    i0.ɵɵlistener("clicked", function LateSignupLeagueComponent_signup_flow_1_Template_signup_flow_clicked_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.signup(); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelement(5, "state-text", 3);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("button", i0.ɵɵpipeBind1(1, 8, "commons:signup"))("hint", i0.ɵɵpipeBind1(2, 10, ctx_r0.countdown$))("disabled", !i0.ɵɵpipeBind1(3, 12, ctx_r0.stateTimeframe$) || !i0.ɵɵpipeBind1(4, 14, ctx_r0.eligible$));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("state", "late-signup")("closed", i0.ɵɵpipeBind1(6, 16, ctx_r0.stateClosed$))("opens", i0.ɵɵpipeBind1(7, 18, ctx_r0.stateOpens$))("eligible", i0.ɵɵpipeBind1(8, 20, ctx_r0.eligible$))("isTeam", i0.ɵɵpipeBind1(9, 22, ctx_r0.isTeamLeague$));
} }
class LateSignupLeagueComponent {
    constructor(timelineHelper, store, dialogs) {
        this.timelineHelper = timelineHelper;
        this.store = store;
        this.dialogs = dialogs;
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId)).pipe();
        this.isTeamLeague$ = this.league$.pipe(filter(entryAvailable), map$1(league => isTeam(league.entry)));
        this.user$ = this.store.select(getUser).pipe();
        this.contestant$ = this.league$.pipe(switchMap(league => {
            return this.store.pipe(getSelectedContestant(this.leagueId, isPlayer(league.entry) ? "player" : "team"));
        }));
        this.eligible$ = this.contestant$.pipe(switchMap(contestantId => {
            return this.store.pipe(isContestantEligible(this.leagueId, contestantId));
        }));
        const countdownInterval = interval(1000).pipe(startWith(0));
        this.stateOpens$ = combineLatest(countdownInterval, this.league$).pipe(map$1(([, league]) => {
            if (league.entry.timeline && league.entry.timeline.lateSignUp) {
                const begin = league.entry.timeline.lateSignUp.begin;
                return !this.timelineHelper.hasAlreadyStarted(begin);
            }
            return false;
        }));
        this.stateClosed$ = combineLatest(countdownInterval, this.league$).pipe(map$1(([, league]) => {
            if (league.entry.timeline && league.entry.timeline.lateSignUp) {
                const end = league.entry.timeline.lateSignUp.end;
                return this.timelineHelper.hasAlreadyEnded(end);
            }
            return false;
        }));
        this.stateTimeframe$ = combineLatest(this.stateOpens$, this.stateClosed$).pipe(map$1(([opens, closed]) => !opens && !closed));
        this.countdown$ = combineLatest(countdownInterval, this.league$, this.user$).pipe(map$1(([, league, user]) => {
            return this.timelineHelper.getCountdownOfTimeline(league.entry, user.entry.timezone, ["lateSignUp"]);
        }));
    }
    signup() {
        this.contestant$.pipe(first()).subscribe(contestantId => {
            this.dialogs
                .openSignupDialog({
                leagueId: this.leagueId,
                contestantId: contestantId,
            })
                .then(() => {
                this.store.dispatch(new LoadContestantsAction(this.leagueId, this.userId, true));
            });
        });
    }
}
LateSignupLeagueComponent.ɵfac = function LateSignupLeagueComponent_Factory(t) { return new (t || LateSignupLeagueComponent)(i0.ɵɵdirectiveInject(TimelineHelper), i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject("DialogService")); };
LateSignupLeagueComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LateSignupLeagueComponent, selectors: [["late-signup-league"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 4, vars: 7, consts: [[3, "leagueId", "userId"], [3, "button", "hint", "disabled", "clicked", 4, "ngIf"], [3, "button", "hint", "disabled", "clicked"], [3, "state", "closed", "opens", "eligible", "isTeam"]], template: function LateSignupLeagueComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "select-team", 0);
        i0.ɵɵtemplate(1, LateSignupLeagueComponent_signup_flow_1_Template, 10, 24, "signup-flow", 1);
        i0.ɵɵpipe(2, "async");
        i0.ɵɵpipe(3, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("leagueId", ctx.leagueId)("userId", ctx.userId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 3, ctx.contestant$) && i0.ɵɵpipeBind1(3, 5, ctx.league$));
    } }, directives: [SelectTeamComponent, i2$1.NgIf, SignupFlowComponent, StateTextComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LateSignupLeagueComponent, [{
        type: Component,
        args: [{
                selector: "late-signup-league",
                templateUrl: "./late-signup-league.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: TimelineHelper }, { type: i1$1.Store }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

function LateSignupLeagueStatusComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div");
} }
function LateSignupLeagueStatusComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "late-signup-league", 3);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("leagueId", ctx_r2.leagueId)("userId", ctx_r2.userId);
} }
function LateSignupLeagueStatusComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "late-signup-league-disabled", 4);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("league", i0.ɵɵpipeBind1(1, 1, ctx_r4.league$));
} }
class LateSignupLeagueStatusComponent {
    constructor(store) {
        this.store = store;
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
    }
}
LateSignupLeagueStatusComponent.ɵfac = function LateSignupLeagueStatusComponent_Factory(t) { return new (t || LateSignupLeagueStatusComponent)(i0.ɵɵdirectiveInject(i1$1.Store)); };
LateSignupLeagueStatusComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LateSignupLeagueStatusComponent, selectors: [["late-signup-league-status"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 6, vars: 5, consts: [[4, "ngIf", "ngIfThen", "ngIfElse"], ["signupEnabled", ""], ["signupDisabled", ""], [3, "leagueId", "userId"], [3, "league"]], template: function LateSignupLeagueStatusComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LateSignupLeagueStatusComponent_div_0_Template, 1, 0, "div", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, LateSignupLeagueStatusComponent_ng_template_2_Template, 1, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, LateSignupLeagueStatusComponent_ng_template_4_Template, 2, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(3);
        const _r3 = i0.ɵɵreference(5);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 3, ctx.league$).entry == null ? null : i0.ɵɵpipeBind1(1, 3, ctx.league$).entry.timeline == null ? null : i0.ɵɵpipeBind1(1, 3, ctx.league$).entry.timeline.lateSignUp)("ngIfThen", _r1)("ngIfElse", _r3);
    } }, directives: [i2$1.NgIf, LateSignupLeagueComponent, LateSignupLeagueDisabledComponent], pipes: [i2$1.AsyncPipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LateSignupLeagueStatusComponent, [{
        type: Component,
        args: [{
                selector: "late-signup-league-status",
                templateUrl: "./late-signup-league-status.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

class InProgressComponent {
}
InProgressComponent.ɵfac = function InProgressComponent_Factory(t) { return new (t || InProgressComponent)(); };
InProgressComponent.ɵcmp = i0.ɵɵdefineComponent({ type: InProgressComponent, selectors: [["already-in-progress"]], decls: 7, vars: 6, consts: [[1, "c-league-widget__module", "c-league-widget__module--warning"], [1, "c-league-widget__module__title"], [1, "c-league-widget__module__description"]], template: function InProgressComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "h3", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "p", 2);
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "signup-flow:in-progress"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "signup-flow:in-progress-description"), " ");
    } }, pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InProgressComponent, [{
        type: Component,
        args: [{
                selector: "already-in-progress",
                templateUrl: "./in-progress.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

class SetupComponent {
}
SetupComponent.ɵfac = function SetupComponent_Factory(t) { return new (t || SetupComponent)(); };
SetupComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SetupComponent, selectors: [["in-setup"]], decls: 7, vars: 6, consts: [[1, "c-league-widget__module", "c-league-widget__module--warning"], [1, "c-league-widget__module__title"], [1, "c-league-widget__module__description"]], template: function SetupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "h3", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "p", 2);
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "signup-flow:setup"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 4, "signup-flow:setup-description"), " ");
    } }, pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SetupComponent, [{
        type: Component,
        args: [{
                selector: "in-setup",
                templateUrl: "./setup.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

function ChangeTeamSignupComponent_article_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "article", 1);
    i0.ɵɵelementStart(1, "a", 2);
    i0.ɵɵlistener("click", function ChangeTeamSignupComponent_article_0_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r1 = i0.ɵɵnextContext(); $event.preventDefault(); return ctx_r1.changeTeam(); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "signup-flow:change-team-description"), " ");
} }
class ChangeTeamSignupComponent {
    constructor(store, translate, dialogs) {
        this.store = store;
        this.translate = translate;
        this.dialogs = dialogs;
    }
    ngOnInit() {
        this.store.dispatch(new LoadContestantsOnceAction(this.leagueId, this.userId));
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.selectedContestantId$ = this.store.pipe(getSelectedContestant(this.leagueId, "team"));
        this.shouldDisplay$ = combineLatest(this.isTeamLeague$, this.canSwitchTeam$, this.hasTeamSelected$, this.isSignupEnabled$).pipe(map$1(array => array.filter(x => !x).length === 0));
    }
    changeTeam() {
        this.dialogs.openTeamSelectDialog({ leagueId: this.leagueId }).then(teamId => {
            this.store.dispatch(new SelectContestantAction(this.leagueId, teamId, "team"));
        });
    }
    /**
     * If not a roster league, players can only switch team if not signed up yet
     */
    get canSwitchTeam$() {
        return this.isRosterLeague$.pipe(mergeMap(isRosterLeague => {
            if (isRosterLeague) {
                return of(true);
            }
            return this.isContestant$.pipe(map$1(x => !x));
        }));
    }
    /**
     * Checks if the league is a team league
     */
    get isTeamLeague$() {
        return this.league$.pipe(filter(entryAvailable), map$1(league => league.entry), map$1(isTeam));
    }
    /**
     * Checks if the league has signup enabled
     */
    get isSignupEnabled$() {
        return this.league$.pipe(filter(entryAvailable), map$1(league => league.entry), map$1(isSignUpEnabled));
    }
    /**
     * Checks if the league has rosters enabled
     */
    get isRosterLeague$() {
        return this.league$.pipe(filter(entryAvailable), map$1(league => league.entry), map$1(isRosterEnabled));
    }
    /**
     * Checks if the user is a contestant of the league
     */
    get isContestant$() {
        return this.selectedContestantId$.pipe(mergeMap(id => this.store.select(getContestant(this.leagueId, this.userId, id))), map$1(exists));
    }
    /**
     * Checks if there's currently a team selected
     */
    get hasTeamSelected$() {
        return this.selectedContestantId$.pipe(map$1(exists));
    }
}
ChangeTeamSignupComponent.ɵfac = function ChangeTeamSignupComponent_Factory(t) { return new (t || ChangeTeamSignupComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject("DialogService")); };
ChangeTeamSignupComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ChangeTeamSignupComponent, selectors: [["change-team-signup"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 2, vars: 3, consts: [["class", "c-league-widget__module", 4, "ngIf"], [1, "c-league-widget__module"], ["href", "#", 3, "click"]], template: function ChangeTeamSignupComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, ChangeTeamSignupComponent_article_0_Template, 4, 3, "article", 0);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.shouldDisplay$));
    } }, directives: [i2$1.NgIf], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChangeTeamSignupComponent, [{
        type: Component,
        args: [{
                selector: "change-team-signup",
                templateUrl: "./change-team.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i1.TranslateService }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }]; }, { leagueId: [{
            type: Input
        }], userId: [{
            type: Input
        }] }); })();

const moment$1 = momentImported;
class SelectedTeamCache extends Cache {
    constructor(cache) {
        super();
        this.cache = cache;
    }
    getCacheKey(id) {
        return `league-widget:selected-team:${id}`;
    }
    getPreselectCacheKey(gameId, gameMode) {
        return `league-widget:preselected-team:${gameId}:${gameMode}`;
    }
    /**
     * Get the selected contestant resource from cache
     *
     * @param leagueId
     */
    getSelectedTeamId(leagueId) {
        return this.cache.getObservable(`${this.getCacheKey(leagueId)}`);
    }
    /**
     * Save the selected contestant resource in cache for 2 months
     *
     * @param leagueId
     * @param teamId
     */
    setSelectedTeamId(leagueId, teamId) {
        return this.cache.setItem(`${this.getCacheKey(leagueId)}`, teamId, moment$1.utc().add(2, "months"));
    }
    /**
     * Get the selected contestant resource from cache
     *
     * @param league
     */
    getPreSelectedTeamId(league) {
        return this.cache.getObservable(`${this.getPreselectCacheKey(league.gameId, league.mode)}`);
    }
    /**
     * Save the selected contestant resource in cache for 2 months
     *
     * @param league
     * @param teamId
     */
    setPreSelectedTeamId(league, teamId) {
        return this.cache.setItem(`${this.getPreselectCacheKey(league.gameId, league.mode)}`, teamId, moment$1.utc().add(2, "months"));
    }
}
SelectedTeamCache.ɵfac = function SelectedTeamCache_Factory(t) { return new (t || SelectedTeamCache)(i0.ɵɵinject(i1$2.CacheService)); };
SelectedTeamCache.ɵprov = i0.ɵɵdefineInjectable({ token: SelectedTeamCache, factory: SelectedTeamCache.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectedTeamCache, [{
        type: Injectable
    }], function () { return [{ type: i1$2.CacheService }]; }, null); })();

class SignupFlowEffects {
    constructor(actions$, store, cache) {
        this.actions$ = actions$;
        this.store = store;
        this.cache = cache;
        this.loadContestant$ = this.actions$.pipe(ofType(SignupFlowActionTypes.LOAD_SELECTED_CONTESTANT), switchMap((action) => {
            return this.store.select(getLeague(action.leagueId)).pipe(filter(league => Boolean(league && league.entry)), filter(league => isTeam(league.entry)), first());
        }), switchMap(league => {
            return this.store.pipe(getSelectedContestant(league.entry.id, "team")).pipe(filter(contestantId => contestantId === undefined), map$1(contestantId => league), first());
        }), switchMap((league) => {
            // Only allow selected contestant if it is an actual contestant
            const selectedTeamId$ = this.cache.getSelectedTeamId(league.entry.id).pipe(switchMap(contestantId => {
                return this.store.select(getUser).pipe(filter(entryAvailable), switchMap(user => this.store.select(getContestant(league.entry.id, +user.entry.id, contestantId))), map$1(contestant => (contestant ? contestantId : null)));
            }));
            // If you already are a contestant, do not get a preselected one
            const preSelectedTeamId$ = this.cache.getPreSelectedTeamId(league.entry).pipe(switchMap(contestantId => {
                return this.store.select(getUser).pipe(filter(user => Boolean(user && user.entry)), switchMap(user => this.store.select(getContestants(league.entry.id, +user.entry.id))), filter(entryAvailable), map$1(contestant => (contestant.entry.length ? null : contestantId)));
            }));
            return combineLatest(selectedTeamId$, preSelectedTeamId$).pipe(first(), map$1(([selectedId, preSelectedId]) => (selectedId ? selectedId : preSelectedId)), map$1(contestantId => new SelectContestantAction(league.entry.id, contestantId, "team")));
        }));
        this.selectContestant$ = this.actions$.pipe(ofType(SignupFlowActionTypes.SELECT_CONTESTANT), switchMap((action) => {
            return this.store.select(getLeague(action.leagueId)).pipe(filter(league => Boolean(league && league.entry)), map$1(league => [league, action]));
        }), switchMap(data => {
            const league = data[0];
            const action = data[1];
            if (action.contestantType === "team" && action.contestantId) {
                this.cache.setPreSelectedTeamId(league.entry, action.contestantId);
                this.cache.setSelectedTeamId(action.leagueId, action.contestantId);
            }
            return [];
        }));
    }
}
SignupFlowEffects.ɵfac = function SignupFlowEffects_Factory(t) { return new (t || SignupFlowEffects)(i0.ɵɵinject(i1$3.Actions), i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(SelectedTeamCache)); };
SignupFlowEffects.ɵprov = i0.ɵɵdefineInjectable({ token: SignupFlowEffects, factory: SignupFlowEffects.ɵfac });
__decorate([
    Effect(),
    __metadata("design:type", Observable)
], SignupFlowEffects.prototype, "loadContestant$", void 0);
__decorate([
    Effect({ dispatch: false }),
    __metadata("design:type", Observable)
], SignupFlowEffects.prototype, "selectContestant$", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignupFlowEffects, [{
        type: Injectable
    }], function () { return [{ type: i1$3.Actions }, { type: i1$1.Store }, { type: SelectedTeamCache }]; }, { loadContestant$: [], selectContestant$: [] }); })();

function LateSignupLeagueCheckInComponent_signup_flow_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "signup-flow", 2);
    i0.ɵɵlistener("clicked", function LateSignupLeagueCheckInComponent_signup_flow_1_Template_signup_flow_clicked_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.checkin(); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelement(5, "state-text", 3);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("button", i0.ɵɵpipeBind1(1, 8, "commons:check-in"))("hint", i0.ɵɵpipeBind1(2, 10, ctx_r0.countdown$))("disabled", !i0.ɵɵpipeBind1(3, 12, ctx_r0.stateTimeframe$) || !i0.ɵɵpipeBind1(4, 14, ctx_r0.eligible$));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("state", "late-checkin")("closed", i0.ɵɵpipeBind1(6, 16, ctx_r0.stateClosed$))("opens", i0.ɵɵpipeBind1(7, 18, ctx_r0.stateOpens$))("eligible", i0.ɵɵpipeBind1(8, 20, ctx_r0.eligible$))("isTeam", i0.ɵɵpipeBind1(9, 22, ctx_r0.isTeamLeague$));
} }
class LateSignupLeagueCheckInComponent {
    constructor(timelineHelper, store, contestantResource, errors, dialogs) {
        this.timelineHelper = timelineHelper;
        this.store = store;
        this.contestantResource = contestantResource;
        this.errors = errors;
        this.dialogs = dialogs;
        this.loading$ = new BehaviorSubject(false);
        this.error$ = new BehaviorSubject(null);
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId)).pipe();
        this.isTeamLeague$ = this.league$.pipe(filter(entryAvailable), map$1(league => isTeam(league.entry)));
        this.user$ = this.store.select(getUser).pipe();
        this.contestant$ = this.league$.pipe(switchMap(league => {
            return this.store.pipe(getSelectedContestant(this.leagueId, isPlayer(league.entry) ? "player" : "team"));
        }));
        this.eligible$ = this.contestant$.pipe(switchMap(contestantId => {
            return this.store.pipe(isContestantEligible(this.leagueId, contestantId));
        }));
        const countdownInterval = interval(1000).pipe(startWith(0));
        this.stateOpens$ = combineLatest(countdownInterval, this.league$).pipe(map$1(([, league]) => {
            if (league.entry.timeline && league.entry.timeline.lateSignUp) {
                const begin = league.entry.timeline.lateSignUp.begin;
                return !this.timelineHelper.hasAlreadyStarted(begin);
            }
            return false;
        }));
        this.stateClosed$ = combineLatest(countdownInterval, this.league$).pipe(map$1(([, league]) => {
            if (league.entry.timeline && league.entry.timeline.lateSignUp) {
                const end = league.entry.timeline.lateSignUp.end;
                return this.timelineHelper.hasAlreadyEnded(end);
            }
            return false;
        }));
        this.stateTimeframe$ = combineLatest(this.stateOpens$, this.stateClosed$).pipe(map$1(([opens, closed]) => !opens && !closed));
        this.countdown$ = combineLatest(countdownInterval, this.league$, this.user$).pipe(map$1(([, league, user]) => {
            return this.timelineHelper.getCountdownOfTimeline(league.entry, user.entry.timezone, ["lateCheckin"]);
        }));
    }
    getErrorForKey(errorKey) {
        return this.errors.getErrorForKey(errorKey);
    }
    checkin() {
        this.loading$.next(true);
        this.error$.next(null);
        combineLatest(this.league$, this.contestant$)
            .pipe(first())
            .subscribe(([league, contestantId]) => {
            this.contestantResource
                .checkInToLeague(league.entry.id, contestantId)
                .toPromise()
                .then(() => this.store.dispatch(new LoadContestantsAction(this.leagueId, this.userId, true)))
                .catch((error) => {
                const errorText = error ? error.message : "";
                this.error$.next(this.getErrorForKey(errorText));
                return null;
            })
                .then(() => this.loading$.next(false));
        });
    }
}
LateSignupLeagueCheckInComponent.ɵfac = function LateSignupLeagueCheckInComponent_Factory(t) { return new (t || LateSignupLeagueCheckInComponent)(i0.ɵɵdirectiveInject(TimelineHelper), i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i3.ContestantResource), i0.ɵɵdirectiveInject(SignupFlowErrors), i0.ɵɵdirectiveInject("DialogService")); };
LateSignupLeagueCheckInComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LateSignupLeagueCheckInComponent, selectors: [["late-signup-league-check-in"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 4, vars: 7, consts: [[3, "leagueId", "userId"], [3, "button", "hint", "disabled", "clicked", 4, "ngIf"], [3, "button", "hint", "disabled", "clicked"], [3, "state", "closed", "opens", "eligible", "isTeam"]], template: function LateSignupLeagueCheckInComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "select-team", 0);
        i0.ɵɵtemplate(1, LateSignupLeagueCheckInComponent_signup_flow_1_Template, 10, 24, "signup-flow", 1);
        i0.ɵɵpipe(2, "async");
        i0.ɵɵpipe(3, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("leagueId", ctx.leagueId)("userId", ctx.userId);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 3, ctx.contestant$) && i0.ɵɵpipeBind1(3, 5, ctx.league$));
    } }, directives: [SelectTeamComponent, i2$1.NgIf, SignupFlowComponent, StateTextComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LateSignupLeagueCheckInComponent, [{
        type: Component,
        args: [{
                selector: "late-signup-league-check-in",
                templateUrl: "./late-signup-league-check-in.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: TimelineHelper }, { type: i1$1.Store }, { type: i3.ContestantResource }, { type: SignupFlowErrors }, { type: undefined, decorators: [{
                type: Inject,
                args: ["DialogService"]
            }] }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

class SignupFlowModule {
    static withComponents() {
        return {
            ngModule: SignupFlowModule,
            providers: [
                {
                    provide: ANALYZE_FOR_ENTRY_COMPONENTS,
                    useValue: [
                        SignupLeagueComponent,
                        CheckinLeagueComponent,
                        SignupLeagueDisabledComponent,
                        SignupLeaguePendingComponent,
                        LateSignupLeagueComponent,
                        LateSignupLeagueDisabledComponent,
                        LateSignupLeagueStatusComponent,
                        LateSignupLeagueCheckInComponent,
                        CheckinLeagueCheckedInComponent,
                        SelectTeamComponent,
                        InProgressComponent,
                        SetupComponent,
                        ChangeTeamSignupComponent,
                        VendorTeamNoticeComponent,
                    ],
                    multi: true,
                },
            ],
        };
    }
}
SignupFlowModule.ɵfac = function SignupFlowModule_Factory(t) { return new (t || SignupFlowModule)(); };
SignupFlowModule.ɵmod = i0.ɵɵdefineNgModule({ type: SignupFlowModule });
SignupFlowModule.ɵinj = i0.ɵɵdefineInjector({ providers: [TimelineHelper, SelectedTeamCache, SignupFlowErrors], imports: [[
            CommonModule,
            TranslationModule,
            CommonsModule,
            CommonsErrorModule,
            CommonsLoadingModule,
            CommonsDateModule,
            CommonsComponentModule,
            EffectsModule.forFeature([SignupFlowEffects]),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SignupFlowModule, { declarations: [SignupFlowComponent,
        SignupFlowTransitionComponent,
        YouAreReadyTextComponent,
        StateClosedTextComponent,
        StateOpensTextComponent,
        StateOpenTextComponent,
        StateTextComponent,
        //
        SignupLeagueComponent,
        CheckinLeagueComponent,
        SignupLeagueDisabledComponent,
        SignupLeaguePendingComponent,
        LateSignupLeagueComponent,
        LateSignupLeagueDisabledComponent,
        LateSignupLeagueStatusComponent,
        LateSignupLeagueCheckInComponent,
        CheckinLeagueCheckedInComponent,
        SelectTeamComponent,
        InProgressComponent,
        SetupComponent,
        ChangeTeamSignupComponent,
        VendorTeamNoticeComponent], imports: [CommonModule,
        TranslationModule,
        CommonsModule,
        CommonsErrorModule,
        CommonsLoadingModule,
        CommonsDateModule,
        CommonsComponentModule, i1$3.EffectsFeatureModule], exports: [SignupFlowComponent, SignupFlowTransitionComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignupFlowModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslationModule,
                    CommonsModule,
                    CommonsErrorModule,
                    CommonsLoadingModule,
                    CommonsDateModule,
                    CommonsComponentModule,
                    EffectsModule.forFeature([SignupFlowEffects]),
                ],
                declarations: [
                    SignupFlowComponent,
                    SignupFlowTransitionComponent,
                    YouAreReadyTextComponent,
                    StateClosedTextComponent,
                    StateOpensTextComponent,
                    StateOpenTextComponent,
                    StateTextComponent,
                    //
                    SignupLeagueComponent,
                    CheckinLeagueComponent,
                    SignupLeagueDisabledComponent,
                    SignupLeaguePendingComponent,
                    LateSignupLeagueComponent,
                    LateSignupLeagueDisabledComponent,
                    LateSignupLeagueStatusComponent,
                    LateSignupLeagueCheckInComponent,
                    CheckinLeagueCheckedInComponent,
                    SelectTeamComponent,
                    InProgressComponent,
                    SetupComponent,
                    ChangeTeamSignupComponent,
                    VendorTeamNoticeComponent,
                ],
                exports: [SignupFlowComponent, SignupFlowTransitionComponent],
                providers: [TimelineHelper, SelectedTeamCache, SignupFlowErrors],
            }]
    }], null, null); })();

const mainHeaderTexts = {
    "league-widget:play": "Play",
};

function MainHeaderReadyComponent_ng_container_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div");
} }
function MainHeaderReadyComponent_ng_container_0_contestant_ready_alert_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "contestant-ready-alert", 7);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("alerts", i0.ɵɵpipeBind1(1, 1, ctx_r3.alerts$));
} }
function MainHeaderReadyComponent_ng_container_0_ng_template_9_contestant_ready_header_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "contestant-ready-header", 9);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("team", true)("ready", i0.ɵɵpipeBind1(1, 2, ctx_r8.eligible$));
} }
function MainHeaderReadyComponent_ng_container_0_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, MainHeaderReadyComponent_ng_container_0_ng_template_9_contestant_ready_header_0_Template, 2, 4, "contestant-ready-header", 8);
    i0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const league_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", league_r1.entry && i0.ɵɵpipeBind1(1, 1, ctx_r5.isTeamLeague$));
} }
function MainHeaderReadyComponent_ng_container_0_ng_template_11_Template(rf, ctx) { }
function MainHeaderReadyComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "section", 1);
    i0.ɵɵelementStart(2, "h3", 2);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, MainHeaderReadyComponent_ng_container_0_div_5_Template, 1, 0, "div", 3);
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, MainHeaderReadyComponent_ng_container_0_contestant_ready_alert_7_Template, 2, 3, "contestant-ready-alert", 4);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵtemplate(9, MainHeaderReadyComponent_ng_container_0_ng_template_9_Template, 2, 3, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(11, MainHeaderReadyComponent_ng_container_0_ng_template_11_Template, 0, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const league_r1 = ctx.ngIf;
    const _r4 = i0.ɵɵreference(10);
    const _r6 = i0.ɵɵreference(12);
    const ctx_r0 = i0.ɵɵnextContext();
    let tmp_1_0 = null;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 5, "league-widget:play"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (tmp_1_0 = i0.ɵɵpipeBind1(6, 7, ctx_r0.restrictions$)) == null ? null : tmp_1_0.entry)("ngIfThen", _r4)("ngIfElse", _r6);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", league_r1.entry && i0.ɵɵpipeBind1(8, 9, ctx_r0.isTeamLeague$));
} }
class MainHeaderReadyComponent {
    constructor(alertFactory, store) {
        this.alertFactory = alertFactory;
        this.store = store;
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.user$ = this.store.select(getUser);
        this.isTeamLeague$ = this.league$.pipe(filter(entryAvailable), map$1(league => isTeam(league.entry)));
        this.teamId$ = this.league$.pipe(switchMap(league => {
            return isPlayer(league.entry) ? [] : this.store.pipe(getSelectedContestant(this.leagueId, "team"));
        }), filter(exists), distinctUntilChanged());
        this.team$ = this.teamId$.pipe(switchMap(teamId => this.store.select(getUserTeams).pipe(filter(userTeams => Boolean(userTeams.entry)), switchMap(userTeams => {
            const membership = find(userTeams.entry, teammembership => +teammembership.team.id === teamId);
            return membership ? [membership.team] : [];
        }))));
        this.restrictions$ = this.teamId$.pipe(tap(teamId => this.store.dispatch(new LoadLeagueRestrictionsOnceAction(this.leagueId, teamId))), switchMap(teamId => this.store.select(getLeagueRestrictions(this.leagueId, teamId))));
        this.eligible$ = this.teamId$.pipe(switchMap(contestantId => {
            return this.store.pipe(isContestantEligible(this.leagueId, contestantId));
        }), distinctUntilChanged());
        this.alerts$ = combineLatest([this.team$, this.user$, this.restrictions$]).pipe(map$1((data) => {
            const [team, user, restrictions] = data;
            if (team && user.entry && restrictions && restrictions.entry) {
                return this.alertFactory.getTeamAlertTexts(team, user.entry, restrictions.entry);
            }
            return [];
        }));
    }
}
MainHeaderReadyComponent.ɵfac = function MainHeaderReadyComponent_Factory(t) { return new (t || MainHeaderReadyComponent)(i0.ɵɵdirectiveInject(ContestantReadyAlertFactory), i0.ɵɵdirectiveInject(i1$1.Store)); };
MainHeaderReadyComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MainHeaderReadyComponent, selectors: [["main-header-ready"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 2, vars: 3, consts: [[4, "ngIf"], [1, "c-league-widget__header"], [1, "c-league-widget__header__title"], [4, "ngIf", "ngIfThen", "ngIfElse"], [3, "alerts", 4, "ngIf"], ["notLoading", ""], ["loading", ""], [3, "alerts"], [3, "team", "ready", 4, "ngIf"], [3, "team", "ready"]], template: function MainHeaderReadyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, MainHeaderReadyComponent_ng_container_0_Template, 13, 11, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.league$));
    } }, directives: [i2$1.NgIf, ContestantReadyAlertComponent, ContestantReadyHeaderComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MainHeaderReadyComponent, [{
        type: Component,
        args: [{
                selector: "main-header-ready",
                templateUrl: "./main-header-ready.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: ContestantReadyAlertFactory }, { type: i1$1.Store }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

class MainHeaderComponent {
}
MainHeaderComponent.ɵfac = function MainHeaderComponent_Factory(t) { return new (t || MainHeaderComponent)(); };
MainHeaderComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MainHeaderComponent, selectors: [["main-header"]], inputs: { leagueId: "leagueId", userId: "userId" }, decls: 4, vars: 3, consts: [[1, "c-league-widget__header"], [1, "c-league-widget__header__title"]], template: function MainHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "section", 0);
        i0.ɵɵelementStart(1, "h3", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "league-widget:play"));
    } }, pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MainHeaderComponent, [{
        type: Component,
        args: [{
                selector: "main-header",
                templateUrl: "./main-header.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], userId: [{
            type: Input,
            args: ["userId"]
        }] }); })();

class MainHeaderModule {
    static withComponents() {
        return {
            ngModule: MainHeaderModule,
            providers: [
                {
                    provide: ANALYZE_FOR_ENTRY_COMPONENTS,
                    useValue: [MainHeaderComponent, MainHeaderReadyComponent],
                    multi: true,
                },
            ],
        };
    }
}
MainHeaderModule.ɵfac = function MainHeaderModule_Factory(t) { return new (t || MainHeaderModule)(); };
MainHeaderModule.ɵmod = i0.ɵɵdefineNgModule({ type: MainHeaderModule });
MainHeaderModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[CommonModule, TranslationModule, ContestantReadyModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(MainHeaderModule, { declarations: [MainHeaderComponent, MainHeaderReadyComponent], imports: [CommonModule, TranslationModule, ContestantReadyModule], exports: [MainHeaderComponent, MainHeaderReadyComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MainHeaderModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TranslationModule, ContestantReadyModule],
                exports: [MainHeaderComponent, MainHeaderReadyComponent],
                declarations: [MainHeaderComponent, MainHeaderReadyComponent],
            }]
    }], null, null); })();

const loginTexts = {
    "league-widget:login-to-play": "Please login to play in the tournament.",
};

function LoginComponent_time_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "time", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const countdown_r1 = ctx.ngIf;
    i0.ɵɵproperty("tooltip", countdown_r1.date);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", countdown_r1.text, " ");
} }
class LoginComponent {
    constructor(links, store, timelineHelper, config) {
        this.links = links;
        this.store = store;
        this.timelineHelper = timelineHelper;
        this.config = config;
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        const countdownInterval = interval(1000).pipe(startWith(0));
        this.countdown$ = combineLatest(countdownInterval, this.league$).pipe(map$1(([, leagueEntry]) => {
            return this.timelineHelper.getCountdownOfTimeline(leagueEntry.entry, this.config.timezone, [
                "signUp",
                "lateSignUp",
                "inProgress",
            ]);
        }));
    }
    get loginLink() {
        return this.links.login();
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(i0.ɵɵdirectiveInject(i2.LinkService), i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(TimelineHelper), i0.ɵɵdirectiveInject(BASE_CONFIG)); };
LoginComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LoginComponent, selectors: [["login"]], inputs: { leagueId: "leagueId" }, decls: 10, vars: 10, consts: [[1, "c-league-widget__module", "c-league-widget__module--highlight"], [1, "c-league-widget__module__description"], [1, "c-button", "c-button--primary", "c-button--gigantic", "c-button--block", 3, "locationHref"], [1, "hintLabel"], ["class", "c-league-widget__module__hint", 3, "tooltip", 4, "ngIf"], [1, "c-league-widget__module__hint", 3, "tooltip"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "p", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "a", 2);
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 3);
        i0.ɵɵtemplate(8, LoginComponent_time_8_Template, 2, 2, "time", 4);
        i0.ɵɵpipe(9, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 4, "league-widget:login-to-play"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("locationHref", ctx.loginLink);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 6, "commons:login"), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(9, 8, ctx.countdown$));
    } }, directives: [i2.LocationDirective, i2$1.NgIf, i2.TooltipDirective], pipes: [i1.TranslatePipe, i2$1.AsyncPipe], styles: [".hintLabel[_ngcontent-%COMP%] {\n                position: relative;\n            }"], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: "login",
                templateUrl: "./login.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [
                    `
            .hintLabel {
                position: relative;
            }
        `,
                ],
            }]
    }], function () { return [{ type: i2.LinkService }, { type: i1$1.Store }, { type: TimelineHelper }, { type: undefined, decorators: [{
                type: Inject,
                args: [BASE_CONFIG]
            }] }]; }, { leagueId: [{
            type: Input
        }] }); })();

class LoginModule {
    static withComponents() {
        return {
            ngModule: LoginModule,
            providers: [
                {
                    provide: ANALYZE_FOR_ENTRY_COMPONENTS,
                    useValue: [LoginComponent],
                    multi: true,
                },
            ],
        };
    }
}
LoginModule.ɵfac = function LoginModule_Factory(t) { return new (t || LoginModule)(); };
LoginModule.ɵmod = i0.ɵɵdefineNgModule({ type: LoginModule });
LoginModule.ɵinj = i0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, TranslationModule, CommonsLocationModule, CommonsComponentModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LoginModule, { declarations: [LoginComponent], imports: [CommonModule, TranslationModule, CommonsLocationModule, CommonsComponentModule] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LoginModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, TranslationModule, CommonsLocationModule, CommonsComponentModule],
                declarations: [LoginComponent],
                exports: [],
                providers: [],
            }]
    }], null, null); })();

const manageRosterTexts = {
    "manage-roster:manage-roster": "Manage Roster",
    "manage-roster:confirm-roster-kick": "Confirm Roster Kick",
    // Roster Eligibility Status
    "manage-roster:roster-eligibility-status-teamSize": `
        {type, select,
            any{May have any number of players selected}
            exact{Must select exactly {minmembers} players that meet all requirements}
            other{{minmembers, select,
                0{{maxmembers, select,
                    0{} other{Must select no more than {maxmembers} players}
                }}
                other{{maxmembers, select,
                    0{Must select at least {minmembers} players that meet all requirements}
                    other{Must select at least {minmembers} players that meet all requirements, and no more than {maxmembers}}
                    }
                }}
            }
        }
    `,
    "manage-roster:roster-eligibility-status-alternateLeague": "Teams must not be a participant " + "of the following tournaments: { leagueids }",
    "manage-roster:roster-eligibility-status-inCountryList": "At least {minmembers} players must be selected " + "that meet the residence requirement.",
    "manage-roster:roster-eligibility-status-residence_nationality": "At least {minmembers} players must be selected " + "that meet the residence/citizenship requirement.",
    "manage-roster:roster-eligibility-status-logo": "Teams must have a logo.",
    "manage-roster:more-info": "More info",
    "manage-roster:upload-logo": "{exists, select, 1{Change logo} other{Upload logo}}",
    // Member Eligibility Status
    "manage-roster:selected": "Selected for roster",
    "manage-roster:select-all-eligible-members": "Select ready players",
    "manage-roster:select-all-eligible-members-disabled": "Too many players are eligible for autoselection",
    "manage-roster:not-ready-to-play": "Not ready",
    "manage-roster:ready-to-play": "Ready to play",
    "manage-roster:too-many-pps-until": "Barred until {until}",
    "manage-roster:banned-until": "Banned until {until}",
    "manage-roster:barred-until": "Barred until {until}",
    "manage-roster:alternate-roster": "Playing for {teamName}",
    "manage-roster:league-ban-warning": "Removing this player from the roster will cause them" + "to be banned for {days} days from the tournament",
    // Save Roster
    "manage-roster:save": "Save Roster",
    "manage-roster:cancel": "Cancel",
    "manage-roster:member-save-error": "Couldn't save changes for {member}",
    // title
    "team-status-dialog:member-eligibility-status-gameaccount-title": "Game ID",
    "team-status-dialog:member-eligibility-status-minage-title": "Age",
    "team-status-dialog:member-eligibility-status-ga_team_positions-title": "Positions",
    "team-status-dialog:member-eligibility-status-age-title": "Age",
    "team-status-dialog:member-eligibility-status-photo-title": "Photo",
    "team-status-dialog:member-eligibility-status-trustlevel-title": "Trusted",
    "team-status-dialog:member-eligibility-status-premium-title": "Premium",
    "team-status-dialog:member-eligibility-status-isadmin-title": "Staff",
    "team-status-dialog:member-eligibility-status-gender-title": "Gender",
    "team-status-dialog:member-eligibility-status-inCountryList-title": "Country",
    "team-status-dialog:member-eligibility-status-residence_nationality-title": "Residence",
    "team-status-dialog:member-eligibility-status-cocTownHallLevel-title": "Town Hall Level",
    // hover
    "team-status-dialog:member-eligibility-status-gameaccount": "Must have { gameaccount } entered.",
    "team-status-dialog:member-eligibility-status-minage": "Must be atleast { minage } old.",
    "team-status-dialog:member-eligibility-status-ga_team_positions": "Must have one of the following team positions: { teampositions }",
    "team-status-dialog:member-eligibility-status-age": "Must have an age entered.",
    "team-status-dialog:member-eligibility-status-photo": "Must have a photo entered.",
    "team-status-dialog:member-eligibility-status-trustlevel": "Must have ESL Trusted Pro { trustlevel }",
    "team-status-dialog:member-eligibility-status-premium": "Must have ESL Premium",
    "team-status-dialog:member-eligibility-status-isadmin": "Must be part of the staff",
    "team-status-dialog:member-eligibility-status-gender": "Must be { gender == 'f' ? 'female' : 'male' }",
    "team-status-dialog:member-eligibility-status-inCountryList": "Must be from one of the following countries: { nationalities }",
    "team-status-dialog:member-eligibility-status-residence_nationality": "Must live in one of the following countries: { countries } " + "and be from one of the following countries: { nationalities }",
    "team-status-dialog:member-eligibility-status-cocTownHallLevel": "Town Hall level must be at least {min}",
    "team-status-dialog:team-eligibility-status-teamSize": `
        Teams {type, select,
            any{can have any number of}
            exact{must have exactly {minmembers}}
            other{{minmembers, select,
                0{{maxmembers, select,
                    0{} other{must have no more than {maxmembers}}
                }}
                other{{maxmembers, select,
                    0{must have at least {minmembers}} other{must have at least {minmembers} and no more than {maxmembers}}
                }}
            }}
        } players`,
    // invite
    "team-status-dialog:invite-players": "Add players that are currently not part of your team:",
    "team-status-dialog:invite-link": "Invite link:",
    "team-status-dialog:copy": "Copy",
    "team-status-dialog:members": "Members",
};

class RosterEligibilityStatusConfig {
    get restrictionSorting() {
        return ["teamSize", "inCountryList", "residence_nationality", "alternateLeague"];
    }
}
RosterEligibilityStatusConfig.ɵfac = function RosterEligibilityStatusConfig_Factory(t) { return new (t || RosterEligibilityStatusConfig)(); };
RosterEligibilityStatusConfig.ɵprov = i0.ɵɵdefineInjectable({ token: RosterEligibilityStatusConfig, factory: RosterEligibilityStatusConfig.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RosterEligibilityStatusConfig, [{
        type: Injectable
    }], null, null); })();

function RosterEligibilityStatusComponent_li_2__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 10);
    i0.ɵɵelement(1, "path", 11);
    i0.ɵɵelementEnd();
} }
function RosterEligibilityStatusComponent_li_2__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 12);
    i0.ɵɵelement(1, "path", 13);
    i0.ɵɵelementEnd();
} }
const _c0$a = function (a0, a1, a2, a3) { return { minmembers: a0, maxmembers: a1, type: a2, leagueids: a3, countries: "", nationalities: "" }; };
function RosterEligibilityStatusComponent_li_2_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, (ctx_r4.isRosterLeague ? "manage-roster:roster-eligibility-status-" : "team-status-dialog:team-eligibility-status-") + restriction_r1.type, i0.ɵɵpureFunction4(4, _c0$a, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.minmembers, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.maxmembers, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.type, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.leagueids == null ? null : restriction_r1.params.leagueids.join(", "))), " ");
} }
function RosterEligibilityStatusComponent_li_2_div_4_ng_container_3_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const league_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", league_r13.uri, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(league_r13.name.full);
} }
function RosterEligibilityStatusComponent_li_2_div_4_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, RosterEligibilityStatusComponent_li_2_div_4_ng_container_3_a_1_Template, 2, 2, "a", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const league_r13 = ctx.$implicit;
    const isLast_r14 = ctx.last;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", league_r13);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", isLast_r14 ? "" : ", ", " ");
} }
const _c1$4 = function () { return { leagueids: "" }; };
function RosterEligibilityStatusComponent_li_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, RosterEligibilityStatusComponent_li_2_div_4_ng_container_3_Template, 3, 2, "ng-container", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const alternateLeagues_r11 = ctx.ngIf;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 2, ctx_r5.isRosterLeague ? "manage-roster:roster-eligibility-status-alternateLeague" : "team-status-dialog:team-eligibility-status-alternateLeague", i0.ɵɵpureFunction0(5, _c1$4)), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", alternateLeagues_r11);
} }
const _c2 = function (a0) { return { minmembers: a0, countries: "" }; };
function RosterEligibilityStatusComponent_li_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(3, 2, ctx_r6.isRosterLeague ? "manage-roster:roster-eligibility-status-inCountryList" : "team-status-dialog:team-eligibility-status-inCountryList", i0.ɵɵpureFunction1(5, _c2, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.minmembers)), " ", restriction_r1.params.countryNames.join(", "), " ");
} }
const _c3 = function (a0) { return { minmembers: a0 }; };
function RosterEligibilityStatusComponent_li_2_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "manage-roster:roster-eligibility-status-residence_nationality", i0.ɵɵpureFunction1(4, _c3, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.minmembers)), " ");
} }
function RosterEligibilityStatusComponent_li_2_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(3, 4, "team-status-dialog:team-eligibility-status-residenceNationality:residence", i0.ɵɵpureFunction1(9, _c3, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.minmembers)), " ", restriction_r1.params.countryNames.join(", "), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(6, 7, "team-status-dialog:team-eligibility-status-residenceNationality:nationality"), " ", restriction_r1.params.nationalityNames.join(", "), " ");
} }
const _c4 = function (a0) { return { exists: a0 }; };
function RosterEligibilityStatusComponent_li_2_a_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r1 = i0.ɵɵnextContext().$implicit;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("locationHref", ctx_r9.uploadPhotoLink);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 2, "manage-roster:upload-logo", i0.ɵɵpureFunction1(5, _c4, restriction_r1.passed ? 1 : 0)), " ");
} }
function RosterEligibilityStatusComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 3);
    i0.ɵɵtemplate(1, RosterEligibilityStatusComponent_li_2__svg_svg_1_Template, 2, 0, "svg", 4);
    i0.ɵɵtemplate(2, RosterEligibilityStatusComponent_li_2__svg_svg_2_Template, 2, 0, "svg", 5);
    i0.ɵɵtemplate(3, RosterEligibilityStatusComponent_li_2_div_3_Template, 3, 9, "div", 6);
    i0.ɵɵtemplate(4, RosterEligibilityStatusComponent_li_2_div_4_Template, 4, 6, "div", 7);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵtemplate(6, RosterEligibilityStatusComponent_li_2_div_6_Template, 4, 7, "div", 8);
    i0.ɵɵtemplate(7, RosterEligibilityStatusComponent_li_2_div_7_Template, 3, 6, "div", 6);
    i0.ɵɵtemplate(8, RosterEligibilityStatusComponent_li_2_div_8_Template, 7, 11, "div", 8);
    i0.ɵɵtemplate(9, RosterEligibilityStatusComponent_li_2_a_9_Template, 3, 7, "a", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", restriction_r1.passed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", restriction_r1.type !== "residence_nationality" && restriction_r1.type !== "inCountryList" && restriction_r1.type !== "alternateLeague");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", restriction_r1.type === "alternateLeague" && i0.ɵɵpipeBind1(5, 9, ctx_r0.alternateLeagues));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", restriction_r1.type === "inCountryList");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", restriction_r1.type === "residence_nationality" && ctx_r0.isRosterLeague);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", restriction_r1.type === "residence_nationality" && !ctx_r0.isRosterLeague);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", restriction_r1.type === "logo");
} }
class RosterEligibilityStatusComponent {
    constructor(links, store) {
        this.links = links;
        this.store = store;
        this.moreInfoClick = new EventEmitter();
    }
    ngOnChanges() {
        const alternateLeagueRestriction = find(this.restrictions, ["type", "alternateLeague"]);
        if (alternateLeagueRestriction) {
            const { params: { leagueids }, } = alternateLeagueRestriction;
            this.store.dispatch(new LoadLeaguesOnceAction(leagueids));
            this.alternateLeagues = this.store.select(getLeagues(leagueids)).pipe(map$1(leagues => leagues.toArray().map(({ entry }) => entry)), map$1(leagues => leagues.filter(Boolean)), startWith([]));
        }
    }
    get uploadPhotoLink() {
        return this.links.teamUploadLogo(+this.team.id);
    }
}
RosterEligibilityStatusComponent.ɵfac = function RosterEligibilityStatusComponent_Factory(t) { return new (t || RosterEligibilityStatusComponent)(i0.ɵɵdirectiveInject(i2.LinkService), i0.ɵɵdirectiveInject(i1$1.Store)); };
RosterEligibilityStatusComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RosterEligibilityStatusComponent, selectors: [["roster-eligibility-status"]], inputs: { league: "league", team: "team", restrictions: "restrictions", isRosterLeague: "isRosterLeague" }, outputs: { moreInfoClick: "moreInfoClick" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [[1, "c-team-eligibility-status"], [1, "c-team-eligibility-status__restriction-list"], ["class", "c-team-eligibility-status__restriction", 3, "ngSwitch", 4, "ngFor", "ngForOf"], [1, "c-team-eligibility-status__restriction", 3, "ngSwitch"], ["class", "u-svg-text c-team-eligibility-status__icon is-passing", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg", 4, "ngSwitchCase"], ["class", "u-svg-text c-team-eligibility-status__icon is-failing", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg", 4, "ngSwitchCase"], [4, "ngIf"], ["class", "c-team-eligibility-status__restriction-alternateLeague", 4, "ngIf"], ["class", "c-team-eligibility-status__restriction-residenceNationality", 4, "ngIf"], [3, "locationHref", 4, "ngIf"], ["viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg", 1, "u-svg-text", "c-team-eligibility-status__icon", "is-passing"], ["d", "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"], ["viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg", 1, "u-svg-text", "c-team-eligibility-status__icon", "is-failing"], ["d", "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"], [1, "c-team-eligibility-status__restriction-alternateLeague"], [4, "ngFor", "ngForOf"], ["target", "_blank", 3, "href", 4, "ngIf"], ["target", "_blank", 3, "href"], [1, "c-team-eligibility-status__restriction-residenceNationality"], [3, "locationHref"]], template: function RosterEligibilityStatusComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "ul", 1);
        i0.ɵɵtemplate(2, RosterEligibilityStatusComponent_li_2_Template, 10, 11, "li", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.restrictions);
    } }, directives: [i2$1.NgForOf, i2$1.NgSwitch, i2$1.NgSwitchCase, i2$1.NgIf, i2.LocationDirective], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RosterEligibilityStatusComponent, [{
        type: Component,
        args: [{
                selector: "roster-eligibility-status",
                templateUrl: "./roster-eligibility-status.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i2.LinkService }, { type: i1$1.Store }]; }, { league: [{
            type: Input
        }], team: [{
            type: Input
        }], restrictions: [{
            type: Input
        }], isRosterLeague: [{
            type: Input
        }], moreInfoClick: [{
            type: Output
        }] }); })();

class MemberEligibilityStatusConfig {
    get memberSorting() {
        return ["nickname"];
    }
    get restrictionSorting() {
        return [
            "gameaccount",
            "ga_team_positions",
            "premium",
            "trustlevel",
            "inCountryList",
            "residence_nationality",
            "age",
            "minage",
            "gender",
            "photo",
            "isadmin",
        ];
    }
}
MemberEligibilityStatusConfig.ɵfac = function MemberEligibilityStatusConfig_Factory(t) { return new (t || MemberEligibilityStatusConfig)(); };
MemberEligibilityStatusConfig.ɵprov = i0.ɵɵdefineInjectable({ token: MemberEligibilityStatusConfig, factory: MemberEligibilityStatusConfig.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberEligibilityStatusConfig, [{
        type: Injectable
    }], null, null); })();

class MemberEligibilityFactory {
    constructor(config, helper, rFilter, date) {
        this.config = config;
        this.helper = helper;
        this.rFilter = rFilter;
        this.date = date;
    }
    getMemberEligibility(member, user, league, restrictions, participants) {
        const memberRestrictions = filter$1(restrictions, restriction => this.rFilter.affectsMembers(restriction));
        return {
            restrictions: this.getMemberEligibilityRestrictions(member, restrictions),
            infos: this.getMemberEligibilityInfos(member, user, league, restrictions, participants),
            disabled: !this.helper.isMemberEligible(memberRestrictions, member),
        };
    }
    getMemberEligibilityRestrictions(member, restrictions) {
        const memberRestrictions = sortBy(this.rFilter.getMemberRestrictions(restrictions), [
            restriction => {
                return this.config.restrictionSorting.indexOf(restriction.type) + 1;
            },
        ], ["asc"]);
        return memberRestrictions.map(restriction => {
            return {
                type: restriction.type,
                passed: this.helper.passesMemberRestriciton(restriction, parseInt(member.user.id, 10)),
            };
        });
    }
    getMemberEligibilityInfos(member, user, league, restrictions, participants) {
        const memberRestrictions = filter$1(restrictions, restriction => this.rFilter.affectsMembers(restriction));
        if (this.helper.isMemberEligible(memberRestrictions, member)) {
            return [{ text: "manage-roster:ready-to-play", params: {} }];
        }
        const texts = [];
        const ppStatus = this.helper.getPlayerPPStatus(restrictions, parseInt(member.user.id, 10));
        const bannedStatus = this.helper.getPlayerBannedStatus(restrictions, parseInt(member.user.id, 10));
        const rosterStatus = this.helper.getAlternateRosterStatus(restrictions, parseInt(member.user.id, 10));
        if (ppStatus) {
            texts.push({
                text: "manage-roster:too-many-pps-until",
                params: {
                    until: this.date.formatDate(ppStatus.until, user.timezone),
                },
            });
        }
        if (bannedStatus) {
            texts.push({
                text: "manage-roster:banned-until",
                params: {
                    until: this.date.formatDate(bannedStatus.until, user.timezone),
                },
            });
        }
        if (rosterStatus) {
            const team = find(participants, participant => participant.id === rosterStatus.teamId);
            const hostname = window.location.hostname;
            texts.push({
                text: "manage-roster:alternate-roster",
                params: {
                    teamName: team.name,
                    team: `<a href="https://${hostname}${league.uri}roster/${team.id}">${team.name}</a>`,
                },
            });
        }
        if (member.user.isBarred) {
            texts.push({
                text: "manage-roster:barred-until",
                params: {
                    until: this.date.formatDate(member.user.barredUntil, user.timezone),
                },
            });
        }
        if (texts.length === 0) {
            return [{ text: "manage-roster:not-ready-to-play", params: {} }];
        }
        return texts;
    }
}
MemberEligibilityFactory.ɵfac = function MemberEligibilityFactory_Factory(t) { return new (t || MemberEligibilityFactory)(i0.ɵɵinject(MemberEligibilityStatusConfig), i0.ɵɵinject(i2.RestrictionService), i0.ɵɵinject(i2.RestrictionFilterService), i0.ɵɵinject(i2.FormatDate)); };
MemberEligibilityFactory.ɵprov = i0.ɵɵdefineInjectable({ token: MemberEligibilityFactory, factory: MemberEligibilityFactory.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberEligibilityFactory, [{
        type: Injectable
    }], function () { return [{ type: MemberEligibilityStatusConfig }, { type: i2.RestrictionService }, { type: i2.RestrictionFilterService }, { type: i2.FormatDate }]; }, null); })();

const _c0$9 = function (a0, a1, a2, a3, a4, a5, a6, a7) { return { gender: a0, minage: a1, gameaccount: a2, trustlevel: a3, teampositions: a4, countries: a5, nationalities: a6, min: a7 }; };
const _c1$3 = function (a0, a1, a2, a3, a4, a5, a6) { return { gender: a0, minage: a1, gameaccount: a2, trustlevel: a3, teampositions: a4, countries: a5, nationalities: a6 }; };
function MemberEligibilityHeaderComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r1 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(1, 2, "team-status-dialog:member-eligibility-status-" + restriction_r1.type, i0.ɵɵpureFunction8(8, _c0$9, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.gender, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.minage, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.type, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.mintrustlevel, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.team_positions == null ? null : restriction_r1.params.team_positions.join(", "), restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.countries == null ? null : restriction_r1.params.countries.join(", "), restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.nationalities == null ? null : restriction_r1.params.nationalities.join(", "), restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.min)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 5, "team-status-dialog:member-eligibility-status-" + restriction_r1.type + "-title", i0.ɵɵpureFunction7(17, _c1$3, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.gender, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.minage, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.type, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.mintrustlevel, restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.team_positions == null ? null : restriction_r1.params.team_positions.join(", "), restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.countries == null ? null : restriction_r1.params.countries.join(", "), restriction_r1 == null ? null : restriction_r1.params == null ? null : restriction_r1.params.nationalities == null ? null : restriction_r1.params.nationalities.join(", "))), " ");
} }
class MemberEligibilityHeaderComponent {
}
MemberEligibilityHeaderComponent.ɵfac = function MemberEligibilityHeaderComponent_Factory(t) { return new (t || MemberEligibilityHeaderComponent)(); };
MemberEligibilityHeaderComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MemberEligibilityHeaderComponent, selectors: [["member-eligibility-header"]], inputs: { restrictions: "restrictions", isRosterLeague: "isRosterLeague" }, decls: 5, vars: 4, consts: [[1, "c-members-eligibility-status__table__headers"], [1, "c-members-eligibility-status__table__header", "c-members-eligibility-status__table__header--member"], ["class", "c-members-eligibility-status__table__header", 3, "title", 4, "ngFor", "ngForOf"], [1, "c-members-eligibility-status__table__header", 3, "title"]], template: function MemberEligibilityHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, MemberEligibilityHeaderComponent_div_4_Template, 4, 25, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, ctx.isRosterLeague ? "manage-roster:selected" : "team-status-dialog:members"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.restrictions);
    } }, directives: [i2$1.NgForOf], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberEligibilityHeaderComponent, [{
        type: Component,
        args: [{
                selector: "member-eligibility-header",
                templateUrl: "./member-eligibility-header.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { restrictions: [{
            type: Input,
            args: ["restrictions"]
        }], isRosterLeague: [{
            type: Input
        }] }); })();

function MemberEligibilityComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "country-flag", 7);
    i0.ɵɵelementStart(2, "a", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("country", ctx_r1.member.region)("size", 16);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("locationHref", ctx_r1.getPlayerLink(ctx_r1.member))("title", ctx_r1.member.nickname);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.member.nickname, " ");
} }
function MemberEligibilityComponent_ng_template_2_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const info_r8 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, info_r8.text, info_r8.params), i0.ɵɵsanitizeHtml);
} }
function MemberEligibilityComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0);
    i0.ɵɵtemplate(1, MemberEligibilityComponent_ng_template_2_div_1_Template, 2, 4, "div", 9);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.infos);
} }
function MemberEligibilityComponent_described_checkbox_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 14);
} }
function MemberEligibilityComponent_described_checkbox_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 15);
} }
function MemberEligibilityComponent_described_checkbox_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "described-checkbox", 11);
    i0.ɵɵlistener("checkedChange", function MemberEligibilityComponent_described_checkbox_6_Template_described_checkbox_checkedChange_0_listener($event) { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.selectedChange.emit($event); });
    i0.ɵɵtemplate(1, MemberEligibilityComponent_described_checkbox_6_ng_container_1_Template, 1, 0, "ng-container", 12);
    i0.ɵɵtemplate(2, MemberEligibilityComponent_described_checkbox_6_ng_container_2_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(1);
    const _r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("disabled", ctx_r4.isDisabled)("checked", ctx_r4.isSelected);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function MemberEligibilityComponent_div_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function MemberEligibilityComponent_div_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function MemberEligibilityComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MemberEligibilityComponent_div_7_ng_container_1_Template, 1, 0, "ng-container", 16);
    i0.ɵɵtemplate(2, MemberEligibilityComponent_div_7_ng_container_2_Template, 1, 0, "ng-container", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(1);
    const _r2 = i0.ɵɵreference(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function MemberEligibilityComponent_div_8__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 20);
    i0.ɵɵelement(1, "path", 21);
    i0.ɵɵelementEnd();
} }
function MemberEligibilityComponent_div_8__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 22);
    i0.ɵɵelement(1, "path", 23);
    i0.ɵɵelementEnd();
} }
function MemberEligibilityComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, MemberEligibilityComponent_div_8__svg_svg_1_Template, 2, 0, "svg", 18);
    i0.ɵɵtemplate(2, MemberEligibilityComponent_div_8__svg_svg_2_Template, 2, 0, "svg", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const restriction_r15 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", restriction_r15.passed);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !restriction_r15.passed);
} }
const _c0$8 = function (a0) { return { "is-selected": a0 }; };
const _c1$2 = ["*"];
class MemberEligibilityComponent {
    constructor(links) {
        this.links = links;
        this.selectedChange = new EventEmitter();
    }
    getPlayerLink(player) {
        return this.links.player(+player.id, player.alias);
    }
}
MemberEligibilityComponent.ɵfac = function MemberEligibilityComponent_Factory(t) { return new (t || MemberEligibilityComponent)(i0.ɵɵdirectiveInject(i2.LinkService)); };
MemberEligibilityComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MemberEligibilityComponent, selectors: [["member-eligibility"]], inputs: { member: "member", restrictions: "restrictions", infos: "infos", isDisabled: ["disabled", "isDisabled"], isSelected: ["selected", "isSelected"], isManager: ["manager", "isManager"] }, outputs: { selectedChange: "selectedChange" }, ngContentSelectors: _c1$2, decls: 9, vars: 6, consts: [["name", ""], ["info", ""], [1, "c-member-eligibility", 3, "ngClass"], [1, "c-members-eligibility-status__table__column", "c-members-eligibility-status__table__column--name"], [3, "disabled", "checked", "checkedChange", 4, "ngIf"], [4, "ngIf"], ["class", "c-members-eligibility-status__table__column", 4, "ngFor", "ngForOf"], [1, "c-member-eligibility__flag", 3, "country", "size"], [1, "c-member-eligibility__name", 3, "locationHref", "title"], ["class", "c-member-eligibility__info", 3, "innerHTML", 4, "ngFor", "ngForOf"], [1, "c-member-eligibility__info", 3, "innerHTML"], [3, "disabled", "checked", "checkedChange"], ["input-label", "", 4, "ngTemplateOutlet"], ["input-description", "", 4, "ngTemplateOutlet"], ["input-label", ""], ["input-description", ""], [4, "ngTemplateOutlet"], [1, "c-members-eligibility-status__table__column"], ["class", "u-svg-text c-member-eligibility__icon is-passing", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg", 4, "ngIf"], ["class", "u-svg-text c-member-eligibility__icon is-failing", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg", 4, "ngIf"], ["viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg", 1, "u-svg-text", "c-member-eligibility__icon", "is-passing"], ["d", "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"], ["viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg", 1, "u-svg-text", "c-member-eligibility__icon", "is-failing"], ["d", "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"]], template: function MemberEligibilityComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, MemberEligibilityComponent_ng_template_0_Template, 4, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(2, MemberEligibilityComponent_ng_template_2_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵtemplate(6, MemberEligibilityComponent_described_checkbox_6_Template, 3, 4, "described-checkbox", 4);
        i0.ɵɵtemplate(7, MemberEligibilityComponent_div_7_Template, 3, 2, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, MemberEligibilityComponent_div_8_Template, 3, 2, "div", 6);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0$8, ctx.isSelected));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isManager);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isManager);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.restrictions);
    } }, directives: [i2$1.NgClass, i2$1.NgIf, i2$1.NgForOf, i2.CountryFlagComponent, i2.LocationDirective, i2.DescribedCheckboxComponent, i2$1.NgTemplateOutlet], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberEligibilityComponent, [{
        type: Component,
        args: [{
                selector: "member-eligibility",
                templateUrl: "./member-eligibility.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i2.LinkService }]; }, { member: [{
            type: Input
        }], restrictions: [{
            type: Input
        }], infos: [{
            type: Input
        }], isDisabled: [{
            type: Input,
            args: ["disabled"]
        }], isSelected: [{
            type: Input,
            args: ["selected"]
        }], isManager: [{
            type: Input,
            args: ["manager"]
        }], selectedChange: [{
            type: Output
        }] }); })();

const _c0$7 = function (a0) { return { "is-disabled": a0 }; };
class SelectAllEligibleMembersComponent {
    constructor() {
        this.select = new EventEmitter();
    }
    onSelect() {
        if (this.isDisabled) {
            return;
        }
        this.select.emit();
    }
}
SelectAllEligibleMembersComponent.ɵfac = function SelectAllEligibleMembersComponent_Factory(t) { return new (t || SelectAllEligibleMembersComponent)(); };
SelectAllEligibleMembersComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SelectAllEligibleMembersComponent, selectors: [["select-all-eligible-members"]], inputs: { isDisabled: ["disabled", "isDisabled"] }, outputs: { select: "select" }, decls: 5, vars: 9, consts: [[1, "c-members-eligibility-status__info"], ["href", "#", "role", "button", 1, "c-members-eligibility-status__info__link", 3, "ngClass", "title", "click"]], template: function SelectAllEligibleMembersComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "section", 0);
        i0.ɵɵelementStart(1, "a", 1);
        i0.ɵɵlistener("click", function SelectAllEligibleMembersComponent_Template_a_click_1_listener($event) { $event.preventDefault(); return ctx.onSelect(); });
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("title", ctx.isDisabled ? i0.ɵɵpipeBind1(2, 3, "manage-roster:select-all-eligible-members-disabled") : "");
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c0$7, ctx.isDisabled));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 5, "manage-roster:select-all-eligible-members"), " ");
    } }, directives: [i2$1.NgClass], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectAllEligibleMembersComponent, [{
        type: Component,
        args: [{
                selector: "select-all-eligible-members",
                templateUrl: "./select-all-eligible-members.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { select: [{
            type: Output,
            args: ["select"]
        }], isDisabled: [{
            type: Input,
            args: ["disabled"]
        }] }); })();

const _c0$6 = function (a0) { return { days: a0 }; };
function MemberEligibilityStatusComponent_member_eligibility_4_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 1, "manage-roster:league-ban-warning", i0.ɵɵpureFunction1(4, _c0$6, ctx_r3.league.kickBanDays)), " ");
} }
function MemberEligibilityStatusComponent_member_eligibility_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "member-eligibility", 6);
    i0.ɵɵlistener("selectedChange", function MemberEligibilityStatusComponent_member_eligibility_4_Template_member_eligibility_selectedChange_0_listener($event) { i0.ɵɵrestoreView(_r5); const member_r2 = ctx.$implicit; const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.toggleMember(member_r2.member.id, $event); });
    i0.ɵɵtemplate(1, MemberEligibilityStatusComponent_member_eligibility_4_div_1_Template, 3, 6, "div", 7);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const member_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("infos", member_r2.eligibility.infos)("restrictions", member_r2.eligibility.restrictions)("member", member_r2.member)("disabled", !member_r2.isSelectable)("selected", member_r2.isSelected)("manager", ctx_r0.isManager);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", member_r2.isAboutToGetBanned);
} }
function MemberEligibilityStatusComponent_select_all_eligible_members_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select-all-eligible-members", 9);
    i0.ɵɵlistener("select", function MemberEligibilityStatusComponent_select_all_eligible_members_5_Template_select_all_eligible_members_select_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.selectAllEligibleMembers(); });
    i0.ɵɵelementEnd();
} }
const createMember = (member, eligibility, isSelected, isSelectable, isAboutToGetBanned) => ({
    member,
    eligibility,
    isSelected,
    isSelectable,
    isAboutToGetBanned,
});
class MemberEligibilityStatusComponent {
    constructor(config, rFilter, helper, factory) {
        this.config = config;
        this.rFilter = rFilter;
        this.helper = helper;
        this.factory = factory;
        this.unselectMember = new EventEmitter();
        this.selectMember = new EventEmitter();
    }
    ngOnChanges() {
        this.memberRestrictions = sortBy(this.rFilter.getMemberRestrictions(this.restrictions), [
            restriction => {
                return this.config.restrictionSorting.indexOf(restriction.type) + 1;
            },
        ], ["asc"]);
        this.members = this.teamMembers.map(member => {
            const eligibility = this.factory.getMemberEligibility(member, this.user, this.league, this.restrictions, this.participants);
            return createMember(member.user, eligibility, this.isSelected(+member.user.id), this.selectAble(+member.user.id, eligibility.disabled), this.isAboutToGetBanned(+member.user.id));
        });
    }
    isSelected(memberId) {
        const value = this.selectedMembers.get(memberId);
        return Boolean(value);
    }
    selectAble(memberId, memberDisabled) {
        if (this.isSelected(memberId)) {
            return true;
        }
        if (this.maxPlayersCount > 0 && this.maxPlayersCount <= this.selectedMembers.count()) {
            return false;
        }
        return !memberDisabled;
    }
    isAboutToGetBanned(memberId) {
        return (isInProgress(this.league) &&
            isLeagueBanEnabled(this.league) &&
            this.rosterMembers &&
            this.rosterMembers.indexOf(memberId) !== -1 &&
            !this.isSelected(memberId));
    }
    toggleMember(memberId, value) {
        const emitter = value ? this.selectMember : this.unselectMember;
        emitter.emit(+memberId);
    }
    selectAllEligibleMembers() {
        const restrictions = this.restrictions.filter(restriction => this.rFilter.affectsMembers(restriction));
        forEach(this.teamMembers, member => {
            const select = this.helper.isMemberEligible(restrictions, member);
            this.toggleMember(member.user.id, select);
        });
    }
    get maxPlayersCount() {
        return find(this.restrictions, restriction => restriction.type === "teamSize").params.maxmembers;
    }
    trackByMember(item, index) {
        return +item.id;
    }
}
MemberEligibilityStatusComponent.ɵfac = function MemberEligibilityStatusComponent_Factory(t) { return new (t || MemberEligibilityStatusComponent)(i0.ɵɵdirectiveInject(MemberEligibilityStatusConfig), i0.ɵɵdirectiveInject(i2.RestrictionFilterService), i0.ɵɵdirectiveInject(i2.RestrictionService), i0.ɵɵdirectiveInject(MemberEligibilityFactory)); };
MemberEligibilityStatusComponent.ɵcmp = i0.ɵɵdefineComponent({ type: MemberEligibilityStatusComponent, selectors: [["members-eligibility-status"]], inputs: { participants: "participants", user: "user", restrictions: "restrictions", rosterMembers: "rosterMembers", selectedMembers: "selectedMembers", league: "league", isManager: "isManager", isRosterLeague: "isRosterLeague", teamMembers: "teamMembers" }, outputs: { unselectMember: "unselectMember", selectMember: "selectMember" }, features: [i0.ɵɵNgOnChangesFeature], decls: 6, vars: 5, consts: [[1, "c-members-eligibility-status"], [1, "c-members-eligibility-status__table"], [3, "restrictions", "isRosterLeague"], [1, "c-members-eligibility-status__table__member-list"], [3, "infos", "restrictions", "member", "disabled", "selected", "manager", "selectedChange", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "select", 4, "ngIf"], [3, "infos", "restrictions", "member", "disabled", "selected", "manager", "selectedChange"], ["class", "c-members-eligibility-status__kick-warning", 4, "ngIf"], [1, "c-members-eligibility-status__kick-warning"], [3, "select"]], template: function MemberEligibilityStatusComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "section", 1);
        i0.ɵɵelement(2, "member-eligibility-header", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtemplate(4, MemberEligibilityStatusComponent_member_eligibility_4_Template, 2, 7, "member-eligibility", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, MemberEligibilityStatusComponent_select_all_eligible_members_5_Template, 1, 0, "select-all-eligible-members", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("restrictions", ctx.memberRestrictions)("isRosterLeague", ctx.isRosterLeague);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.members)("ngForTrackBy", ctx.trackByMember);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isManager);
    } }, directives: [MemberEligibilityHeaderComponent, i2$1.NgForOf, i2$1.NgIf, MemberEligibilityComponent, SelectAllEligibleMembersComponent], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MemberEligibilityStatusComponent, [{
        type: Component,
        args: [{
                selector: "members-eligibility-status",
                templateUrl: "./member-eligbility-status.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: MemberEligibilityStatusConfig }, { type: i2.RestrictionFilterService }, { type: i2.RestrictionService }, { type: MemberEligibilityFactory }]; }, { participants: [{
            type: Input
        }], user: [{
            type: Input
        }], restrictions: [{
            type: Input
        }], rosterMembers: [{
            type: Input
        }], selectedMembers: [{
            type: Input
        }], league: [{
            type: Input
        }], isManager: [{
            type: Input
        }], isRosterLeague: [{
            type: Input
        }], unselectMember: [{
            type: Output
        }], selectMember: [{
            type: Output
        }], teamMembers: [{
            type: Input
        }] }); })();

class SaveRosterComponent {
    constructor() {
        this.save = new EventEmitter();
        this.cancel = new EventEmitter();
    }
}
SaveRosterComponent.ɵfac = function SaveRosterComponent_Factory(t) { return new (t || SaveRosterComponent)(); };
SaveRosterComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SaveRosterComponent, selectors: [["save-roster"]], inputs: { loading: "loading", disabled: "disabled" }, outputs: { save: "save", cancel: "cancel" }, decls: 6, vars: 9, consts: [[1, "c-button--group", "c-button--big", "c-button--primary", 3, "disabled", "loading", "clicked"], [1, "c-button--group", "c-button--big", "c-button--secondary", 3, "disabled", "clicked"]], template: function SaveRosterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "play-button", 0);
        i0.ɵɵlistener("clicked", function SaveRosterComponent_Template_play_button_clicked_0_listener() { return ctx.save.emit(); });
        i0.ɵɵtext(1);
        i0.ɵɵpipe(2, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "play-button", 1);
        i0.ɵɵlistener("clicked", function SaveRosterComponent_Template_play_button_clicked_3_listener() { return ctx.cancel.emit(); });
        i0.ɵɵtext(4);
        i0.ɵɵpipe(5, "translate");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("disabled", ctx.disabled)("loading", ctx.loading);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 5, "manage-roster:save"), "\n");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.loading);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, "manage-roster:cancel"), "\n");
    } }, directives: [i2.ButtonComponent], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SaveRosterComponent, [{
        type: Component,
        args: [{
                selector: "save-roster",
                templateUrl: "./save-roster.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, { loading: [{
            type: Input
        }], disabled: [{
            type: Input
        }], save: [{
            type: Output
        }], cancel: [{
            type: Output
        }] }); })();

function ManageRosterComponent_inline_error_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r2 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(error_r2);
} }
function ManageRosterComponent_inline_error_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtemplate(1, ManageRosterComponent_inline_error_5_div_1_Template, 2, 1, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.errors);
} }
class ManageRosterComponent {
    constructor(transformer, rFilter, rosterEligibilityStatusConfig) {
        this.transformer = transformer;
        this.rFilter = rFilter;
        this.rosterEligibilityStatusConfig = rosterEligibilityStatusConfig;
        this.save = new EventEmitter();
        this.cancel = new EventEmitter();
        this.selectedMembers = Map();
    }
    setTeamRestrictions(restrictions, rosterMembers) {
        let patchedRestrictions = restrictions.map(restriction => {
            switch (restriction.type) {
                case "teamSize":
                    return this.transformer.transformTeamSizeWithParams(restriction);
            }
            return restriction;
        });
        patchedRestrictions = this.transformer.teamRestrictionsToRoster(rosterMembers, patchedRestrictions);
        patchedRestrictions = this.transformer.countryCodeToCountryName(patchedRestrictions);
        patchedRestrictions = this.rFilter.getTeamRestrictions(patchedRestrictions);
        // First restrictions that have passed, then sort according to list
        this.teamRestrictions = orderBy(patchedRestrictions, [
            "passed",
            restriction => {
                return this.rosterEligibilityStatusConfig.restrictionSorting.indexOf(restriction.type) + 1;
            },
        ], ["desc", "asc"]);
    }
    ngOnChanges(changes) {
        if (this.teamMembers && this.user) {
            this.isUserManager = find(this.teamMembers, (member) => isLeader(member.membership) && member.user.id === this.user.id);
        }
        const members = filter$1(this.teamMembers, (member) => {
            return ["honorary_member", "inactive"].indexOf(member.membership.role) === -1;
        });
        if (changes.rosterMembers) {
            this.selectedMembers = this.getPreselection(members);
        }
        this.members = orderBy(members, [
            member => {
                if (this.selectedMembers.get(+member.user.id)) {
                    return 1;
                }
                return 0;
            },
            member => member.user.nickname.toLowerCase(),
        ], ["desc", "asc"]);
        this.updateRosterMembers(this.selectedMembers);
    }
    getPreselection(teamMembers) {
        let selectedMembers = Map();
        forEach(teamMembers, member => {
            const preSelected = this.rosterMembers.indexOf(parseInt(member.user.id, 10)) !== -1;
            if (preSelected) {
                selectedMembers = selectedMembers.set(parseInt(member.user.id, 10), preSelected);
            }
            else {
                selectedMembers = selectedMembers.delete(parseInt(member.user.id, 10));
            }
        });
        return selectedMembers;
    }
    updateRosterMembers(members) {
        const rosterMembers = members.keySeq().toArray();
        this.setTeamRestrictions(this.restrictions, rosterMembers);
    }
    selectMember(memberId) {
        this.selectedMembers = this.selectedMembers.set(memberId, true);
        this.updateRosterMembers(this.selectedMembers);
    }
    unselectMember(memberId) {
        this.selectedMembers = this.selectedMembers.delete(memberId);
        this.updateRosterMembers(this.selectedMembers);
    }
    get maxPlayersCount() {
        return find(this.restrictions, restriction => restriction.type === "teamSize").params.maxmembers;
    }
    onSave() {
        const rosterMembers = this.selectedMembers.keySeq().toArray();
        this.save.emit(rosterMembers);
    }
}
ManageRosterComponent.ɵfac = function ManageRosterComponent_Factory(t) { return new (t || ManageRosterComponent)(i0.ɵɵdirectiveInject(i2.RestrictionTransformerService), i0.ɵɵdirectiveInject(i2.RestrictionFilterService), i0.ɵɵdirectiveInject(RosterEligibilityStatusConfig)); };
ManageRosterComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ManageRosterComponent, selectors: [["manage-roster"]], inputs: { participants: "participants", user: "user", league: "league", restrictions: "restrictions", team: "team", teamMembers: "teamMembers", rosterMembers: "rosterMembers", isRosterLeague: "isRosterLeague", errors: "errors", loading: "loading" }, outputs: { save: "save", cancel: "cancel" }, features: [i0.ɵɵNgOnChangesFeature], decls: 9, vars: 17, consts: [[1, "c-team-status"], [1, "c-team-status__team"], [3, "restrictions", "team", "league", "isRosterLeague"], [1, "c-team-status__member"], [3, "user", "participants", "league", "teamMembers", "restrictions", "rosterMembers", "selectedMembers", "isManager", "isRosterLeague", "selectMember", "unselectMember"], [4, "ngIf"], [1, "c-team-status__invite"], [3, "team"], [3, "loading", "disabled", "save", "cancel"], [4, "ngFor", "ngForOf"]], template: function ManageRosterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "section", 1);
        i0.ɵɵelement(2, "roster-eligibility-status", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "section", 3);
        i0.ɵɵelementStart(4, "members-eligibility-status", 4);
        i0.ɵɵlistener("selectMember", function ManageRosterComponent_Template_members_eligibility_status_selectMember_4_listener($event) { return ctx.selectMember($event); })("unselectMember", function ManageRosterComponent_Template_members_eligibility_status_unselectMember_4_listener($event) { return ctx.unselectMember($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, ManageRosterComponent_inline_error_5_Template, 2, 1, "inline-error", 5);
        i0.ɵɵelementStart(6, "section", 6);
        i0.ɵɵelement(7, "team-invite", 7);
        i0.ɵɵelementStart(8, "save-roster", 8);
        i0.ɵɵlistener("save", function ManageRosterComponent_Template_save_roster_save_8_listener() { return ctx.onSave(); })("cancel", function ManageRosterComponent_Template_save_roster_cancel_8_listener() { return ctx.cancel.emit(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("restrictions", ctx.teamRestrictions)("team", ctx.team)("league", ctx.league)("isRosterLeague", ctx.isRosterLeague);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("user", ctx.user)("participants", ctx.participants)("league", ctx.league)("teamMembers", ctx.members)("restrictions", ctx.restrictions)("rosterMembers", ctx.rosterMembers)("selectedMembers", ctx.selectedMembers)("isManager", true)("isRosterLeague", ctx.isRosterLeague);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.length);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("team", ctx.team);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("loading", ctx.loading)("disabled", ctx.maxPlayersCount && ctx.selectedMembers.size > ctx.maxPlayersCount);
    } }, directives: [RosterEligibilityStatusComponent, MemberEligibilityStatusComponent, i2$1.NgIf, TeamInviteComponent, SaveRosterComponent, i2.InlineErrorComponent, i2$1.NgForOf], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ManageRosterComponent, [{
        type: Component,
        args: [{
                selector: "manage-roster",
                templateUrl: "./manage-roster.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i2.RestrictionTransformerService }, { type: i2.RestrictionFilterService }, { type: RosterEligibilityStatusConfig }]; }, { participants: [{
            type: Input
        }], user: [{
            type: Input
        }], league: [{
            type: Input
        }], restrictions: [{
            type: Input
        }], team: [{
            type: Input
        }], teamMembers: [{
            type: Input
        }], rosterMembers: [{
            type: Input
        }], isRosterLeague: [{
            type: Input
        }], errors: [{
            type: Input
        }], loading: [{
            type: Input
        }], save: [{
            type: Output
        }], cancel: [{
            type: Output
        }] }); })();

const moment = momentImported;
class RosterPreSelectionCache extends Cache {
    constructor(cache) {
        super();
        this.cache = cache;
    }
    getCacheKey(id) {
        throw new Error("Use getRosterKey instead");
    }
    /**
     * Returns the full cache key for the preselected roster resource
     *
     * @param leagueId
     * @param teamId
     */
    getRosterKey(leagueId, teamId) {
        return `league-widget:roster-preselect:${leagueId}:${teamId}`;
    }
    /**
     * Get the preselected roster resource from cache
     *
     * @param leagueId
     * @param teamId
     */
    getRoster(leagueId, teamId) {
        return this.cache.getObservable(`${this.getRosterKey(leagueId, teamId)}`).pipe(map$1(members => members || []));
    }
    /**
     * Save the preselected roster resource in cache for 48 hours
     *
     * @param leagueId
     * @param teamId
     * @param rosterMembers
     */
    setRoster(leagueId, teamId, rosterMembers) {
        return this.cache.setItem(`${this.getRosterKey(leagueId, teamId)}`, rosterMembers, moment.utc().add(48, "hours"));
    }
}
RosterPreSelectionCache.ɵfac = function RosterPreSelectionCache_Factory(t) { return new (t || RosterPreSelectionCache)(i0.ɵɵinject(i1$2.CacheService)); };
RosterPreSelectionCache.ɵprov = i0.ɵɵdefineInjectable({ token: RosterPreSelectionCache, factory: RosterPreSelectionCache.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RosterPreSelectionCache, [{
        type: Injectable
    }], function () { return [{ type: i1$2.CacheService }]; }, null); })();

class RosterPreSelectionEffects {
    constructor(cache, actions$) {
        this.cache = cache;
        this.actions$ = actions$;
        this.loadRoster$ = this.actions$.pipe(ofType(PreSelectionActionTypes.LOAD_ROSTER), mergeMap((action) => {
            const nextSearch$ = this.actions$.pipe(ofType(PreSelectionActionTypes.LOAD_ROSTER), skip(1));
            return this.cache.getRoster(action.leagueId, action.teamId).pipe(takeUntil(nextSearch$), map$1((rosterMembers) => new LoadRosterCompleteAction(action.leagueId, action.teamId, rosterMembers)));
        }));
        this.setRoster$ = this.actions$.pipe(ofType(PreSelectionActionTypes.SET_ROSTER), switchMap((action) => {
            return this.cache.getRoster(action.leagueId, action.teamId).pipe(take(1), map$1(members => {
                this.cache.setRoster(action.leagueId, action.teamId, action.members);
            }));
        }));
    }
}
RosterPreSelectionEffects.ɵfac = function RosterPreSelectionEffects_Factory(t) { return new (t || RosterPreSelectionEffects)(i0.ɵɵinject(RosterPreSelectionCache), i0.ɵɵinject(i1$3.Actions)); };
RosterPreSelectionEffects.ɵprov = i0.ɵɵdefineInjectable({ token: RosterPreSelectionEffects, factory: RosterPreSelectionEffects.ɵfac });
__decorate([
    Effect(),
    __metadata("design:type", Observable)
], RosterPreSelectionEffects.prototype, "loadRoster$", void 0);
__decorate([
    Effect({ dispatch: false }),
    __metadata("design:type", Observable)
], RosterPreSelectionEffects.prototype, "setRoster$", void 0);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RosterPreSelectionEffects, [{
        type: Injectable
    }], function () { return [{ type: RosterPreSelectionCache }, { type: i1$3.Actions }]; }, { loadRoster$: [], setRoster$: [] }); })();

function RosterPreselectDialogComponent_div_0_loading_spinner_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner");
} }
function RosterPreselectDialogComponent_div_0_inline_error_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"), " ");
} }
function RosterPreselectDialogComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, RosterPreselectDialogComponent_div_0_loading_spinner_1_Template, 1, 0, "loading-spinner", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, RosterPreselectDialogComponent_div_0_inline_error_3_Template, 3, 3, "inline-error", 2);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r0.isLoading$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx_r0.hasError$));
} }
const _c0$5 = function () { return []; };
function RosterPreselectDialogComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "manage-roster", 3);
    i0.ɵɵlistener("cancel", function RosterPreselectDialogComponent_ng_template_3_Template_manage_roster_cancel_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.onCancel(); })("save", function RosterPreselectDialogComponent_ng_template_3_Template_manage_roster_save_0_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.onSave($event); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("team", i0.ɵɵpipeBind1(1, 9, ctx_r2.team$).entry)("teamMembers", i0.ɵɵpipeBind1(2, 11, ctx_r2.teamMembers$).entry)("rosterMembers", i0.ɵɵpipeBind1(3, 13, ctx_r2.rosterMembers$))("restrictions", i0.ɵɵpipeBind1(4, 15, ctx_r2.restrictions$).entry)("league", i0.ɵɵpipeBind1(5, 17, ctx_r2.league$).entry)("user", i0.ɵɵpipeBind1(6, 19, ctx_r2.user$).entry)("participants", i0.ɵɵpipeBind1(7, 21, ctx_r2.participants$).entry)("isRosterLeague", ctx_r2.isRosterLeague)("errors", i0.ɵɵpureFunction0(23, _c0$5));
} }
class RosterPreselectDialogComponent {
    constructor(store) {
        this.store = store;
        this.cancel = new EventEmitter();
        this.save = new EventEmitter();
    }
    ngOnInit() {
        this.user$ = this.store.select(getUser);
        this.store.dispatch(new LoadLeagueRestrictionsOnceAction(this.leagueId, this.teamId));
        this.restrictions$ = this.store.select(getLeagueRestrictions(this.leagueId, this.teamId)).pipe();
        this.store.dispatch(new LoadParticipantsOnceAction(this.leagueId));
        this.participants$ = this.store.select(getLeagueParticipants(this.leagueId)).pipe();
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId)).pipe();
        this.store.dispatch(new LoadTeamOnceAction(this.teamId));
        this.team$ = this.store.select(getTeam(this.teamId)).pipe();
        this.store.dispatch(new LoadMembersOnceAction(this.teamId));
        this.teamMembers$ = this.store.select(getTeamMembers(this.teamId)).pipe();
        this.store.dispatch(new LoadRosterAction(this.leagueId, this.teamId));
        this.rosterMembers$ = this.store.select(getRosterMembers(this.leagueId, this.teamId)).pipe();
        this.hasError$ = this.hasError();
        this.isLoading$ = this.isLoading();
    }
    hasError() {
        return combineLatest([this.user$, this.restrictions$, this.league$, this.participants$, this.team$, this.teamMembers$]).pipe(map$1((data) => data.filter(entry => entry && entry.error).length !== 0), distinctUntilChanged());
    }
    isLoading() {
        return combineLatest([this.user$, this.restrictions$, this.league$, this.participants$, this.team$, this.teamMembers$]).pipe(map$1((data) => data.filter(entry => !entry || (entry.loading && !entry.entry)).length !== 0), distinctUntilChanged());
    }
    onSave(rosterMembers) {
        this.store.dispatch(new SetRosterAction(this.leagueId, this.teamId, rosterMembers));
        this.save.emit(rosterMembers);
    }
    onCancel() {
        this.cancel.emit();
    }
}
RosterPreselectDialogComponent.ɵfac = function RosterPreselectDialogComponent_Factory(t) { return new (t || RosterPreselectDialogComponent)(i0.ɵɵdirectiveInject(i1$1.Store)); };
RosterPreselectDialogComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RosterPreselectDialogComponent, selectors: [["roster-preselection-dialog"]], inputs: { leagueId: ["leagueid", "leagueId"], teamId: ["teamid", "teamId"], isRosterLeague: ["isrosterleague", "isRosterLeague"] }, outputs: { cancel: "cancel", save: "save" }, decls: 5, vars: 6, consts: [[4, "ngIf", "ngIfElse"], ["content", ""], [4, "ngIf"], [3, "team", "teamMembers", "rosterMembers", "restrictions", "league", "user", "participants", "isRosterLeague", "errors", "cancel", "save"]], template: function RosterPreselectDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RosterPreselectDialogComponent_div_0_Template, 5, 6, "div", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵpipe(2, "async");
        i0.ɵɵtemplate(3, RosterPreselectDialogComponent_ng_template_3_Template, 8, 24, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.isLoading$) || i0.ɵɵpipeBind1(2, 4, ctx.hasError$))("ngIfElse", _r1);
    } }, directives: [i2$1.NgIf, i2.LoadingSpinnerComponent, i2.InlineErrorComponent, ManageRosterComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RosterPreselectDialogComponent, [{
        type: Component,
        args: [{
                selector: "roster-preselection-dialog",
                templateUrl: "./roster-preselection.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }]; }, { cancel: [{
            type: Output
        }], save: [{
            type: Output
        }], leagueId: [{
            type: Input,
            args: ["leagueid"]
        }], teamId: [{
            type: Input,
            args: ["teamid"]
        }], isRosterLeague: [{
            type: Input,
            args: ["isrosterleague"]
        }] }); })();

function ConfirmRemoveMemberComponent_li_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const member_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("locationHref", ctx_r0.getPlayerLink(member_r2.user));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", member_r2.user.nickname, " ");
} }
function ConfirmRemoveMemberComponent_inline_error_16_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r4 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(error_r4);
} }
function ConfirmRemoveMemberComponent_inline_error_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error", 9);
    i0.ɵɵtemplate(1, ConfirmRemoveMemberComponent_inline_error_16_div_1_Template, 2, 1, "div", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.errors);
} }
const _c0$4 = function (a0) { return { days: a0 }; };
class ConfirmRemoveMemberComponent {
    constructor(links) {
        this.links = links;
        this.confirm = new EventEmitter();
        this.cancel = new EventEmitter();
    }
    onConfirm() {
        this.confirm.emit(this.selectedRoster);
    }
    onCancel() {
        this.cancel.emit();
    }
    getPlayerLink(player) {
        return this.links.player(+player.id, player.alias);
    }
}
ConfirmRemoveMemberComponent.ɵfac = function ConfirmRemoveMemberComponent_Factory(t) { return new (t || ConfirmRemoveMemberComponent)(i0.ɵɵdirectiveInject(i2.LinkService)); };
ConfirmRemoveMemberComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ConfirmRemoveMemberComponent, selectors: [["confirm-remove-member"]], inputs: { selectedRoster: "selectedRoster", removedMembers: "removedMembers", errors: "errors", loading: "loading", kickBanDays: "kickBanDays" }, outputs: { confirm: "confirm", cancel: "cancel" }, decls: 17, vars: 22, consts: [[1, "c-confirm-action", "c-confirm-action--inside"], [1, "c-confirm-action__description"], [1, "c-confirm-action__description", "c-confirm-action__description--lean"], [4, "ngFor", "ngForOf"], [1, "c-confirm-action__controls"], [1, "c-button--group", "c-button--big", "c-button--empty", 3, "disabled", "clicked"], [1, "c-button--group", "c-button--big", "c-button--destructive", 3, "loading", "clicked"], ["class", "c-confirm-action__error", 4, "ngIf"], [3, "locationHref"], [1, "c-confirm-action__error"]], template: function ConfirmRemoveMemberComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtext(5);
        i0.ɵɵpipe(6, "translate");
        i0.ɵɵelementStart(7, "ul");
        i0.ɵɵtemplate(8, ConfirmRemoveMemberComponent_li_8_Template, 3, 2, "li", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 4);
        i0.ɵɵelementStart(10, "play-button", 5);
        i0.ɵɵlistener("clicked", function ConfirmRemoveMemberComponent_Template_play_button_clicked_10_listener() { return ctx.onCancel(); });
        i0.ɵɵtext(11);
        i0.ɵɵpipe(12, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "play-button", 6);
        i0.ɵɵlistener("clicked", function ConfirmRemoveMemberComponent_Template_play_button_clicked_13_listener() { return ctx.onConfirm(); });
        i0.ɵɵtext(14);
        i0.ɵɵpipe(15, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, ConfirmRemoveMemberComponent_inline_error_16_Template, 2, 1, "inline-error", 7);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 8, "confirm-remove-member:warning", i0.ɵɵpureFunction1(18, _c0$4, ctx.kickBanDays)), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(6, 11, "confirm-remove-member:description", i0.ɵɵpureFunction1(20, _c0$4, ctx.kickBanDays)), " ");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.removedMembers);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx.loading);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 14, "commons:cancel"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("loading", ctx.loading);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 16, "commons:confirm"), " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.errors == null ? null : ctx.errors.length);
    } }, directives: [i2$1.NgForOf, i2.ButtonComponent, i2$1.NgIf, i2.LocationDirective, i2.InlineErrorComponent], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ConfirmRemoveMemberComponent, [{
        type: Component,
        args: [{
                selector: "confirm-remove-member",
                templateUrl: "./confirm-remove-member.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i2.LinkService }]; }, { confirm: [{
            type: Output
        }], cancel: [{
            type: Output
        }], selectedRoster: [{
            type: Input
        }], removedMembers: [{
            type: Input
        }], errors: [{
            type: Input
        }], loading: [{
            type: Input
        }], kickBanDays: [{
            type: Input
        }] }); })();

function RosterSelectDialogComponent_div_0_loading_spinner_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner");
} }
function RosterSelectDialogComponent_div_0_inline_error_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"), " ");
} }
function RosterSelectDialogComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, RosterSelectDialogComponent_div_0_loading_spinner_1_Template, 1, 0, "loading-spinner", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, RosterSelectDialogComponent_div_0_inline_error_3_Template, 3, 3, "inline-error", 2);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r0.isLoading$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx_r0.hasError$));
} }
function RosterSelectDialogComponent_ng_template_3_step_12_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "step", 4);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementStart(2, "confirm-remove-member", 7);
    i0.ɵɵlistener("cancel", function RosterSelectDialogComponent_ng_template_3_step_12_Template_confirm_remove_member_cancel_2_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.goToManage(); })("confirm", function RosterSelectDialogComponent_ng_template_3_step_12_Template_confirm_remove_member_confirm_2_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.onSave($event); });
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 6, "manage-roster:confirm-roster-kick"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("removedMembers", i0.ɵɵpipeBind1(3, 8, ctx_r5.aboutToRemovedMembers$))("selectedRoster", i0.ɵɵpipeBind1(4, 10, ctx_r5.selectedRoster$))("errors", i0.ɵɵpipeBind1(5, 12, ctx_r5.errors$))("loading", ctx_r5.loading)("kickBanDays", i0.ɵɵpipeBind1(6, 14, ctx_r5.league$).entry.kickBanDays);
} }
function RosterSelectDialogComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "stepper", 3);
    i0.ɵɵlistener("stepped", function RosterSelectDialogComponent_ng_template_3_Template_stepper_stepped_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.setStep($event); });
    i0.ɵɵelementStart(1, "step", 4);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementStart(3, "manage-roster", 5);
    i0.ɵɵlistener("cancel", function RosterSelectDialogComponent_ng_template_3_Template_manage_roster_cancel_3_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.onCancel(); })("save", function RosterSelectDialogComponent_ng_template_3_Template_manage_roster_save_3_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.goToConfirm($event); });
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵpipe(10, "async");
    i0.ɵɵpipe(11, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, RosterSelectDialogComponent_ng_template_3_step_12_Template, 7, 16, "step", 6);
    i0.ɵɵpipe(13, "async");
    i0.ɵɵpipe(14, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("step", ctx_r2.step);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(2, 12, "manage-roster:manage-roster"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("team", i0.ɵɵpipeBind1(4, 14, ctx_r2.team$).entry)("teamMembers", i0.ɵɵpipeBind1(5, 16, ctx_r2.teamMembers$).entry)("rosterMembers", i0.ɵɵpipeBind1(6, 18, ctx_r2.roster$).entry.members)("restrictions", i0.ɵɵpipeBind1(7, 20, ctx_r2.restrictions$).entry)("league", i0.ɵɵpipeBind1(8, 22, ctx_r2.league$).entry)("user", i0.ɵɵpipeBind1(9, 24, ctx_r2.user$).entry)("participants", i0.ɵɵpipeBind1(10, 26, ctx_r2.participants$).entry)("isRosterLeague", ctx_r2.isRosterLeague)("errors", i0.ɵɵpipeBind1(11, 28, ctx_r2.errors$));
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(13, 30, ctx_r2.aboutToRemovedMembers$).length && i0.ɵɵpipeBind1(14, 32, ctx_r2.league$).entry.kickBanDays);
} }
var SelectRosterStep;
(function (SelectRosterStep) {
    SelectRosterStep[SelectRosterStep["MANAGE"] = 0] = "MANAGE";
    SelectRosterStep[SelectRosterStep["CONFIRM"] = 1] = "CONFIRM";
})(SelectRosterStep || (SelectRosterStep = {}));
const getRemovedMembers = (teamMembers, currentRoster, newRoster) => {
    return filter$1(teamMembers, member => {
        const memberId = +member.user.id;
        return newRoster.indexOf(memberId) === -1 && currentRoster.indexOf(memberId) !== -1;
    });
};
const getAddedMembers = (teamMembers, currentRoster, newRoster) => {
    return filter$1(teamMembers, member => {
        const memberId = +member.user.id;
        return newRoster.indexOf(memberId) !== -1 && currentRoster.indexOf(memberId) === -1;
    });
};
class RosterSelectDialogComponent {
    constructor(store, translate, rosters) {
        this.store = store;
        this.translate = translate;
        this.rosters = rosters;
        this.cancel = new EventEmitter();
        this.save = new EventEmitter();
        this.errors$ = new BehaviorSubject([]);
        this.step = SelectRosterStep.MANAGE;
        this.selectedRoster$ = new BehaviorSubject([]);
    }
    ngOnInit() {
        this.user$ = this.store.select(getUser);
        this.store.dispatch(new LoadLeagueRestrictionsOnceAction(this.leagueId, this.teamId));
        this.restrictions$ = this.store.select(getLeagueRestrictions(this.leagueId, this.teamId));
        this.store.dispatch(new LoadParticipantsOnceAction(this.leagueId));
        this.participants$ = this.store.select(getLeagueParticipants(this.leagueId));
        this.store.dispatch(new LoadRosterOnceAction(this.leagueId, this.teamId));
        this.roster$ = this.store.select(getRoster(this.leagueId, this.teamId));
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.store.dispatch(new LoadTeamOnceAction(this.teamId));
        this.team$ = this.store.select(getTeam(this.teamId));
        this.store.dispatch(new LoadMembersOnceAction(this.teamId));
        this.teamMembers$ = this.store.select(getTeamMembers(this.teamId));
        this.aboutToRemovedMembers$ = combineLatest(this.roster$, this.teamMembers$, this.selectedRoster$).pipe(distinct(([roster, teamMembers, rosterMembers]) => getRemovedMembers(teamMembers.entry, roster.entry.members, rosterMembers)));
        this.roster$
            .pipe(filter(entryAvailable), first())
            .subscribe(roster => this.selectedRoster$.next(roster.entry.members));
        this.hasError$ = this.hasError();
        this.isLoading$ = this.isLoading();
    }
    hasError() {
        return combineLatest([
            this.user$,
            this.roster$,
            this.restrictions$,
            this.league$,
            this.participants$,
            this.team$,
            this.teamMembers$,
        ]).pipe(map$1((data) => data.filter(entry => entry && entry.error).length !== 0), distinctUntilChanged());
    }
    isLoading() {
        return combineLatest([
            this.user$,
            this.roster$,
            this.restrictions$,
            this.league$,
            this.participants$,
            this.team$,
            this.teamMembers$,
        ]).pipe(map$1((data) => data.filter(entry => !entry || (entry.loading && !entry.entry)).length !== 0), distinctUntilChanged());
    }
    catchIndividualSaveException(member, error) {
        const errorText = error ? error.message : "";
        // Ignore error if action has already been done
        if (["player_not_in_roster", "already_in_this_roster"].indexOf(errorText) !== -1) {
            return;
        }
        this.errors$.next([
            ...this.errors$.getValue(),
            this.translate.translate("manage-roster:member-save-error", {
                member: member.user.nickname,
            }),
        ]);
        return Promise.reject(error);
    }
    setStep(step) {
        this.step = step;
    }
    goToManage() {
        this.step = SelectRosterStep.MANAGE;
    }
    goToConfirm(rosterMembers) {
        this.selectedRoster$.next(rosterMembers);
        combineLatest(this.aboutToRemovedMembers$, this.league$.pipe(filter(entryAvailable)))
            .pipe(first())
            .subscribe(([removedMembers, league]) => {
            if (!removedMembers.length || !league.entry.kickBanDays) {
                this.onSave(this.selectedRoster$.getValue());
            }
            else {
                this.step = SelectRosterStep.CONFIRM;
            }
        });
    }
    onSave(rosterMembers) {
        this.loading = true;
        this.errors$.next([]);
        combineLatest(this.league$, this.roster$, this.teamMembers$)
            .pipe(first())
            .toPromise()
            .then(data => {
            const league = data[0];
            const roster = data[1];
            const teamMembers = data[2];
            if (!league.entry) {
                return;
            }
            const removedMembers = getRemovedMembers(teamMembers.entry, roster.entry.members, rosterMembers);
            const addedMembers = getAddedMembers(teamMembers.entry, roster.entry.members, rosterMembers);
            return Promise.all(removedMembers.map(member => {
                const memberId = +member.user.id;
                return this.rosters
                    .removePlayer(this.leagueId, this.teamId, memberId)
                    .toPromise()
                    .catch(this.catchIndividualSaveException.bind(this, member))
                    .then(() => this.store.dispatch(new RemoveMemberFromRosterAction(this.leagueId, this.teamId, memberId)));
            }))
                .then(() => {
                return Promise.all(addedMembers.map(member => {
                    const memberId = +member.user.id;
                    return this.rosters
                        .addPlayer(this.leagueId, this.teamId, memberId)
                        .toPromise()
                        .catch(this.catchIndividualSaveException.bind(this, member))
                        .then(() => this.store.dispatch(new AddMemberToRosterAction(this.leagueId, this.teamId, memberId)));
                }));
            })
                .then(() => this.save.emit(rosterMembers))
                .catch(() => {
                this.store.dispatch(new LoadRosterAction$1(this.leagueId, this.teamId));
                this.store.dispatch(new LoadLeagueRestrictionsAction(this.leagueId, this.teamId));
            });
        })
            .then(() => (this.loading = false));
    }
    onCancel() {
        this.cancel.emit();
    }
}
RosterSelectDialogComponent.ɵfac = function RosterSelectDialogComponent_Factory(t) { return new (t || RosterSelectDialogComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject(i3.RosterResource)); };
RosterSelectDialogComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RosterSelectDialogComponent, selectors: [["roster-selection-dialog"]], inputs: { leagueId: ["leagueid", "leagueId"], teamId: ["teamid", "teamId"], isRosterLeague: ["isrosterleague", "isRosterLeague"] }, outputs: { cancel: "cancel", save: "save" }, decls: 5, vars: 6, consts: [[4, "ngIf", "ngIfElse"], ["content", ""], [4, "ngIf"], [1, "c-ranking-ffa-picker", 3, "step", "stepped"], [3, "title"], [3, "team", "teamMembers", "rosterMembers", "restrictions", "league", "user", "participants", "isRosterLeague", "errors", "cancel", "save"], [3, "title", 4, "ngIf"], [3, "removedMembers", "selectedRoster", "errors", "loading", "kickBanDays", "cancel", "confirm"]], template: function RosterSelectDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RosterSelectDialogComponent_div_0_Template, 5, 6, "div", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵpipe(2, "async");
        i0.ɵɵtemplate(3, RosterSelectDialogComponent_ng_template_3_Template, 15, 34, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.isLoading$) || i0.ɵɵpipeBind1(2, 4, ctx.hasError$))("ngIfElse", _r1);
    } }, directives: [i2$1.NgIf, i2.LoadingSpinnerComponent, i2.InlineErrorComponent, i2.StepperComponent, i2.StepComponent, ManageRosterComponent, ConfirmRemoveMemberComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RosterSelectDialogComponent, [{
        type: Component,
        args: [{
                selector: "roster-selection-dialog",
                templateUrl: "./roster-selection.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i1.TranslateService }, { type: i3.RosterResource }]; }, { cancel: [{
            type: Output
        }], save: [{
            type: Output
        }], leagueId: [{
            type: Input,
            args: ["leagueid"]
        }], teamId: [{
            type: Input,
            args: ["teamid"]
        }], isRosterLeague: [{
            type: Input,
            args: ["isrosterleague"]
        }] }); })();

function RosterStatusComponent_inline_error_5_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r3 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(error_r3);
} }
function RosterStatusComponent_inline_error_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtemplate(1, RosterStatusComponent_inline_error_5_div_1_Template, 2, 1, "div", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.errors);
} }
function RosterStatusComponent_team_invite_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "team-invite", 10);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("team", ctx_r1.team);
} }
class RosterStatusComponent extends ManageRosterComponent {
}
RosterStatusComponent.ɵfac = function RosterStatusComponent_Factory(t) { return ɵRosterStatusComponent_BaseFactory(t || RosterStatusComponent); };
RosterStatusComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RosterStatusComponent, selectors: [["roster-status"]], features: [i0.ɵɵInheritDefinitionFeature], decls: 11, vars: 17, consts: [[1, "c-team-status"], [1, "c-team-status__team"], [3, "restrictions", "team", "league", "isRosterLeague"], [1, "c-team-status__member"], [3, "user", "participants", "league", "teamMembers", "restrictions", "selectedMembers", "isManager", "isRosterLeague"], [4, "ngIf"], [1, "c-team-status__invite"], [3, "team", 4, "ngIf"], [1, "c-button", "c-button--primary", 3, "click"], [4, "ngFor", "ngForOf"], [3, "team"]], template: function RosterStatusComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementStart(1, "section", 1);
        i0.ɵɵelement(2, "roster-eligibility-status", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "section", 3);
        i0.ɵɵelement(4, "members-eligibility-status", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, RosterStatusComponent_inline_error_5_Template, 2, 1, "inline-error", 5);
        i0.ɵɵelementStart(6, "section", 6);
        i0.ɵɵtemplate(7, RosterStatusComponent_team_invite_7_Template, 1, 1, "team-invite", 7);
        i0.ɵɵelementStart(8, "button", 8);
        i0.ɵɵlistener("click", function RosterStatusComponent_Template_button_click_8_listener() { return ctx.cancel.emit(); });
        i0.ɵɵtext(9);
        i0.ɵɵpipe(10, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("restrictions", ctx.teamRestrictions)("team", ctx.team)("league", ctx.league)("isRosterLeague", ctx.isRosterLeague);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("user", ctx.user)("participants", ctx.participants)("league", ctx.league)("teamMembers", ctx.members)("restrictions", ctx.restrictions)("selectedMembers", ctx.selectedMembers)("isManager", false)("isRosterLeague", ctx.isRosterLeague);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.errors.length);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isUserManager);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 15, "common:close"), " ");
    } }, directives: [RosterEligibilityStatusComponent, MemberEligibilityStatusComponent, i2$1.NgIf, i2.InlineErrorComponent, i2$1.NgForOf, TeamInviteComponent], pipes: [i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
const ɵRosterStatusComponent_BaseFactory = /*@__PURE__*/ i0.ɵɵgetInheritedFactory(RosterStatusComponent);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RosterStatusComponent, [{
        type: Component,
        args: [{
                selector: "roster-status",
                templateUrl: "./roster-status.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], null, null); })();

function RosterStatusDialogComponent_ng_container_0_loading_spinner_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner");
} }
function RosterStatusDialogComponent_ng_container_0_inline_error_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"), " ");
} }
function RosterStatusDialogComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, RosterStatusDialogComponent_ng_container_0_loading_spinner_1_Template, 1, 0, "loading-spinner", 2);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, RosterStatusDialogComponent_ng_container_0_inline_error_3_Template, 3, 3, "inline-error", 2);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r0.isLoading$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx_r0.hasError$));
} }
function RosterStatusDialogComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "roster-status", 3);
    i0.ɵɵlistener("cancel", function RosterStatusDialogComponent_ng_template_3_Template_roster_status_cancel_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.onClose(); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "async");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("team", i0.ɵɵpipeBind1(1, 9, ctx_r2.team$).entry)("teamMembers", i0.ɵɵpipeBind1(2, 11, ctx_r2.teamMembers$).entry)("rosterMembers", i0.ɵɵpipeBind1(3, 13, ctx_r2.roster$).entry.members)("restrictions", i0.ɵɵpipeBind1(4, 15, ctx_r2.restrictions$).entry)("league", i0.ɵɵpipeBind1(5, 17, ctx_r2.league$).entry)("user", i0.ɵɵpipeBind1(6, 19, ctx_r2.user$).entry)("participants", i0.ɵɵpipeBind1(7, 21, ctx_r2.participants$).entry)("errors", i0.ɵɵpipeBind1(8, 23, ctx_r2.errors$))("isRosterLeague", ctx_r2.isRosterLeague);
} }
class RosterStatusDialogComponent {
    constructor(store) {
        this.store = store;
        this.close = new EventEmitter();
        this.errors$ = new BehaviorSubject([]);
    }
    ngOnInit() {
        this.user$ = this.store.select(getUser);
        this.store.dispatch(new LoadLeagueRestrictionsOnceAction(this.leagueId, this.teamId));
        this.restrictions$ = this.store.select(getLeagueRestrictions(this.leagueId, this.teamId));
        this.store.dispatch(new LoadParticipantsOnceAction(this.leagueId));
        this.participants$ = this.store.select(getLeagueParticipants(this.leagueId));
        this.store.dispatch(new LoadRosterOnceAction(this.leagueId, this.teamId));
        this.roster$ = this.store.select(getRoster(this.leagueId, this.teamId));
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId));
        this.store.dispatch(new LoadTeamOnceAction(this.teamId));
        this.team$ = this.store.select(getTeam(this.teamId));
        this.store.dispatch(new LoadMembersOnceAction(this.teamId));
        this.teamMembers$ = this.store.select(getTeamMembers(this.teamId));
        this.hasError$ = this.hasError();
        this.isLoading$ = this.isLoading();
    }
    hasError() {
        return combineLatest([
            this.user$,
            this.roster$,
            this.restrictions$,
            this.league$,
            this.participants$,
            this.team$,
            this.teamMembers$,
        ]).pipe(distinct((data) => data.filter(entry => entry && entry.error).length !== 0));
    }
    isLoading() {
        return combineLatest([
            this.user$,
            this.roster$,
            this.restrictions$,
            this.league$,
            this.participants$,
            this.team$,
            this.teamMembers$,
        ]).pipe(distinct((data) => data.filter(entry => !entry || (entry.loading && !entry.entry)).length !== 0));
    }
    onClose() {
        this.close.emit();
    }
}
RosterStatusDialogComponent.ɵfac = function RosterStatusDialogComponent_Factory(t) { return new (t || RosterStatusDialogComponent)(i0.ɵɵdirectiveInject(i1$1.Store)); };
RosterStatusDialogComponent.ɵcmp = i0.ɵɵdefineComponent({ type: RosterStatusDialogComponent, selectors: [["roster-status-dialog"]], inputs: { leagueId: "leagueId", teamId: "teamId", isRosterLeague: "isRosterLeague" }, outputs: { close: "close" }, decls: 5, vars: 6, consts: [[4, "ngIf", "ngIfElse"], ["content", ""], [4, "ngIf"], [3, "team", "teamMembers", "rosterMembers", "restrictions", "league", "user", "participants", "errors", "isRosterLeague", "cancel"]], template: function RosterStatusDialogComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, RosterStatusDialogComponent_ng_container_0_Template, 5, 6, "ng-container", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵpipe(2, "async");
        i0.ɵɵtemplate(3, RosterStatusDialogComponent_ng_template_3_Template, 9, 25, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(4);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 2, ctx.isLoading$) || i0.ɵɵpipeBind1(2, 4, ctx.hasError$))("ngIfElse", _r1);
    } }, directives: [i2$1.NgIf, i2.LoadingSpinnerComponent, i2.InlineErrorComponent, RosterStatusComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RosterStatusDialogComponent, [{
        type: Component,
        args: [{
                selector: "roster-status-dialog",
                templateUrl: "./roster-status-dialog.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }]; }, { close: [{
            type: Output
        }], leagueId: [{
            type: Input
        }], teamId: [{
            type: Input
        }], isRosterLeague: [{
            type: Input
        }] }); })();

const confirmRemoveMemberTexts = {
    "confirm-remove-member:warning": "Changes you have made will lead to temporary bans from the tournament.",
    "confirm-remove-member:description": "You are about to remove the following players from the roster " +
        "which will cause them to be banned from the tournament for {days} days:",
};

class ManageRosterModule {
}
ManageRosterModule.ɵfac = function ManageRosterModule_Factory(t) { return new (t || ManageRosterModule)(); };
ManageRosterModule.ɵmod = i0.ɵɵdefineNgModule({ type: ManageRosterModule });
ManageRosterModule.ɵinj = i0.ɵɵdefineInjector({ providers: [MemberEligibilityStatusConfig, RosterEligibilityStatusConfig, RosterPreSelectionCache, MemberEligibilityFactory], imports: [[
            CommonModule,
            FormsModule,
            TranslationModule,
            CommonsModule,
            CommonsFormModule,
            CommonsErrorModule,
            CommonsLoadingModule,
            CommonsLocationModule,
            CacheModule,
            ComponentsModule,
            CommonsComponentModule,
            EffectsModule.forFeature([RosterPreSelectionEffects]),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ManageRosterModule, { declarations: [ManageRosterComponent,
        RosterEligibilityStatusComponent,
        MemberEligibilityStatusComponent,
        SaveRosterComponent,
        RosterPreselectDialogComponent,
        RosterSelectDialogComponent,
        MemberEligibilityComponent,
        SelectAllEligibleMembersComponent,
        MemberEligibilityHeaderComponent,
        RosterStatusDialogComponent,
        RosterStatusComponent,
        ConfirmRemoveMemberComponent], imports: [CommonModule,
        FormsModule,
        TranslationModule,
        CommonsModule,
        CommonsFormModule,
        CommonsErrorModule,
        CommonsLoadingModule,
        CommonsLocationModule,
        CacheModule,
        ComponentsModule,
        CommonsComponentModule, i1$3.EffectsFeatureModule], exports: [RosterPreselectDialogComponent, RosterSelectDialogComponent, RosterStatusDialogComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ManageRosterModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslationModule,
                    CommonsModule,
                    CommonsFormModule,
                    CommonsErrorModule,
                    CommonsLoadingModule,
                    CommonsLocationModule,
                    CacheModule,
                    ComponentsModule,
                    CommonsComponentModule,
                    EffectsModule.forFeature([RosterPreSelectionEffects]),
                ],
                providers: [MemberEligibilityStatusConfig, RosterEligibilityStatusConfig, RosterPreSelectionCache, MemberEligibilityFactory],
                declarations: [
                    ManageRosterComponent,
                    RosterEligibilityStatusComponent,
                    MemberEligibilityStatusComponent,
                    SaveRosterComponent,
                    RosterPreselectDialogComponent,
                    RosterSelectDialogComponent,
                    MemberEligibilityComponent,
                    SelectAllEligibleMembersComponent,
                    MemberEligibilityHeaderComponent,
                    RosterStatusDialogComponent,
                    RosterStatusComponent,
                    ConfirmRemoveMemberComponent,
                ],
                exports: [RosterPreselectDialogComponent, RosterSelectDialogComponent, RosterStatusDialogComponent],
            }]
    }], null, null); })();

const chooseTeamTexts = {
    // Select Team
    "choose-team:select-text": "Please select the team you would like to play with:",
    "choose-team:choose-a-team": "Choose a team:",
    "choose-team:choose-team": "Choose Team",
    // Create Team
    "choose-team:create-text": "If you don't already have a team you can create one:",
    "choose-team:enter-team-name": "Team name:",
    "choose-team:create-team": "Create Team",
};

function ChooseTeamComponent_div_1_loading_spinner_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner");
} }
function ChooseTeamComponent_div_1_inline_error_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"), " ");
} }
function ChooseTeamComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ChooseTeamComponent_div_1_loading_spinner_1_Template, 1, 0, "loading-spinner", 3);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵtemplate(3, ChooseTeamComponent_div_1_inline_error_3_Template, 3, 3, "inline-error", 3);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx_r0.userTeams$).loading);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx_r0.userTeams$).error);
} }
function ChooseTeamComponent_ng_template_4_option_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const teammembership_r7 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", teammembership_r7);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", teammembership_r7.team.name + " " + (teammembership_r7.team.suffix || "") + " (#" + teammembership_r7.team.id + ")", " ");
} }
function ChooseTeamComponent_ng_template_4_span_25_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const error_r8 = ctx.ngIf;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(error_r8);
} }
function ChooseTeamComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelementStart(1, "p", 5);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "label", 6);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "select", 7);
    i0.ɵɵlistener("ngModelChange", function ChooseTeamComponent_ng_template_4_Template_select_ngModelChange_7_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return $event.team ? ctx_r9.changeTeam($event.team.id) : null; });
    i0.ɵɵpipe(8, "async");
    i0.ɵɵtemplate(9, ChooseTeamComponent_ng_template_4_option_9_Template, 2, 2, "option", 8);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "play-button", 9);
    i0.ɵɵlistener("clicked", function ChooseTeamComponent_ng_template_4_Template_play_button_clicked_11_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.chooseTeam(); });
    i0.ɵɵpipe(12, "async");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 10);
    i0.ɵɵelementStart(16, "p");
    i0.ɵɵtext(17);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "form");
    i0.ɵɵelementStart(20, "label", 11);
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "input", 12);
    i0.ɵɵlistener("ngModelChange", function ChooseTeamComponent_ng_template_4_Template_input_ngModelChange_23_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r12 = i0.ɵɵnextContext(); return ctx_r12.teamName = $event; });
    i0.ɵɵpipe(24, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(25, ChooseTeamComponent_ng_template_4_span_25_Template, 2, 1, "span", 13);
    i0.ɵɵpipe(26, "async");
    i0.ɵɵelementStart(27, "play-button", 14);
    i0.ɵɵlistener("clicked", function ChooseTeamComponent_ng_template_4_Template_play_button_clicked_27_listener() { i0.ɵɵrestoreView(_r10); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.createTeam(ctx_r13.teamName); });
    i0.ɵɵpipe(28, "async");
    i0.ɵɵtext(29);
    i0.ɵɵpipe(30, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 13, "choose-team:select-text"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 15, "choose-team:choose-a-team"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", i0.ɵɵpipeBind1(8, 17, ctx_r2.selectedTeam$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(10, 19, ctx_r2.userTeams$).entry);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !i0.ɵɵpipeBind1(12, 21, ctx_r2.selectedTeam$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 23, "choose-team:choose-team"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(18, 25, "choose-team:create-text"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(22, 27, "choose-team:enter-team-name"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(24, 29, ctx_r2.randomTeamName$))("ngModel", ctx_r2.teamName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(26, 31, ctx_r2.createError$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("loading", i0.ɵɵpipeBind1(28, 33, ctx_r2.createLoading$));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(30, 35, "choose-team:create-team"));
} }
class ChooseTeamComponent {
    constructor(teamResource, translate, store) {
        this.teamResource = teamResource;
        this.translate = translate;
        this.store = store;
        this.cancel = new EventEmitter();
        this.save = new EventEmitter();
        this.changeTeam$ = new BehaviorSubject(0);
        this.createError$ = new BehaviorSubject(null);
        this.createLoading$ = new BehaviorSubject(false);
        this.teamNames = [
            "Raging Racoons",
            "Way out of our League",
            "Shaolin Monkeys",
            "Top Fraggers",
            "Insert Name Here",
            "Dude where's my AWP?",
            "Chicken Dinner",
        ];
        this.userTeams$ = this.store.select(getUserTeams).pipe(map$1(teams => {
            if (!teams.entry) {
                return teams;
            }
            let entry = filter$1(teams.entry, membership => ["leader", "co_leader", "matchorga"].indexOf(membership.membership.permission) !== -1);
            entry = sortBy(entry, membership => membership.team.name);
            return Object.assign(Object.assign({}, teams), { entry: entry });
        }));
        this.randomTeamName$ = interval(5000)
            .pipe(startWith(0))
            .pipe(map$1(x => this.teamNames[Math.floor(Math.random() * this.teamNames.length)]), distinctUntilChanged());
    }
    ngOnInit() {
        this.store.dispatch(new LoadSelectedContestantAction(this.leagueId));
        this.selectedTeam$ = merge(this.changeTeam$, this.store.pipe(getSelectedContestant(this.leagueId, "team"), filter(exists), tap(x => this.changeTeam$.next(x)), distinctUntilChanged())).pipe(switchMap(teamId => {
            return this.userTeams$.pipe(filter(userTeam => Boolean(userTeam.entry)), map$1(userTeam => find(userTeam.entry, team => +team.team.id === teamId)));
        }));
    }
    changeTeam(teamId) {
        this.changeTeam$.next(+teamId);
    }
    createTeam(teamName) {
        this.createLoading$.next(true);
        this.createError$.next(null);
        this.teamResource
            .createTeam(teamName)
            .toPromise()
            .then(teammembership => {
            combineLatest(this.store.select(getUserTeams), this.store.select(getUser))
                .pipe(first())
                .subscribe(([userTeams, user]) => {
                const userId = +user.entry.id;
                this.store.dispatch(new LoadUserTeamsCompleteAction(userId, [...userTeams.entry, teammembership]));
                this.changeTeam(teammembership.team.id);
                this.chooseTeam();
            });
        })
            .catch(error => {
            if (!error.data || !error.data.error) {
                this.createError$.next(this.getErrorForKey("unknown"));
                return;
            }
            this.createError$.next(this.getErrorForKey(error.data.error));
            return null;
        })
            .then(x => this.createLoading$.next(false));
    }
    getErrorForKey(errorKey) {
        switch (errorKey) {
            case "name_blacklisted":
            case "no_teamname":
            case "invalid_teamname":
                return this.translate.translate("commons:error-invalid-name", {});
            default:
                return this.translate.translate("commons:error-unknown", {});
        }
    }
    chooseTeam() {
        this.changeTeam$.pipe(first()).subscribe(teamId => this.save.emit(teamId));
    }
}
ChooseTeamComponent.ɵfac = function ChooseTeamComponent_Factory(t) { return new (t || ChooseTeamComponent)(i0.ɵɵdirectiveInject(i3.TeamResource), i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject(i1$1.Store)); };
ChooseTeamComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ChooseTeamComponent, selectors: [["choose-team"]], inputs: { leagueId: "leagueId" }, outputs: { cancel: "cancel", save: "save" }, decls: 6, vars: 6, consts: [[1, "c-choose-team"], [4, "ngIf", "ngIfElse"], ["content", ""], [4, "ngIf"], [1, "play-dialog__left", "c-choose-team__action"], [1, "c-choose-team__choose-team__info"], ["for", "choose-team", 1, "c-choose-team__label"], ["id", "choose-team", 1, "c-choose-team__input", "play-dialog__select-input", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "c-button--primary", "c-button--big", "c-button--block", 3, "disabled", "clicked"], [1, "play-dialog__right", "c-choose-team__action"], ["for", "c-choose-team__team-name-input", 1, "c-choose-team__label"], ["id", "c-choose-team__team-name-input", "type", "text", "name", "team-name", 1, "c-choose-team__input", "play-dialog__text-input", 3, "placeholder", "ngModel", "ngModelChange"], ["class", "play-dialog__error c-choose-team__error", 4, "ngIf"], [1, "c-button--primary", "c-button--big", "c-button--block", 3, "loading", "clicked"], [3, "ngValue"], [1, "play-dialog__error", "c-choose-team__error"]], template: function ChooseTeamComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, ChooseTeamComponent_div_1_Template, 5, 6, "div", 1);
        i0.ɵɵpipe(2, "async");
        i0.ɵɵpipe(3, "async");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, ChooseTeamComponent_ng_template_4_Template, 31, 37, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(5);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 2, ctx.userTeams$).loading || i0.ɵɵpipeBind1(3, 4, ctx.userTeams$).error)("ngIfElse", _r1);
    } }, directives: [i2$1.NgIf, i2.LoadingSpinnerComponent, i2.InlineErrorComponent, i6.SelectControlValueAccessor, i6.NgControlStatus, i6.NgModel, i2$1.NgForOf, i2.ButtonComponent, i6.ɵangular_packages_forms_forms_ba, i6.NgControlStatusGroup, i6.NgForm, i6.DefaultValueAccessor, i6.NgSelectOption, i6.ɵangular_packages_forms_forms_z], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChooseTeamComponent, [{
        type: Component,
        args: [{
                selector: "choose-team",
                templateUrl: "./choose-team.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i3.TeamResource }, { type: i1.TranslateService }, { type: i1$1.Store }]; }, { leagueId: [{
            type: Input,
            args: ["leagueId"]
        }], cancel: [{
            type: Output
        }], save: [{
            type: Output
        }] }); })();

class ChooseTeamModule {
}
ChooseTeamModule.ɵfac = function ChooseTeamModule_Factory(t) { return new (t || ChooseTeamModule)(); };
ChooseTeamModule.ɵmod = i0.ɵɵdefineNgModule({ type: ChooseTeamModule });
ChooseTeamModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            TranslationModule,
            CommonsModule,
            CommonsErrorModule,
            CommonsLoadingModule,
            CommonsComponentModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ChooseTeamModule, { declarations: [ChooseTeamComponent], imports: [CommonModule,
        FormsModule,
        TranslationModule,
        CommonsModule,
        CommonsErrorModule,
        CommonsLoadingModule,
        CommonsComponentModule], exports: [ChooseTeamComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChooseTeamModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    TranslationModule,
                    CommonsModule,
                    CommonsErrorModule,
                    CommonsLoadingModule,
                    CommonsComponentModule,
                ],
                exports: [ChooseTeamComponent],
                declarations: [ChooseTeamComponent],
            }]
    }], null, null); })();

const _c0$3 = function (a0) { return { inProgress: a0 }; };
const _c1$1 = function (a0, a1) { return { inProgress: a0, banDays: a1 }; };
function LeaveRosterComponent_confirm_action_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "confirm-action", 2);
    i0.ɵɵlistener("confirm", function LeaveRosterComponent_confirm_action_0_Template_confirm_action_confirm_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.leaveRoster(); })("cancel", function LeaveRosterComponent_confirm_action_0_Template_confirm_action_cancel_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.cancel.emit($event); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("destructive", true)("error", i0.ɵɵpipeBind1(1, 6, ctx_r0.leaveError$))("loading", i0.ɵɵpipeBind1(2, 8, ctx_r0.leaveLoading$))("checkbox", i0.ɵɵpipeBind2(3, 10, "leave-roster:confirm", i0.ɵɵpureFunction1(24, _c0$3, i0.ɵɵpipeBind1(4, 13, ctx_r0.leagueInProgress$) ? 1 : 0)))("button", i0.ɵɵpipeBind1(5, 15, "leave-roster:leave"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(7, 17, "leave-roster:warning", i0.ɵɵpureFunction2(26, _c1$1, i0.ɵɵpipeBind1(8, 20, ctx_r0.leagueInProgress$) ? 1 : 0, i0.ɵɵpipeBind1(9, 22, ctx_r0.leagueKickBanDays$))), "\n");
} }
function LeaveRosterComponent_loading_spinner_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner");
} }
function LeaveRosterComponent_inline_error_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"), "\n");
} }
class LeaveRosterComponent {
    constructor(store, translate, rosterResource) {
        this.store = store;
        this.translate = translate;
        this.rosterResource = rosterResource;
        this.cancel = new EventEmitter();
        this.leaveLoadingSubject$ = new Subject();
        this.leaveLoadingSubject$.next(false);
        this.leaveLoading$ = this.leaveLoadingSubject$.asObservable();
        this.leaveErrorSubject$ = new Subject();
        this.leaveErrorSubject$.next("");
        this.leaveError$ = this.leaveErrorSubject$.asObservable();
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        const league$ = this.store.select(getLeague(this.leagueId));
        const user$ = this.store.select(getUser);
        this.leagueInProgress$ = league$.pipe(filter(entryAvailable), distinct(league => isInProgress(league.entry)));
        this.leagueKickBanDays$ = league$.pipe(filter(entryAvailable), distinct(league => league.entry.kickBanDays));
        this.loading$ = combineLatest(league$, user$).pipe(map$1(([league, user]) => league.loading || user.loading), distinctUntilChanged());
        this.hasDataFetchError$ = combineLatest(league$, user$).pipe(map$1(([league, user]) => Boolean(league.error) || Boolean(user.error)), distinctUntilChanged());
        this.playerId$ = user$.pipe(filter(entryAvailable), map$1(user => +user.entry.id), distinctUntilChanged());
    }
    leaveRoster() {
        this.leaveErrorSubject$.next("");
        this.leaveLoadingSubject$.next(true);
        this.playerId$.pipe(first()).subscribe(playerId => {
            this.rosterResource
                .removePlayer(this.leagueId, this.teamId, playerId)
                .toPromise()
                .catch((error) => {
                this.leaveLoadingSubject$.next(false);
                this.leaveErrorSubject$.next(this.translate.translate("commons:error-unknown", {}));
                return Promise.reject(error);
            })
                .then(() => {
                this.leaveLoadingSubject$.next(false);
                this.store.dispatch(new LeaveRosterAction(this.leagueId, this.teamId));
                this.store.dispatch(new SelectRosterAction(this.leagueId, this.teamId));
                this.cancel.emit(true);
            });
        });
    }
}
LeaveRosterComponent.ɵfac = function LeaveRosterComponent_Factory(t) { return new (t || LeaveRosterComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject(i3.RosterResource)); };
LeaveRosterComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LeaveRosterComponent, selectors: [["leave-roster"]], inputs: { leagueId: "leagueId", teamId: "teamId" }, outputs: { cancel: "cancel" }, decls: 6, vars: 9, consts: [[3, "destructive", "error", "loading", "checkbox", "button", "confirm", "cancel", 4, "ngIf"], [4, "ngIf"], [3, "destructive", "error", "loading", "checkbox", "button", "confirm", "cancel"]], template: function LeaveRosterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LeaveRosterComponent_confirm_action_0_Template, 10, 29, "confirm-action", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, LeaveRosterComponent_loading_spinner_2_Template, 1, 0, "loading-spinner", 1);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵtemplate(4, LeaveRosterComponent_inline_error_4_Template, 3, 3, "inline-error", 1);
        i0.ɵɵpipe(5, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(1, 3, ctx.loading$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 5, ctx.loading$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 7, ctx.hasDataFetchError$));
    } }, directives: [i2$1.NgIf, ConfirmActionComponent, i2.LoadingSpinnerComponent, i2.InlineErrorComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeaveRosterComponent, [{
        type: Component,
        args: [{
                selector: "leave-roster",
                templateUrl: "./leave-roster.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i1.TranslateService }, { type: i3.RosterResource }]; }, { leagueId: [{
            type: Input
        }], teamId: [{
            type: Input
        }], cancel: [{
            type: Output
        }] }); })();

class LeaveRosterModule {
}
LeaveRosterModule.ɵfac = function LeaveRosterModule_Factory(t) { return new (t || LeaveRosterModule)(); };
LeaveRosterModule.ɵmod = i0.ɵɵdefineNgModule({ type: LeaveRosterModule });
LeaveRosterModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[TranslationModule, FormsModule, CommonModule, CommonsLoadingModule, CommonsErrorModule, CommonsFormModule, ComponentsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LeaveRosterModule, { declarations: [LeaveRosterComponent], imports: [TranslationModule, FormsModule, CommonModule, CommonsLoadingModule, CommonsErrorModule, CommonsFormModule, ComponentsModule], exports: [LeaveRosterComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeaveRosterModule, [{
        type: NgModule,
        args: [{
                imports: [TranslationModule, FormsModule, CommonModule, CommonsLoadingModule, CommonsErrorModule, CommonsFormModule, ComponentsModule],
                exports: [LeaveRosterComponent],
                declarations: [LeaveRosterComponent],
            }]
    }], null, null); })();

const leaveRosterTexts = {
    "leave-roster:warning": `Are you sure you wish to leave this roster? {
        inProgress, select, 1{You will forfeit any open and future matches} other{}
    }`,
    "leave-roster:confirm": `I wish to leave {
        inProgress, select, 1{and accept that current and future matches may be forfeit} other{}
    }`,
    "leave-roster:leave": "Leave",
};

const _c0$2 = function (a0) { return { inProgress: a0 }; };
const _c1 = function (a0, a1) { return { inProgress: a0, banDays: a1 }; };
function LeaveLeagueComponent_confirm_action_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "confirm-action", 2);
    i0.ɵɵlistener("confirm", function LeaveLeagueComponent_confirm_action_0_Template_confirm_action_confirm_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.leaveLeague(); })("cancel", function LeaveLeagueComponent_confirm_action_0_Template_confirm_action_cancel_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.cancel.emit($event); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "async");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("destructive", true)("error", i0.ɵɵpipeBind1(1, 6, ctx_r0.leaveError$))("loading", i0.ɵɵpipeBind1(2, 8, ctx_r0.leaveLoading$))("checkbox", i0.ɵɵpipeBind2(3, 10, "leave-league:confirm", i0.ɵɵpureFunction1(24, _c0$2, i0.ɵɵpipeBind1(4, 13, ctx_r0.leagueInProgress$) ? 1 : 0)))("button", i0.ɵɵpipeBind1(5, 15, "leave-league:leave"));
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(7, 17, "leave-league:warning", i0.ɵɵpureFunction2(26, _c1, i0.ɵɵpipeBind1(8, 20, ctx_r0.leagueInProgress$) ? 1 : 0, i0.ɵɵpipeBind1(9, 22, ctx_r0.leagueKickBanDays$))), "\n");
} }
function LeaveLeagueComponent_loading_spinner_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner");
} }
function LeaveLeagueComponent_inline_error_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"), "\n");
} }
class LeaveLeagueComponent {
    constructor(store, translate, contestantResource) {
        this.store = store;
        this.translate = translate;
        this.contestantResource = contestantResource;
        this.cancel = new EventEmitter();
        this.leaveLoadingSubject$ = new Subject();
        this.leaveLoadingSubject$.next(false);
        this.leaveLoading$ = this.leaveLoadingSubject$.asObservable();
        this.leaveErrorSubject$ = new Subject();
        this.leaveErrorSubject$.next("");
        this.leaveError$ = this.leaveErrorSubject$.asObservable();
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        const league$ = this.store.select(getLeague(this.leagueId));
        this.leagueInProgress$ = league$.pipe(filter(entryAvailable), distinct(league => isInProgress(league.entry)));
        this.leagueKickBanDays$ = league$.pipe(filter(entryAvailable), distinct(league => league.entry.kickBanDays));
        this.loading$ = league$.pipe(distinct(league => league.loading));
        this.hasDataFetchError$ = league$.pipe(distinct(league => Boolean(league.error)));
    }
    leaveLeague() {
        this.leaveErrorSubject$.next("");
        this.leaveLoadingSubject$.next(true);
        this.contestantResource
            .signOffFromLeague(this.leagueId, this.contestantId)
            .toPromise()
            .catch((error) => {
            this.leaveLoadingSubject$.next(false);
            this.leaveErrorSubject$.next(this.getErrorTranslation(error && error.data && error.data.error));
            return Promise.reject(error);
        })
            .then(() => {
            this.leaveLoadingSubject$.next(false);
            this.store.dispatch(new LeaveLeagueAction(this.leagueId, this.contestantId));
            this.cancel.emit(true);
        });
    }
    /**
     * Map API errors to translations.
     */
    getErrorTranslation(error) {
        const errors = {
            too_late: "leave-league:error-too-late",
            no_signoff_allowed_for_leaguetype: "leave-league:error-not-allowed-for-league-type",
            no_signoff_allowed: "leave-league:error-signoff-disabled",
            must_be_manager: "leave-league:error-invalid-permissions",
        };
        const errorKey = errors[error] || "commons:error-unknown";
        return this.translate.translate(errorKey, {});
    }
}
LeaveLeagueComponent.ɵfac = function LeaveLeagueComponent_Factory(t) { return new (t || LeaveLeagueComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject(i3.ContestantResource)); };
LeaveLeagueComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LeaveLeagueComponent, selectors: [["leave-league"]], inputs: { leagueId: "leagueId", contestantId: "contestantId" }, outputs: { cancel: "cancel" }, decls: 6, vars: 9, consts: [[3, "destructive", "error", "loading", "checkbox", "button", "confirm", "cancel", 4, "ngIf"], [4, "ngIf"], [3, "destructive", "error", "loading", "checkbox", "button", "confirm", "cancel"]], template: function LeaveLeagueComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LeaveLeagueComponent_confirm_action_0_Template, 10, 29, "confirm-action", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, LeaveLeagueComponent_loading_spinner_2_Template, 1, 0, "loading-spinner", 1);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵtemplate(4, LeaveLeagueComponent_inline_error_4_Template, 3, 3, "inline-error", 1);
        i0.ɵɵpipe(5, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(1, 3, ctx.loading$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 5, ctx.loading$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 7, ctx.hasDataFetchError$));
    } }, directives: [i2$1.NgIf, ConfirmActionComponent, i2.LoadingSpinnerComponent, i2.InlineErrorComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeaveLeagueComponent, [{
        type: Component,
        args: [{
                selector: "leave-league",
                templateUrl: "./leave-league.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i1.TranslateService }, { type: i3.ContestantResource }]; }, { leagueId: [{
            type: Input
        }], contestantId: [{
            type: Input
        }], cancel: [{
            type: Output
        }] }); })();

class LeaveLeagueModule {
}
LeaveLeagueModule.ɵfac = function LeaveLeagueModule_Factory(t) { return new (t || LeaveLeagueModule)(); };
LeaveLeagueModule.ɵmod = i0.ɵɵdefineNgModule({ type: LeaveLeagueModule });
LeaveLeagueModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[TranslationModule, FormsModule, CommonModule, CommonsLoadingModule, CommonsErrorModule, CommonsFormModule, ComponentsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LeaveLeagueModule, { declarations: [LeaveLeagueComponent], imports: [TranslationModule, FormsModule, CommonModule, CommonsLoadingModule, CommonsErrorModule, CommonsFormModule, ComponentsModule], exports: [LeaveLeagueComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeaveLeagueModule, [{
        type: NgModule,
        args: [{
                imports: [TranslationModule, FormsModule, CommonModule, CommonsLoadingModule, CommonsErrorModule, CommonsFormModule, ComponentsModule],
                exports: [LeaveLeagueComponent],
                declarations: [LeaveLeagueComponent],
            }]
    }], null, null); })();

const leaveLeagueTexts = {
    "leave-league:warning": `Are you sure you wish to leave this cup? {
        inProgress, select, 1{You will forfeit any open and future matches} other{}
    }`,
    "leave-league:confirm": `I wish to leave {
        inProgress, select, 1{and accept that current and future matches may be forfeit} other{}
    }`,
    "leave-league:leave": "Leave",
    "leave-league:error-too-late": "Cannot leave finished league",
    "leave-league:error-not-allowed-for-league-type": "Signoff not allowed for league type",
    "leave-league:error-invalid-permissions": "You do not have the permissions to signoff",
    "leave-league:error-signoff-disabled": "Signoff is disabled on this tournament",
};

const signupContestantTexts = {
    "signup-contestant:description": "You're signing up for this tournament:",
    "signup-contestant:confirm-rules": "I have read and have accepted the {rules} of this tournament.",
    "signup-contestant:league-rules": "rules",
    "signup-contestant:league-rules-title": "{leagueName}'s rules page",
};

class RulesLinkService {
    constructor(translate) {
        this.translate = translate;
    }
    getRulesLink(league, content) {
        const url = `${league.uri}rules`;
        const title = this.translate.translate("signup-contestant:league-rules-title", {
            leagueName: league.name.full,
        });
        return `<a href="${url}" title="${title}">${content}</a>`;
    }
}
RulesLinkService.ɵfac = function RulesLinkService_Factory(t) { return new (t || RulesLinkService)(i0.ɵɵinject(i1.TranslateService)); };
RulesLinkService.ɵprov = i0.ɵɵdefineInjectable({ token: RulesLinkService, factory: RulesLinkService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RulesLinkService, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }]; }, null); })();

var SignupAction;
(function (SignupAction) {
    SignupAction[SignupAction["SIGNUP"] = 0] = "SIGNUP";
    SignupAction[SignupAction["CHECKIN"] = 1] = "CHECKIN";
    SignupAction[SignupAction["SIGNUP_CHECKIN"] = 2] = "SIGNUP_CHECKIN";
})(SignupAction || (SignupAction = {}));
class SignupService {
    constructor(translate, errors, rosterResource, contestantResource) {
        this.translate = translate;
        this.errors = errors;
        this.rosterResource = rosterResource;
        this.contestantResource = contestantResource;
    }
    /**
     * Signs a contestant up
     * And if league is roster league, it also adds the player to the roster
     *
     * @param league
     * @param user
     * @param contestantId
     */
    signUpContestant(league, contestantId, rosterMembers) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contestantResource
                .signUpToLeague(league.id, contestantId)
                .toPromise()
                .then(() => {
                if (!isRosterEnabled(league)) {
                    return;
                }
                return Promise.all(rosterMembers.map(memberId => {
                    return this.rosterResource.addPlayer(league.id, contestantId, memberId).toPromise();
                }));
            });
        });
    }
    /**
     * Checks a contestant in
     *
     * @param league
     * @param user
     * @param contestantId
     */
    checkInContestant(league, contestantId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.contestantResource.checkInToLeague(league.id, contestantId).toPromise();
        });
    }
    /**
     * Decides what action needs to be executed by the dialog depending on states
     *
     * @param league
     * @param contestant
     */
    getSignupAction(league, contestant) {
        if (league.state === "lateSignUp") {
            if (contestant) {
                // no need to signup if already signed up
                return SignupAction.CHECKIN;
            }
            return SignupAction.SIGNUP_CHECKIN;
        }
        return SignupAction.SIGNUP;
    }
    signUp(league, contestantId, contestant, rosterMembers) {
        return __awaiter(this, void 0, void 0, function* () {
            let promise;
            const action = this.getSignupAction(league, contestant);
            switch (action) {
                case SignupAction.SIGNUP:
                    promise = this.signUpContestant(league, contestantId, rosterMembers);
                    break;
                case SignupAction.CHECKIN:
                    promise = this.checkInContestant(league, contestantId);
                    break;
                case SignupAction.SIGNUP_CHECKIN:
                    promise = this.signUpContestant(league, contestantId, rosterMembers).then(() => this.checkInContestant(league, contestantId));
                    break;
            }
            return promise;
        });
    }
}
SignupService.ɵfac = function SignupService_Factory(t) { return new (t || SignupService)(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(SignupFlowErrors), i0.ɵɵinject(i3.RosterResource), i0.ɵɵinject(i3.ContestantResource)); };
SignupService.ɵprov = i0.ɵɵdefineInjectable({ token: SignupService, factory: SignupService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignupService, [{
        type: Injectable
    }], function () { return [{ type: i1.TranslateService }, { type: SignupFlowErrors }, { type: i3.RosterResource }, { type: i3.ContestantResource }]; }, null); })();

const _c0$1 = function (a0) { return { rules: a0 }; };
function SignupContestantComponent_confirm_action_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "confirm-action", 2);
    i0.ɵɵlistener("confirm", function SignupContestantComponent_confirm_action_0_Template_confirm_action_confirm_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.signUp(); })("cancel", function SignupContestantComponent_confirm_action_0_Template_confirm_action_cancel_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.cancel.emit($event); });
    i0.ɵɵpipe(1, "async");
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementStart(6, "div", 3);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 4);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    let tmp_7_0 = null;
    i0.ɵɵproperty("destructive", false)("error", i0.ɵɵpipeBind1(1, 8, ctx_r0.signUpError$))("loading", i0.ɵɵpipeBind1(2, 10, ctx_r0.signUpLoading$))("checkbox", i0.ɵɵpipeBind2(3, 12, "signup-contestant:confirm-rules", i0.ɵɵpureFunction1(23, _c0$1, i0.ɵɵpipeBind1(4, 15, ctx_r0.rulesLink$))))("customCheckbox", ctx_r0.customCheckbox)("button", i0.ɵɵpipeBind1(5, 17, "commons:signup"));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 19, "signup-contestant:description"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (tmp_7_0 = i0.ɵɵpipeBind1(11, 21, ctx_r0.league$)) == null ? null : tmp_7_0.entry.name.full, " ");
} }
function SignupContestantComponent_loading_spinner_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner");
} }
function SignupContestantComponent_inline_error_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"), "\n");
} }
class SignupContestantComponent {
    constructor(store, translate, errors, rulesLink, signupService) {
        this.store = store;
        this.translate = translate;
        this.errors = errors;
        this.rulesLink = rulesLink;
        this.signupService = signupService;
        this.cancel = new EventEmitter();
        this.customCheckboxWhitelist = [];
        this.signUpLoadingSubject$ = new Subject();
        this.signUpLoadingSubject$.next(false);
        this.signUpLoading$ = this.signUpLoadingSubject$.asObservable();
        this.signUpErrorSubject$ = new Subject();
        this.signUpErrorSubject$.next("");
        this.signUpError$ = this.signUpErrorSubject$.asObservable();
    }
    ngOnInit() {
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.store.dispatch(new LoadRosterAction(this.leagueId, this.contestantId));
        this.league$ = this.store.select(getLeague(this.leagueId)).pipe(filter(exists));
        this.user$ = this.store.select(getUser).pipe(filter(exists));
        this.contestant$ = this.user$.pipe(filter(entryAvailable), switchMap(user => {
            return this.store.select(getContestant(this.leagueId, +user.entry.id, this.contestantId));
        }));
        if (typeof Drupal !== "undefined") {
            const prefix = Drupal.settings.legacy_content.prefix.replace("/", "");
            if (this.customCheckboxWhitelist.indexOf(prefix) >= 0) {
                this.customCheckbox = prefix;
            }
        }
        this.isLoading$ = this.getIsLoading();
        this.hasError$ = this.getHasError();
    }
    /**
     * If any API route is still loading without prior result, this will return true
     */
    getIsLoading() {
        return combineLatest(this.league$, this.user$).pipe(map$1(data => find(data, entry => !entry.entry && entry.loading)), map$1(Boolean), distinctUntilChanged());
    }
    /**
     * If any API route returns an error, this will return true
     */
    getHasError() {
        return combineLatest(this.league$, this.user$).pipe(map$1(data => find(data, entry => entry.error)), map$1(Boolean), distinctUntilChanged());
    }
    /**
     * Returns the rules html link for the league.
     * Extracted in to a services so that mobile can override it.
     */
    get rulesLink$() {
        return this.league$.pipe(filter(entryAvailable), map$1(league => {
            return this.rulesLink.getRulesLink(league.entry, this.translate.translate("signup-contestant:league-rules", {}));
        }));
    }
    /**
     * Get"s the translated error text for an error key returned by the API
     *
     * @param errorKey
     */
    getErrorText(errorKey) {
        return this.errors.getErrorForKey(errorKey);
    }
    /**
     * Tries to sign up a contestant.
     * Will reload data on success AND error
     */
    signUp() {
        this.signUpErrorSubject$.next("");
        this.signUpLoadingSubject$.next(true);
        combineLatest(this.league$.pipe(filter(entryAvailable)), this.user$.pipe(filter(entryAvailable)), this.contestant$, this.store.select(getRosterMembers(this.leagueId, this.contestantId)))
            .pipe(first())
            .subscribe(([leagueEntry, userEntry, contestant, rosterMembers]) => {
            const league = leagueEntry.entry;
            const user = userEntry.entry;
            this.signupService
                .signUp(league, this.contestantId, contestant, rosterMembers)
                .then(() => {
                if (isRosterEnabled(league)) {
                    this.store.dispatch(new LoadRosterAction$1(this.leagueId, this.contestantId, true));
                }
                this.cancel.emit(true);
            })
                .catch((error) => {
                const errorText = error ? error.message : "";
                this.signUpErrorSubject$.next(this.getErrorText(errorText));
                return null;
            })
                .then(() => {
                this.signUpLoadingSubject$.next(false);
                this.store.dispatch(new LoadContestantsAction(league.id, +user.id));
            });
        });
    }
}
SignupContestantComponent.ɵfac = function SignupContestantComponent_Factory(t) { return new (t || SignupContestantComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(i1.TranslateService), i0.ɵɵdirectiveInject(SignupFlowErrors), i0.ɵɵdirectiveInject(RulesLinkService), i0.ɵɵdirectiveInject(SignupService)); };
SignupContestantComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SignupContestantComponent, selectors: [["signup-contestant"]], inputs: { leagueId: "leagueId", contestantId: "contestantId" }, outputs: { cancel: "cancel" }, decls: 6, vars: 9, consts: [["class", "c-signup-contestant", 3, "destructive", "error", "loading", "checkbox", "customCheckbox", "button", "confirm", "cancel", 4, "ngIf"], [4, "ngIf"], [1, "c-signup-contestant", 3, "destructive", "error", "loading", "checkbox", "customCheckbox", "button", "confirm", "cancel"], [1, "c-signup-contestant__header"], [1, "c-signup-contestant__tournament"]], template: function SignupContestantComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SignupContestantComponent_confirm_action_0_Template, 12, 25, "confirm-action", 0);
        i0.ɵɵpipe(1, "async");
        i0.ɵɵtemplate(2, SignupContestantComponent_loading_spinner_2_Template, 1, 0, "loading-spinner", 1);
        i0.ɵɵpipe(3, "async");
        i0.ɵɵtemplate(4, SignupContestantComponent_inline_error_4_Template, 3, 3, "inline-error", 1);
        i0.ɵɵpipe(5, "async");
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(1, 3, ctx.isLoading$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 5, ctx.isLoading$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 7, ctx.hasError$));
    } }, directives: [i2$1.NgIf, ConfirmActionComponent, i2.LoadingSpinnerComponent, i2.InlineErrorComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignupContestantComponent, [{
        type: Component,
        args: [{
                selector: "signup-contestant",
                templateUrl: "./signup-contestant.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }, { type: i1.TranslateService }, { type: SignupFlowErrors }, { type: RulesLinkService }, { type: SignupService }]; }, { leagueId: [{
            type: Input
        }], contestantId: [{
            type: Input
        }], cancel: [{
            type: Output
        }] }); })();

class SignupContestantModule {
}
SignupContestantModule.ɵfac = function SignupContestantModule_Factory(t) { return new (t || SignupContestantModule)(); };
SignupContestantModule.ɵmod = i0.ɵɵdefineNgModule({ type: SignupContestantModule });
SignupContestantModule.ɵinj = i0.ɵɵdefineInjector({ providers: [RulesLinkService, SignupService], imports: [[
            TranslationModule,
            FormsModule,
            CommonModule,
            CommonsLoadingModule,
            CommonsErrorModule,
            CommonsFormModule,
            ComponentsModule,
            SignupFlowModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SignupContestantModule, { declarations: [SignupContestantComponent], imports: [TranslationModule,
        FormsModule,
        CommonModule,
        CommonsLoadingModule,
        CommonsErrorModule,
        CommonsFormModule,
        ComponentsModule,
        SignupFlowModule], exports: [SignupContestantComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SignupContestantModule, [{
        type: NgModule,
        args: [{
                imports: [
                    TranslationModule,
                    FormsModule,
                    CommonModule,
                    CommonsLoadingModule,
                    CommonsErrorModule,
                    CommonsFormModule,
                    ComponentsModule,
                    SignupFlowModule,
                ],
                providers: [RulesLinkService, SignupService],
                exports: [SignupContestantComponent],
                declarations: [SignupContestantComponent],
            }]
    }], null, null); })();

class StateConfiguration {
    get setup() {
        return {
            logged_out: [MainHeaderComponent, SetupComponent, LoginComponent],
            none: [MainHeaderComponent, SetupComponent],
            signed_up: [PlayerReadyComponent, MainHeaderReadyComponent, ContestantAccountComponent, SetupComponent],
            checked_in: [PlayerReadyComponent, MainHeaderReadyComponent, ContestantAccountComponent, SetupComponent],
            sign_up_pending: [PlayerReadyComponent, MainHeaderReadyComponent, ContestantAccountComponent, SignupLeaguePendingComponent],
            playing: [PlayerReadyComponent, MainHeaderReadyComponent, ContestantAccountComponent],
            finished: [MainHeaderComponent],
        };
    }
    get preSignUp() {
        return {
            logged_out: [PlayerReadyComponent, MainHeaderComponent, LoginComponent],
            none: [PlayerReadyComponent, MainHeaderComponent, ContestantAccountComponent, SignupLeagueComponent, ChangeTeamSignupComponent],
            signed_up: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                VendorTeamNoticeComponent,
                ContestantAccountComponent,
                CheckinLeagueComponent,
                ChangeTeamSignupComponent,
            ],
            checked_in: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                VendorTeamNoticeComponent,
                ContestantAccountComponent,
                CheckinLeagueCheckedInComponent,
                ChangeTeamSignupComponent,
            ],
            sign_up_pending: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                VendorTeamNoticeComponent,
                ContestantAccountComponent,
            ],
            playing: [PlayerReadyComponent, MainHeaderReadyComponent, VendorTeamNoticeComponent, ContestantAccountComponent],
            finished: [MainHeaderComponent],
        };
    }
    get signUp() {
        return {
            logged_out: [PlayerReadyComponent, MainHeaderComponent, LoginComponent],
            none: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                ContestantAccountComponent,
                SignupLeagueComponent,
                ChangeTeamSignupComponent,
            ],
            signed_up: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                VendorTeamNoticeComponent,
                ContestantAccountComponent,
                CheckinLeagueComponent,
                ChangeTeamSignupComponent,
            ],
            checked_in: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                VendorTeamNoticeComponent,
                ContestantAccountComponent,
                CheckinLeagueCheckedInComponent,
                ChangeTeamSignupComponent,
            ],
            sign_up_pending: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                VendorTeamNoticeComponent,
                ContestantAccountComponent,
                SignupLeaguePendingComponent,
                ChangeTeamSignupComponent,
            ],
            playing: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                VendorTeamNoticeComponent,
                ContestantAccountComponent,
                ChangeTeamSignupComponent,
            ],
            finished: [MainHeaderComponent],
        };
    }
    get lateSignUp() {
        return {
            logged_out: [PlayerReadyComponent, MainHeaderComponent, LoginComponent],
            none: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                ContestantAccountComponent,
                LateSignupLeagueComponent,
                ChangeTeamSignupComponent,
            ],
            signed_up: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                VendorTeamNoticeComponent,
                ContestantAccountComponent,
                LateSignupLeagueCheckInComponent,
                ChangeTeamSignupComponent,
            ],
            checked_in: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                VendorTeamNoticeComponent,
                ContestantAccountComponent,
                CheckinLeagueCheckedInComponent,
                ChangeTeamSignupComponent,
            ],
            sign_up_pending: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                VendorTeamNoticeComponent,
                ContestantAccountComponent,
                SignupLeaguePendingComponent,
                ChangeTeamSignupComponent,
            ],
            playing: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                VendorTeamNoticeComponent,
                ContestantAccountComponent,
                ChangeTeamSignupComponent,
            ],
            finished: [MainHeaderComponent],
        };
    }
    get postSignUp() {
        return {
            logged_out: [MainHeaderComponent, LoginComponent],
            none: [PlayerReadyPickupComponent, MainHeaderComponent, InProgressComponent],
            signed_up: [PlayerReadyPickupComponent, MainHeaderReadyComponent, InProgressComponent],
            checked_in: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                ContestantAccountComponent,
                CheckinLeagueCheckedInComponent,
                ChangeTeamSignupComponent,
            ],
            sign_up_pending: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                ContestantAccountComponent,
                SignupLeaguePendingComponent,
                ChangeTeamSignupComponent,
            ],
            playing: [PlayerReadyComponent, MainHeaderReadyComponent, ContestantAccountComponent, ChangeTeamSignupComponent],
            finished: [MainHeaderComponent],
        };
    }
    get checkIn() {
        return {
            logged_out: [PlayerReadyComponent, MainHeaderComponent, LoginComponent],
            none: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                ContestantAccountComponent,
                LateSignupLeagueStatusComponent,
                ChangeTeamSignupComponent,
            ],
            signed_up: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                ContestantAccountComponent,
                CheckinLeagueComponent,
                ChangeTeamSignupComponent,
            ],
            checked_in: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                ContestantAccountComponent,
                CheckinLeagueCheckedInComponent,
                ChangeTeamSignupComponent,
            ],
            sign_up_pending: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                ContestantAccountComponent,
                SignupLeaguePendingComponent,
                ChangeTeamSignupComponent,
            ],
            playing: [PlayerReadyComponent, MainHeaderReadyComponent, ContestantAccountComponent, ChangeTeamSignupComponent],
            finished: [MainHeaderComponent],
        };
    }
    get inProgress() {
        return {
            logged_out: [MainHeaderComponent, InProgressComponent],
            none: [PlayerReadyPickupComponent, MainHeaderComponent, InProgressComponent],
            signed_up: [PlayerReadyPickupComponent, MainHeaderReadyComponent, InProgressComponent],
            checked_in: [PlayerReadyComponent, MainHeaderReadyComponent, ContestantAccountComponent, InProgressComponent],
            sign_up_pending: [PlayerReadyPickupComponent, MainHeaderReadyComponent, InProgressComponent],
            playing: [PlayerReadyComponent, MainHeaderReadyComponent, ContestantAccountComponent],
            finished: [MainHeaderComponent],
        };
    }
    get finished() {
        return {
            logged_out: [MainHeaderComponent],
            none: [MainHeaderComponent],
            signed_up: [MainHeaderComponent],
            checked_in: [MainHeaderComponent],
            sign_up_pending: [MainHeaderComponent],
            playing: [MainHeaderComponent],
            finished: [MainHeaderComponent],
        };
    }
}
StateConfiguration.ɵfac = function StateConfiguration_Factory(t) { return new (t || StateConfiguration)(); };
StateConfiguration.ɵprov = i0.ɵɵdefineInjectable({ token: StateConfiguration, factory: StateConfiguration.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StateConfiguration, [{
        type: Injectable
    }], null, null); })();
class CupStateConfiguration extends StateConfiguration {
}
CupStateConfiguration.ɵfac = function CupStateConfiguration_Factory(t) { return ɵCupStateConfiguration_BaseFactory(t || CupStateConfiguration); };
CupStateConfiguration.ɵprov = i0.ɵɵdefineInjectable({ token: CupStateConfiguration, factory: CupStateConfiguration.ɵfac });
const ɵCupStateConfiguration_BaseFactory = /*@__PURE__*/ i0.ɵɵgetInheritedFactory(CupStateConfiguration);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CupStateConfiguration, [{
        type: Injectable
    }], null, null); })();
class SwissStateConfiguration extends StateConfiguration {
}
SwissStateConfiguration.ɵfac = function SwissStateConfiguration_Factory(t) { return ɵSwissStateConfiguration_BaseFactory(t || SwissStateConfiguration); };
SwissStateConfiguration.ɵprov = i0.ɵɵdefineInjectable({ token: SwissStateConfiguration, factory: SwissStateConfiguration.ɵfac });
const ɵSwissStateConfiguration_BaseFactory = /*@__PURE__*/ i0.ɵɵgetInheritedFactory(SwissStateConfiguration);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SwissStateConfiguration, [{
        type: Injectable
    }], null, null); })();
class PremiershipStateConfiguration extends StateConfiguration {
}
PremiershipStateConfiguration.ɵfac = function PremiershipStateConfiguration_Factory(t) { return ɵPremiershipStateConfiguration_BaseFactory(t || PremiershipStateConfiguration); };
PremiershipStateConfiguration.ɵprov = i0.ɵɵdefineInjectable({ token: PremiershipStateConfiguration, factory: PremiershipStateConfiguration.ɵfac });
const ɵPremiershipStateConfiguration_BaseFactory = /*@__PURE__*/ i0.ɵɵgetInheritedFactory(PremiershipStateConfiguration);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PremiershipStateConfiguration, [{
        type: Injectable
    }], null, null); })();
class FFAStateConfiguration extends StateConfiguration {
}
FFAStateConfiguration.ɵfac = function FFAStateConfiguration_Factory(t) { return ɵFFAStateConfiguration_BaseFactory(t || FFAStateConfiguration); };
FFAStateConfiguration.ɵprov = i0.ɵɵdefineInjectable({ token: FFAStateConfiguration, factory: FFAStateConfiguration.ɵfac });
const ɵFFAStateConfiguration_BaseFactory = /*@__PURE__*/ i0.ɵɵgetInheritedFactory(FFAStateConfiguration);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FFAStateConfiguration, [{
        type: Injectable
    }], null, null); })();
class AseriesStateConfiguration extends StateConfiguration {
    constructor(baseConfig) {
        super();
        this.baseConfig = baseConfig;
    }
    get inProgress() {
        return Object.assign(Object.assign({}, this.baseConfig.inProgress), { logged_out: [PlayerReadyComponent, MainHeaderComponent, LoginComponent], none: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                ContestantAccountComponent,
                SignupLeagueComponent,
                ChangeTeamSignupComponent,
            ], sign_up_pending: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                VendorTeamNoticeComponent,
                ContestantAccountComponent,
                SignupLeaguePendingComponent,
                ChangeTeamSignupComponent,
            ] });
    }
}
AseriesStateConfiguration.ɵfac = function AseriesStateConfiguration_Factory(t) { return new (t || AseriesStateConfiguration)(i0.ɵɵinject(StateConfiguration)); };
AseriesStateConfiguration.ɵprov = i0.ɵɵdefineInjectable({ token: AseriesStateConfiguration, factory: AseriesStateConfiguration.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AseriesStateConfiguration, [{
        type: Injectable
    }], function () { return [{ type: StateConfiguration }]; }, null); })();
class LadderStateConfiguration extends StateConfiguration {
    constructor(baseConfig) {
        super();
        this.baseConfig = baseConfig;
    }
    get inProgress() {
        return Object.assign(Object.assign({}, this.baseConfig.inProgress), { logged_out: [PlayerReadyComponent, MainHeaderComponent, LoginComponent], none: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                ContestantAccountComponent,
                SignupLeagueComponent,
                ChangeTeamSignupComponent,
            ], sign_up_pending: [
                PlayerReadyComponent,
                MainHeaderReadyComponent,
                VendorTeamNoticeComponent,
                ContestantAccountComponent,
                SignupLeaguePendingComponent,
                ChangeTeamSignupComponent,
            ] });
    }
}
LadderStateConfiguration.ɵfac = function LadderStateConfiguration_Factory(t) { return new (t || LadderStateConfiguration)(i0.ɵɵinject(StateConfiguration)); };
LadderStateConfiguration.ɵprov = i0.ɵɵdefineInjectable({ token: LadderStateConfiguration, factory: LadderStateConfiguration.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LadderStateConfiguration, [{
        type: Injectable
    }], function () { return [{ type: StateConfiguration }]; }, null); })();

const _c0 = ["container"];
function LeagueWidgetComponent_loading_spinner_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "loading-spinner");
} }
function LeagueWidgetComponent_inline_error_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "inline-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "commons:data-fetch-error"), " ");
} }
class LeagueWidgetComponent {
    constructor(store, cupConfig, swissConfig, premiershipConfig, ladderConfig, aseriesConfig, ffaConfig, components, changeDetection) {
        this.store = store;
        this.cupConfig = cupConfig;
        this.swissConfig = swissConfig;
        this.premiershipConfig = premiershipConfig;
        this.ladderConfig = ladderConfig;
        this.aseriesConfig = aseriesConfig;
        this.ffaConfig = ffaConfig;
        this.components = components;
        this.changeDetection = changeDetection;
        this.configs = {
            cup: this.cupConfig,
            swiss: this.swissConfig,
            premiership: this.premiershipConfig,
            ladder: this.ladderConfig,
            ffa: this.ffaConfig,
            "a-series": this.aseriesConfig,
        };
    }
    getConfig(leagueType) {
        return this.configs[leagueType] ? this.configs[leagueType] : this.configs["cup"];
    }
    isLoading() {
        return combineLatest([this.league$, this.user$]).pipe(map$1((data) => {
            return data.filter(entry => entry.loading && !entry.entry).length !== 0;
        }), switchMap(isLoading => {
            return this.contestants$.pipe(map$1(contestants => {
                if (!contestants) {
                    return isLoading;
                }
                return contestants.loading && !contestants.entry;
            }));
        }), distinctUntilChanged());
    }
    hasError() {
        return combineLatest([this.league$, this.contestants$, this.user$]).pipe(map$1((data) => data.filter(entry => entry && entry.error).length !== 0), distinctUntilChanged());
    }
    ngOnInit() {
        this.user$ = this.store.select(getUser).pipe();
        this.store.dispatch(new LoadLeagueOnceAction(this.leagueId));
        this.league$ = this.store.select(getLeague(this.leagueId)).pipe(filter(exists));
        this.contestants$ = this.user$.pipe(switchMap(user => {
            if (!user.entry) {
                return [null];
            }
            this.store.dispatch(new LoadContestantsOnceAction(this.leagueId, +user.entry.id));
            return this.store.select(getContestants(this.leagueId, +user.entry.id));
        }));
        this.contestant$ = combineLatest(this.league$, this.user$, this.contestants$).pipe(filter(([league, user]) => Boolean(!league.error && league.entry) && Boolean(!user.error)), switchMap(([league, user, contestants]) => this.findContestant(league, user, contestants)));
        this.getSelectedTeamId$ = this.league$.pipe(filter(entryAvailable), switchMap(league => this.store.pipe(getSelectedContestant(league.entry.id, "team"))), filter(contestantId => contestantId !== undefined), distinctUntilChanged());
        this.isLoading$ = this.isLoading();
        this.hasError$ = this.hasError();
    }
    /**
     * Clean up the observable
     */
    ngOnDestroy() {
        this.subscriber.unsubscribe();
    }
    ngAfterViewInit() {
        this.subscriber = combineLatest(this.league$, this.user$, this.contestant$)
            .pipe(tap(() => this.container.clear()), filter(([league, user]) => Boolean(!league.error && league.entry) && Boolean(!user.error && !user.loading)))
            .subscribe(([league, user, contestant]) => {
            this.loadSelectedContestant(league, contestant, user);
            this.renderComponents(league, contestant, user);
            this.changeDetection.detectChanges();
        });
    }
    /**
     * Dispatch the actions needed to load the correct contestant
     *
     * @param league
     * @param contestant
     * @param user
     */
    loadSelectedContestant(league, contestant, user) {
        if (isPlayer(league.entry) && user.entry) {
            this.store.dispatch(new SelectContestantAction(league.entry.id, +user.entry.id, "player"));
        }
        else if (contestant) {
            this.store.dispatch(new SelectContestantAction(league.entry.id, +contestant.id, "team"));
        }
    }
    /**
     * Renders the correct components depending on league state and contestant state
     *
     * @param league
     * @param contestant
     * @param user
     */
    renderComponents(league, contestant, user) {
        let contestantState = "logged_out";
        if (user.entry) {
            contestantState = contestant ? contestant.state : "none";
        }
        const leagueState = league.entry.state;
        const components = this.getConfig(league.entry.type)[leagueState][contestantState];
        components.forEach(component => {
            const factory = this.components.resolveComponentFactory(component);
            const ref = this.container.createComponent(factory);
            const cmp = ref.instance;
            cmp.leagueId = league.entry.id;
            cmp.userId = user.entry ? +user.entry.id : null;
            ref.changeDetectorRef.detectChanges(); // related to this issue https://github.com/NativeScript/nativescript-angular/issues/1014
        });
    }
    /**
     * Finds the contestant to show in all contestants
     *
     * @param league
     * @param user
     * @param contestants
     */
    findContestant(league, user, contestants) {
        if (!user.entry || !league.entry) {
            return of(null);
        }
        if (isPlayer(league.entry)) {
            return this.store.select(getContestant(league.entry.id, +user.entry.id, +user.entry.id));
        }
        this.store.dispatch(new LoadSelectedContestantAction(league.entry.id));
        return this.getSelectedTeamId$.pipe(switchMap(contestantId => {
            if (!contestants || contestants.error || !contestants.entry) {
                return [null];
            }
            const sortedContestant = sortBy(contestants.entry, contestantInfo => {
                return -contestantInfo.id;
            }).pop();
            if (!sortedContestant) {
                return [null];
            }
            if (!contestantId) {
                contestantId = +sortedContestant.id;
            }
            return this.store.select(getContestant(league.entry.id, +user.entry.id, contestantId));
        }));
    }
}
LeagueWidgetComponent.ɵfac = function LeagueWidgetComponent_Factory(t) { return new (t || LeagueWidgetComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(CupStateConfiguration), i0.ɵɵdirectiveInject(SwissStateConfiguration), i0.ɵɵdirectiveInject(PremiershipStateConfiguration), i0.ɵɵdirectiveInject(LadderStateConfiguration), i0.ɵɵdirectiveInject(AseriesStateConfiguration), i0.ɵɵdirectiveInject(FFAStateConfiguration), i0.ɵɵdirectiveInject(i0.ComponentFactoryResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
LeagueWidgetComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LeagueWidgetComponent, selectors: [["league-widget"]], viewQuery: function LeagueWidgetComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1, ViewContainerRef);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
    } }, inputs: { leagueId: ["leagueid", "leagueId"] }, decls: 7, vars: 6, consts: [[1, "c-league-widget"], ["container", ""], [4, "ngIf"]], template: function LeagueWidgetComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "article", 0);
        i0.ɵɵelementContainer(1, null, 1);
        i0.ɵɵtemplate(3, LeagueWidgetComponent_loading_spinner_3_Template, 1, 0, "loading-spinner", 2);
        i0.ɵɵpipe(4, "async");
        i0.ɵɵtemplate(5, LeagueWidgetComponent_inline_error_5_Template, 3, 3, "inline-error", 2);
        i0.ɵɵpipe(6, "async");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 2, ctx.isLoading$));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(6, 4, ctx.hasError$));
    } }, directives: [i2$1.NgIf, i2.LoadingSpinnerComponent, i2.InlineErrorComponent], pipes: [i2$1.AsyncPipe, i1.TranslatePipe], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeagueWidgetComponent, [{
        type: Component,
        args: [{
                selector: "league-widget",
                templateUrl: "./league-widget.component.html",
                changeDetection: ChangeDetectionStrategy.OnPush,
            }]
    }], function () { return [{ type: i1$1.Store }, { type: CupStateConfiguration }, { type: SwissStateConfiguration }, { type: PremiershipStateConfiguration }, { type: LadderStateConfiguration }, { type: AseriesStateConfiguration }, { type: FFAStateConfiguration }, { type: i0.ComponentFactoryResolver }, { type: i0.ChangeDetectorRef }]; }, { leagueId: [{
            type: Input,
            args: ["leagueid"]
        }], container: [{
            type: ViewChild,
            args: ["container", { read: ViewContainerRef }]
        }] }); })();

const reducers = {
    preSelectRoster: preSelectionReducer,
    selectedContestant: selectContestantReducer,
};

class LeagueWidgetModule {
}
LeagueWidgetModule.ɵfac = function LeagueWidgetModule_Factory(t) { return new (t || LeagueWidgetModule)(); };
LeagueWidgetModule.ɵmod = i0.ɵɵdefineNgModule({ type: LeagueWidgetModule });
LeagueWidgetModule.ɵinj = i0.ɵɵdefineInjector({ providers: [
        CupStateConfiguration,
        SwissStateConfiguration,
        PremiershipStateConfiguration,
        AseriesStateConfiguration,
        FFAStateConfiguration,
        LadderStateConfiguration,
        StateConfiguration,
        EligiblityService,
        GameAccountBuilder,
    ], imports: [[
            CommonModule,
            CommonsErrorModule,
            CommonsLoadingModule,
            CommonsCountryNameModule,
            CommonsRestrictionsModule,
            TranslationModule,
            RequirementModule,
            ManageRosterModule,
            LeaveLeagueModule,
            LeaveRosterModule,
            SignupContestantModule,
            ChooseTeamModule,
            ComponentsModule,
            PlayerReadyModule.withComponents(),
            LoginModule.withComponents(),
            SignupFlowModule.withComponents(),
            ContestantAccountModule.withComponents(),
            MainHeaderModule.withComponents(),
            StateModule,
            StoreModule.forFeature("leagueWidget", reducers),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LeagueWidgetModule, { declarations: [LeagueWidgetComponent], imports: [CommonModule,
        CommonsErrorModule,
        CommonsLoadingModule,
        CommonsCountryNameModule,
        CommonsRestrictionsModule,
        TranslationModule,
        RequirementModule,
        ManageRosterModule,
        LeaveLeagueModule,
        LeaveRosterModule,
        SignupContestantModule,
        ChooseTeamModule,
        ComponentsModule, PlayerReadyModule, LoginModule, SignupFlowModule, ContestantAccountModule, MainHeaderModule, StateModule, i1$1.StoreFeatureModule], exports: [LeagueWidgetComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LeagueWidgetModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    CommonsErrorModule,
                    CommonsLoadingModule,
                    CommonsCountryNameModule,
                    CommonsRestrictionsModule,
                    TranslationModule,
                    RequirementModule,
                    ManageRosterModule,
                    LeaveLeagueModule,
                    LeaveRosterModule,
                    SignupContestantModule,
                    ChooseTeamModule,
                    ComponentsModule,
                    PlayerReadyModule.withComponents(),
                    LoginModule.withComponents(),
                    SignupFlowModule.withComponents(),
                    ContestantAccountModule.withComponents(),
                    MainHeaderModule.withComponents(),
                    StateModule,
                    StoreModule.forFeature("leagueWidget", reducers),
                ],
                declarations: [LeagueWidgetComponent],
                exports: [LeagueWidgetComponent],
                providers: [
                    CupStateConfiguration,
                    SwissStateConfiguration,
                    PremiershipStateConfiguration,
                    AseriesStateConfiguration,
                    FFAStateConfiguration,
                    LadderStateConfiguration,
                    StateConfiguration,
                    EligiblityService,
                    GameAccountBuilder,
                ],
            }]
    }], null, null); })();

/*
 * Public API Surface of league-widget
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AgeRequirementFactory, AlternateLeagueRequirementFactory, BrawlStarsProfileRequirementFactory, COCTownHallLevelRequirementFactory, ChangeTeamSignupComponent, CheckinLeagueCheckedInComponent, CheckinLeagueComponent, ChooseTeamComponent, ChooseTeamModule, CityRequirementFactory, ComponentsModule, ConfirmActionComponent, ConfirmRemoveMemberComponent, ContestantAccountComponent, ContestantAccountModule, ContestantListComponent, ContestantReadyAlertComponent, ContestantReadyAlertFactory, ContestantReadyHeaderComponent, ContestantReadyModule, EligiblityService, GameAccountBuilder, GameAccountRequirementFactory, GenderRequirementFactory, InCountryListRequirementFactory, InProgressComponent, IsAdminRequirementFactory, LateSignupLeagueComponent, LateSignupLeagueDisabledComponent, LateSignupLeagueStatusComponent, LeagueWidgetComponent, LeagueWidgetModule, LeaveLeagueComponent, LeaveLeagueModule, LeaveRosterComponent, LeaveRosterModule, LoadRosterAction, LoadRosterCompleteAction, LoginComponent, LoginModule, MainHeaderComponent, MainHeaderModule, MainHeaderReadyComponent, ManageRosterComponent, ManageRosterModule, MemberEligibilityStatusConfig, MinAgeRequirementFactory, PhotoRequirementFactory, PlayerAccountComponent, PlayerReadyComponent, PlayerReadyComponentConfig, PlayerReadyModule, PlayerReadyPickupComponent, PreSelectionActionTypes, PremiumRequirementFactory, RequirementFactory, RequirementGameAccountStepComponent, RequirementModule, RequirementStepComponent, ResetRosterAction, ResidenceNationalityRequirementFactory, RosterEligibilityStatusComponent, RosterEligibilityStatusConfig, RosterPreSelectionEffects, RosterPreselectDialogComponent, RosterSelectDialogComponent, RosterStatusComponent, RosterStatusDialogComponent, RulesLinkService, SC2RegionRequirementFactory, SelectRosterStep, SelectTeamComponent, SelectedTeamCache, SetRosterAction, SetupComponent, SignupContestantComponent, SignupContestantModule, SignupFlowComponent, SignupFlowEffects, SignupFlowModule, SignupFlowTransitionComponent, SignupLeagueComponent, SignupLeagueDisabledComponent, SignupLeaguePendingComponent, SignupService, SwitchContestantComponent, TeamAccountComponent, TeamInviteComponent, MemberEligibilityStatusComponent as TeamMemberEligibilityStatusComponent, TimelineHelper, TrustLevelRequirementFactory, VendorTeamNoticeComponent, chooseTeamTexts, confirmRemoveMemberTexts, contestantAccountTexts, contestantReadyTexts, getAddedMembers, getRemovedMembers, getRosterMemberState, getRosterMembers, getSelectedContestant, leaveLeagueTexts, leaveRosterTexts, loginTexts, mainHeaderTexts, manageRosterTexts, mapStateToPrefix, playerAccountTexts, playerReadyTexts, preSelectionReducer, reducers, requirementTexts, selectContestantReducer, signupContestantTexts, signupFlowTexts, teamAccountTexts, vendorTeamNoticeTexts };
//# sourceMappingURL=play-league-widget.js.map
